

import { TranslationStructure } from '../types';

const walletItems = [
  { name: 'Ricavi Vendita Privata', address: 'EMP6boRHx13HfuQ9HELPQyCEJ4QpxSJ6aRA32aMbGqY' },
  { name: 'CTC Treasury', address: 'DJmTvA7CvJJF1pSqQ1ny2rw7yfGPQQYphYrrrhvGPdRb' },
  { name: 'Founders', address: 'CYABTRyngdzX8JAcZD7zV2tFfaTrSAeZpXY49JkCFvfR' },
  { name: 'Private Sale', address: '5bEEtR3CtFxCaorEDSmuRvQ4nR9D6cnk1AJQZzcnH9eW' },
  { name: '1° Airdrop', address: 'Cswv13bgLCs61d1gpspjs5FhKXwVwdrm2ssrz8kU8w1X' },
  { name: 'Liquidity Pool', address: '4HBJqbaMAXSF238NovanxTTKuuzPGDzVmQdCRxkzEGQN' },
  { name: 'CEX Listing', address: 'HXMjMYQNLLQQCj4qsUNBKZqu7ftIGCyMXAH2z2jTck3s' },
  { name: '2° Airdrop', address: 'ASLN3iNkx4ZdIuPYGodtgvHap2aBHLGjy4JLXgKU16o' },
  { name: '3° Airdrop', address: 'C8nG97B6HsCPpA9v7Enbo4obBV5PznDsuUcPvVFwLXQ8' }
];

const walletItemsEn = [
  { name: 'Private Sale Revenue', address: 'EMP6boRHx13HfuQ9HELPQyCEJ4QpxSJ6aRA32aMbGqY' },
  { name: 'CTC Treasury', address: 'DJmTvA7CvJJF1pSqQ1ny2rw7yfGPQQYphYrrrhvGPdRb' },
  { name: 'Founders', address: 'CYABTRyngdzX8JAcZD7zV2tFfaTrSAeZpXY49JkCFvfR' },
  { name: 'Private Sale', address: '5bEEtR3CtFxCaorEDSmuRvQ4nR9D6cnk1AJQZzcnH9eW' },
  { name: '1st Airdrop', address: 'Cswv13bgLCs61d1gpspjs5FhKXwVwdrm2ssrz8kU8w1X' },
  { name: 'Liquidity Pool', address: '4HBJqbaMAXSF238NovanxTTKuuzPGDzVmQdCRxkzEGQN' },
  { name: 'CEX Listing', address: 'HXMjMYQNLLQQCj4qsUNBKZqu7ftIGCyMXAH2z2jTck3s' },
  { name: '2nd Airdrop', address: 'ASLN3iNkx4ZdIuPYGodtgvHap2aBHLGjy4JLXgKU16o' },
  { name: '3rd Airdrop', address: 'C8nG97B6HsCPpA9v7Enbo4obBV5PznDsuUcPvVFwLXQ8' }
];

const walletItemsEt = [
  { name: 'Eramüügi tulu', address: 'EMP6boRHx13HfuQ9HELPQyCEJ4QpxSJ6aRA32aMbGqY' },
  { name: 'CTC Varakamber', address: 'DJmTvA7CvJJF1pSqQ1ny2rw7yfGPQQYphYrrrhvGPdRb' },
  { name: 'Asutajad', address: 'CYABTRyngdzX8JAcZD7zV2tFfaTrSAeZpXY49JkCFvfR' },
  { name: 'Eramüük', address: '5bEEtR3CtFxCaorEDSmuRvQ4nR9D6cnk1AJQZzcnH9eW' },
  { name: '1. Airdrop', address: 'Cswv13bgLCs61d1gpspjs5FhKXwVwdrm2ssrz8kU8w1X' },
  { name: 'Likviidsusbassein', address: '4HBJqbaMAXSF238NovanxTTKuuzPGDzVmQdCRxkzEGQN' },
  { name: 'CEX Noteerimine', address: 'HXMjMYQNLLQQCj4qsUNBKZqu7ftIGCyMXAH2z2jTck3s' },
  { name: '2. Airdrop', address: 'ASLN3iNkx4ZdIuPYGodtgvHap2aBHLGjy4JLXgKU16o' },
  { name: '3. Airdrop', address: 'C8nG97B6HsCPpA9v7Enbo4obBV5PznDsuUcPvVFwLXQ8' }
];

export const translations: Record<string, any> = {
  it: {
    nav: {
      home: 'Home',
      finance: 'Finanza',
      realEstate: 'Immobiliare',
      token: 'Token CTC',
      infoSocietarie: 'Info Societarie',
      community: 'Community Telegram',
      aiAutomation: 'AI & Automation'
    },
    common: {
      learnMore: 'Scopri di Più',
      comingSoon: 'Prossimamente',
      live: 'LIVE',
      explore: 'Esplora Ecosistema',
      buyCtc: 'Acquista CTC',
      joinCommunity: 'Unisciti alla Community',
      back: 'Indietro',
      viewPresentation: 'Visualizza Presentazione',
      downloadList: 'Listino & Backtest',
      technicalSpecs: 'Specifiche Tecniche',
      glossary: 'Glossario Ufficiale CTC',
      recentPerformance: 'Performance Recenti',
      partialRoadmapNote: 'Stai visualizzando solo la Roadmap relativa a questa sezione.',
      viewFullRoadmap: 'Visualizza Roadmap Completa',
      verified: 'VERIFICATO',
      screenshot: 'Screenshot',
      feedbackTitle: 'Feedback verificati & Risultati reali',
      viewMoreFeedback: 'Vedi altri feedback nel Gruppo Corporate',
      excellent: 'Eccellente',
      copied: 'Copiato!',
      copy: 'Copia',
      freeTrial: 'Richiedi Prova di 1 Mese',
      contactChoice: 'Scegli come contattarci:',
      contactEmail: 'Email',
      contactTelegram: 'Telegram',
      searchGlossary: 'Cerca un termine...',
      noResultsFound: 'Nessun termine trovato',
      tryAnotherKeyword: 'Prova con un\'altra parola chiave'
    },
    cookies: {
      title: 'Utilizzo dei Cookie',
      gdprCompliant: 'GDPR Compliant',
      description: 'Utilizziamo cookie essenziali per garantire il corretto funzionamento del sito e cookie opzionali per migliorare la tua esperienza. Puoi personalizzare le tue preferenze in qualsiasi momento.',
      acceptAll: 'Accetta Tutti',
      rejectAll: 'Solo Necessari',
      customize: 'Personalizza',
      savePreferences: 'Salva Preferenze',
      back: 'Indietro',
      required: 'Obbligatori',
      learnMore: 'Per maggiori informazioni consulta la nostra',
      privacyPolicy: 'Privacy Policy',
      necessary: {
        title: 'Cookie Necessari',
        desc: 'Essenziali per il funzionamento del sito. Non possono essere disabilitati.'
      },
      analytics: {
        title: 'Cookie Analitici',
        desc: 'Ci aiutano a capire come i visitatori interagiscono con il sito raccogliendo dati anonimi.'
      },
      marketing: {
        title: 'Cookie di Marketing',
        desc: 'Utilizzati per tracciare i visitatori sui siti web e mostrare annunci pertinenti.'
      }
    },
    socialSection: {
      titlePart1: 'CANALI',
      titlePart2: 'UFFICIALI',
      subtitle: 'Un ecosistema di comunicazione strutturato per garantire trasparenza, supporto e aggiornamenti tempestivi.',
      telegramTitle: 'Ecosistema Telegram',
      telegramDesc: 'Tre canali distinti per ogni esigenza: informazioni corporate, aggiornamenti token e community.',
      telegramChannels: {
        corporate: {
          title: 'Official Corporate Group',
          desc: 'Accesso su Approvazione. Il cuore operativo: servizi Real Estate, Finanza, Analisi di Mercato e News. Qui trovi i risultati e le recensioni in anteprima.',
          action: 'Richiedi Accesso'
        },
        token: {
          title: 'CTC Token Channel',
          desc: 'Canale pubblico ufficiale. Solo annunci verificati e notizie importanti riguardanti il Token CTC e la Roadmap.',
          action: 'Unisciti al Canale'
        },
        community: {
          title: 'CTC Token Community',
          desc: 'Gruppo pubblico aperto a tutti. Topic dedicati per Governance, Supporto tecnico, Airdrop e discussioni generali. Protetto da Recaptcha.',
          action: 'Entra nella Community'
        }
      },
      twitter: 'X (Twitter)',
      twitterDesc: 'Il punto di riferimento per l\'ecosistema crypto. Aggiornamenti real-time, partnership e interazione diretta con la community DeFi.',
      instagram: 'Instagram',
      instagramDesc: 'La nostra vetrina visiva: risultati Blue Strike, performance mensili Algo Engine 2.0, recensioni dei clienti e illustrazioni dei servizi.'
    },
    feedSection: {
      title: 'Wall of Excellence',
      subtitle: 'Risultati reali, Feedback trasparenti. Aggiorniamo costantemente la community con le performance dei nostri servizi e le opinioni dei nostri clienti.',
      viewAll: 'Visualizza tutti nel Gruppo Corporate'
    },
    home: {
      hero: {
        badge: 'AI & AUTOMATION PER PRIVATI E AZIENDE - LIVE',
        titlePart1: 'ChartTower',
        titlePart2: 'Corp.',
        subtitle: 'Inspired by the fear of being average.',
        cards: {
          corporate: 'Corporate',
          corporateDesc: 'Dati aziendali e trasparenza',
          finance: 'Finanza',
          financeDesc: 'Gestione e investimenti',
          token: 'Token CTC',
          tokenDesc: 'Utility token su Solana',
          realEstate: 'Immobiliare',
          realEstateDesc: 'Portafoglio immobiliare'
        },
        verify: {
          title: 'Dati Verificabili',
          companyNameLabel: 'Ragione Sociale',
          companyNameValue: 'ChartTower Corp. OÜ',
          regLabel: 'Numero Registrazione',
          regValue: '17288413',
          leiLabel: 'LEI Code',
          leiValue: '9845001C375D5E411F72',
          legalLabel: 'Sede Legale',
          legalValue: 'Ruunaoja 3, 11415 Tallinn, Estonia',
          tokenComplianceLabel: 'Compliance Token',
          tokenComplianceValue: 'CTC Token MICA Compliant',
          button: 'Scopri di Più'
        }
      },
      structure: {
        titlePart1: 'STRUTTURA',
        titlePart2: 'AZIENDALE',
        description: 'Ogni informazione di rilievo riguardante la nostra gestione integrata che combina vari tipi di asset sarà sempre resa disponibile al pubblico, dalle partecipazioni in asset finanziari diversificati alle proprietà immobiliari, oltre alle quote di token CTC in possesso della Tesoreria.',
        cards: {
          finance: 'Divisione Finanza & Investimenti',
          financeDesc: 'Gestione portafoglio diversificato, risk management e trasparenza totale per ottimizzare i rendimenti.',
          realEstate: 'Divisione Immobiliare',
          realEstateDesc: 'Investimenti strategici nel settore immobiliare che costruiscono una riserva di valore per l\'ecosistema.',
          token: 'CTC Token',
          tokenDesc: 'Utility token su rete Solana con cashback, sconti dedicati e rendimenti dall\'ecosistema.',
          aiAutomation: 'AI & Automation',
          aiAutomationDesc: 'Soluzioni intelligenti per automatizzare processi aziendali e ottimizzare la produttività.'
        }
      },
      roadmap: {
        leftCard: {
          title: 'Roadmap Dinamica',
          desc: 'Una timeline interattiva che traccia ogni milestone del progetto: dalla pubblicazione del White Paper alla vendita privata, dal lancio della liquidity pool agli airdrop, fino ai servizi delle divisioni Finance e Immobiliare.',
          bullets: [
            'Aggiornamenti in tempo reale',
            'Versione storica consultabile',
            'Date indicative e deliverable tecnici'
          ]
        },
        rightContent: {
          titlePart1: 'ROADMAP',
          titlePart2: 'TRASPARENTE',
          desc1: 'La Roadmap Dinamica di ChartTower guida passo-passo attraverso il presente e il futuro del progetto. Ogni obiettivo raggiunto è documentato, ogni milestone futura è pianificata con date indicative e deliverable chiari.',
          desc2: 'Dal percorso normativo MiCA EU ai servizi operativi, dalla gestione del token agli sviluppi immobiliari: tutto è tracciabile e verificabile dalla community.',
          button: 'Visualizza Roadmap'
        },
        teaser: {
          q3Title: 'Costituzione Società',
          q3Status: 'Completato',
          q4Title: 'Token & Finanza',
          q4Status: 'Completato',
          q1Title: 'Espansione',
          q1Status: 'In Corso'
        }
      },
      stats: {
        transparency: '100% TRASPARENZA',
        transparencyLabel: 'TRASPARENZA',
        solana: 'SOLANA BLOCKCHAIN NETWORK',
        solanaLabel: 'NETWORK',
        live: 'LIVE LIQUIDITY POOL',
        liveLabel: 'LIQUIDITY POOL',
        support: '24/7 COMMUNITY SUPPORT',
        supportLabel: 'SUPPORT',
        verifiable: '100%',
        verifiableLabel: 'VERIFICABILE',
        publicWallets: '9',
        publicWalletsLabel: 'WALLET PUBBLICI'
      },
      testimonials: {
        title: 'Dicono di Noi',
        reviews: [
          {
            text: 'Ottimi segnali, seguo da mesi e i risultati parlano chiaro. Dashboard molto utile per monitorare le performance!',
            author: 'Cliente Algo Engine',
            service: 'Algo Engine',
            date: '2025-11-01'
          },
          {
            text: 'Buona sera Andrea, stamattina Grazie alla performance di CTC Blue Strike mi sono alzato dal letto con il sorriso 😁. Grazie per avermi fatto conoscere questo prodotto, sono sempre più soddisfatto di aver investito in questo prodotto... grazieeee 🙏🔥🔥',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2025-12-01'
          },
          {
            text: 'E NIENTE, IL MATTINO HA L\'oro in bocca 💰🔥 Ci mancherebbe caro, grazie a te 💪🏻',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2025-12-22'
          },
          {
            text: 'Dopo che CTC blustrike si è preso un giorno di ferie 🤣 oggi è tornato più performante di prima 🔥🔥💪',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2026-01-01'
          },
          {
            text: 'Questa mattina un bel risveglio grazie al software Blue Strike. Un ottimo inizio settimanaaaaa🔥',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2026-01-12'
          },
          {
            text: 'Ri buongiorno dal software automatico direi 😂😂🔥🔥 Si direi di si, non vedo l\'ora che continui a fare questi rendimenti 💪🏻',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2026-01-16'
          },
          {
            text: 'Ti allego lo storico del software di oggi. Si inizia a macinaree😁 pochi ma buoni💪',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2026-01-30'
          },
          {
            text: 'Zero stress, replica perfetta. Trasparenza totale sulle commissioni. A breve partiamo anche con il Copy caricooo🔥🔥🔥',
            author: 'Cliente Copy Service',
            service: 'Copy Service',
            date: '2026-01-30'
          },
          {
            text: 'Comunque mega profitttt🚀 Lo consiglieresti questo servizio?😁 Assolutamente si 🔥🔥🔥',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2026-02-01'
          },
          {
            text: 'Ciao Andrea, beh che dire il mattino ha l\'oro in bocca e anche l\'argento 😂 💪💪🔥, tutto questo grazie ai tuoi ottimi servizi, CTC Blue strike e il Copy trading... grazieeee ☺️',
            author: 'Cliente Blue Strike & Copy Service',
            service: 'Blue Strike',
            date: '2026-02-23'
          },
          {
            text: 'In 3 mesi scarsi ho recuperato tutto il costo del servizio più altri 1000$ circa! È assurdo 😍',
            author: 'Cliente Blue Strike & Copy Service',
            service: 'Blue Strike',
            date: '2026-02-25'
          },
          {
            text: 'Assolutamente sì, sono servizi degni di essere chiamati tali! A confronto di tutte le cose che si leggono su Internet, compra il corso di qua, spendi soldi di là e vedrai che avrai successo e bla bla bla, questo funziona davvero!',
            author: 'Cliente Blue Strike & Copy Service',
            service: 'Copy Service',
            date: '2026-02-25'
          },
          {
            text: 'Ciao Andrea, devo dire che non potevamo incominciare meglio la settimana 💪💪',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2026-03-16'
          },
          {
            text: 'Conflitti o meno a Blue Strike non interessa, anzi ci ha portato un po\' di volatilità da sfruttare!! È una cosa fuori di testa ahaha ho ufficialmente fatto più del 50% in 5 mesi circa 😁😁',
            author: 'Cliente Blue Strike',
            service: 'Blue Strike',
            date: '2026-04-08'
          }
        ]
      },

      ecosystem: {
        title: 'Technology Stack & Ecosistema',
        solana: 'SOLANA',
        solanaDesc: 'Blockchain',
        raydium: 'RAYDIUM',
        raydiumDesc: 'Liquidità',
        telegram: 'TELEGRAM',
        telegramDesc: 'Community',
        estonia: 'ESTONIA',
        estoniaDesc: 'Regolamentazione',
        button: 'Unisciti alla Community'
      },
      faq: {
        title: 'Domande Frequenti',
        items: [
          {
            question: 'Cos\'è il token CTC?',
            answer: 'CTC è il token utility di ChartTower Corp., costruito su blockchain Solana. Offre cashback automatico sui servizi pagati in fiat, sconti dedicati pagando in CTC, partecipazione alla governance e airdrop periodici. Totale supply: 21 milioni CTC, MICA EU Compliant.'
          },
          {
            question: 'Quali servizi offrite?',
            answer: 'Offriamo tre servizi finanziari attivi: 1) CTC Blue Strike - Expert Advisor 24/7 su XAU/USD con 6 strategie indipendenti, 2) CTC Algo Engine 2.0 - Sala segnali algoritmica con dashboard real-time, 3) CTC Copy Service - Replica automatica operazioni tramite broker FPG. Inoltre stiamo sviluppando la Divisione Immobiliare e servizi AI & Automation.',
          },
          {
            question: 'Come posso verificare la trasparenza aziendale?',
            answer: 'Tutti i 9 wallet ufficiali sono pubblicamente verificabili on-chain su Solscan 24/7. I documenti ufficiali (White Paper, Statuto, Ricevuta Registrazione) sono disponibili sul sito. Le performance di Blue Strike sono certificate su MyFXBook con privilegi di trading verificati.'
          },
          {
            question: 'Dove posso acquistare il token CTC?',
            answer: 'Il token CTC è disponibile su exchange decentralizzati (DEX) Solana: Raydium e Jupiter. Puoi acquistarlo swappando SOL o USDC. La liquidity pool è live su Raydium con LP token bruciati per sicurezza.'
          },
          {
            question: 'Cos\'è la Roadmap Dinamica?',
            answer: 'È uno strumento interattivo che mostra lo stato di avanzamento del progetto in tempo reale. Traccia ogni milestone: dalla costituzione societaria al lancio token, dai servizi finanziari agli sviluppi immobiliari. Include anche una versione storica consultabile.'
          },
          {
            question: 'Siete regolamentati?',
            answer: 'Sì. ChartTower Corp. OÜ è registrata in Estonia con LEI Code 9845001C375D5E411F72 verificabile. Il token CTC è MICA EU Compliant con White Paper notificato secondo normativa europea Markets in Crypto-Assets, garantendo massima trasparenza e tutela degli investitori.'
          },
          {
            question: 'Quali vantaggi ha detenere CTC?',
            answer: 'Detenendo CTC ottieni: cashback automatico quando paghi servizi in fiat, sconti esclusivi pagando in CTC, accesso prioritario a nuovi servizi, partecipazione agli airdrop periodici, e governance sull\'ecosistema. Più CTC detieni, maggiori sono i vantaggi.'
          },
          {
            question: 'Come posso provare i servizi finanziari?',
            answer: 'Per Blue Strike e Algo Engine 2.0 puoi richiedere una prova di 1 mese tramite il pulsante nelle rispettive pagine servizi. Per Copy Service, contattaci via email (info@ctc-corp.eu) o Telegram. La prova ti permette di testare personalmente le performance.',
          }
        ]
      },
      bottomCta: {
        titlePart1: 'ENTRA NELL\'ECOSISTEMA',
        titlePart2: 'ChartTower',
        description: 'Unisciti alla community e scopri come il token CTC può trasformare il tuo approccio agli investimenti. Trasparenza, rendimenti concreti, e un network in continua crescita.',
        btn1: 'Unisciti alla Community',
        btn2: 'Acquista CTC'
      }
    },
    finance: {
      heroTitle: 'FINANZA & INVESTIMENTI',
      heroDesc: 'Strategie professionali per la crescita del tuo capitale.',
      activeServicesTitle: 'SERVIZI',
      activeServicesSubtitle: 'ATTIVI',
      badgeOperative: 'OPERATIVI ORA',
      services: {
        blueStrike: {
          title: 'CTC Blue Strike',
          subtitle: 'Expert Advisor 24/7 su XAU/USD',
          badge: 'EXPERT ADVISOR 24/7',
          f1: 'Monitoraggio MyFXbook',
          f2: 'Trasparenza totale',
          f3: 'Strategie sinergiche avanzate',
          detailedDesc: 'CTC Blue Strike è il nostro Expert Advisor di punta, operante 24/7 sulla coppia XAU/USD (Oro). Il software lavora a breakout con 6 strategie indipendenti che possono lavorare in sinergia o distaccate. Completamente automatico, include "slippage optimizer" per evitare sorprese durante le news.',
          amazonBanner: {
            title: 'PROSSIMAMENTE SU AMAZON',
            desc: 'Stiamo lavorando per portare Blue Strike sul marketplace più grande del mondo. Sarà disponibile l\'acquisto di licenze a periodo definito (es. 3 o 6 mesi) in aggiunta alla possibilità della licenza a vita, rendendo accessibile a tutti la possibilità di testare e verificare personalmente le performance del nostro Expert Advisor.'
          },
          specs: [
            { label: 'Asset', value: 'XAU/USD (Gold)' },
            { label: 'Profit Factor', value: '1.47 (Verificato 6 Anni)' },
            { label: 'Net Profit', value: '+27.672% (Compound)' },
            { label: 'Drawdown Max', value: '0.08% (Compound)' },
            { label: 'Win Rate', value: '55% (3907 Trade)' },
            { label: 'Strategie', value: '6 Indipendenti' }
          ],
          glossary: [
            { term: 'Absolute Drawdown', def: 'Differenza massima tra il capitale iniziale e il saldo minimo raggiunto durante l\'intero periodo di test. Minore è meglio.' },
            { term: 'Average Profit/Loss Trade', def: 'Media del guadagno per ogni trade vincente e della perdita per ogni trade perdente. Il rapporto deve essere > 1 per essere profittevole.' },
            { term: 'Backtest Quality', def: 'Percentuale che indica quanto fedelmente la simulazione riproduce le condizioni reali del mercato storico. 99% è il massimo.' },
            { term: 'Bars in Test', def: 'Numero totale di unità temporali (candele) considerate nella simulazione del backtest. Più alto è, più affidabile è il test.' },
            { term: 'Expected Payoff', def: 'Guadagno (o perdita) medio atteso per ogni singolo trade eseguito. Deve essere positivo.' },
            { term: 'Gross Loss', def: 'Sommatoria di tutti i trade chiusi in perdita, senza considerare i guadagni. Indica il costo operativo delle perdite.' },
            { term: 'Gross Profit', def: 'Sommatoria di tutti i trade chiusi in profitto, senza togliere le perdite. Deve superare il Gross Loss.' },
            { term: 'Initial Deposit', def: 'Capitale iniziale con cui viene avviato il backtest. Standard €1.000 per uniformità.' },
            { term: 'Largest Loss Trade', def: 'Il singolo trade che ha generato la perdita maggiore. Non deve mai compromettere il capitale.' },
            { term: 'Largest Profit Trade', def: 'Il singolo trade che ha generato il guadagno maggiore. Se troppo alto, potrebbe essere una coincidenza.' },
            { term: 'Lot', def: 'Dimensione della posizione aperta nel mercato. È il "peso" di ogni singolo trade (0.01 = micro lotto).' },
            { term: 'Lot Size Step', def: 'Regola automatica che aumenta la dimensione del lotto quando il capitale cresce (compounding).' },
            { term: 'Loss Trades (%)', def: 'Percentuale di trade chiusi in perdita. Anche il 45% può andare bene se i profitti coprono le perdite.' },
            { term: 'Magic Number', def: 'Codice identificativo univoco assegnato al bot per distinguere e gestire le sue operazioni.' },
            { term: 'Maximal Drawdown', def: 'La massima perdita subita dal picco più alto della curva di equity fino al punto più basso successivo.' },
            { term: 'Modelling Quality', def: 'Precisione dei dati storici usati. 99% significa che ogni tick è reale.' },
            { term: 'Net Profit Percent', def: 'Crescita percentuale complessiva del capitale rispetto al deposito iniziale.' },
            { term: 'Profit Factor', def: 'Rapporto tra profitti lordi totali e perdite lorde totali. > 1.0 significa profitto.' },
            { term: 'Profit Trades (%)', def: 'Percentuale di trade chiusi in profitto. > 50% è generalmente buono.' },
            { term: 'Relative Drawdown', def: 'Drawdown massimo espresso in percentuale del capitale al momento del picco.' },
            { term: 'Short Positions (won %)', def: 'Percentuale di successo nelle operazioni di vendita allo scoperto (scommessa al ribasso).' },
            { term: 'Slippage', def: 'Differenza tra prezzo atteso e prezzo reale di esecuzione. L\'ottimizzatore cerca di ridurlo.' },
            { term: 'Spread', def: 'Costo della transazione (differenza tra prezzo ask e bid). Più basso è meglio.' },
            { term: 'Take Profit / Stop Loss', def: 'Livelli automatici di chiusura in profitto (TP) o in perdita (SL) per proteggere il capitale.' },
            { term: 'Ticks Modeled', def: 'Numero totale di variazioni di prezzo considerate. Milioni di tick indicano alta precisione.' },
            { term: 'Total Net Profit', def: 'Guadagno netto finale (Capitale Finale - Capitale Iniziale).' },
            { term: 'Total Trades', def: 'Numero totale di operazioni eseguite. Un campione statistico valido richiede molti trade.' },
            { term: 'Max Consecutive Wins/Losses', def: 'La serie più lunga di trade consecutivi tutti vincenti o tutti perdenti.' },
            { term: 'Max Consecutive Profit/Loss', def: 'Importo guadagnato o perso durante la serie consecutiva più lunga.' },
            { term: 'Long Positions (won %)', def: 'Percentuale di successo nelle operazioni di acquisto (scommessa al rialzo).' }
          ],
          monitoring: {
            title: 'Monitoraggio Certificato',
            desc: 'Le performance di CTC Blue Strike sono monitorate e certificate da MyFXbook. Trasparenza totale per permettere a ogni utente di verificare i rendimenti storici in tempo reale.',
            btn: 'Vai a MyFXbook',
            verified: 'VERIFICATO',
            privileges: 'Privilegi di Trading Verificati'
          },
          apiDashboard: {
            title: 'Dashboard Real-Time MyFXBook',
            desc: 'Dashboard integrata che utilizza MyFXBook per visualizzare i dati di performance in tempo reale direttamente sul nostro sito.',
            button: 'Vai alla Dashboard Live',
            feature1: 'Dati in Tempo Reale',
            feature1Desc: 'Integrazione MyFXBook per aggiornamenti live delle performance',
            feature2: 'Grafici Interattivi',
            feature2Desc: 'Visualizzazione avanzata di equity, drawdown e statistiche di trading',
            feature3: 'Storico Completo',
            feature3Desc: 'Accesso a tutti i dati storici e metriche di performance',
            feature4: 'Trasparenza Totale',
            feature4Desc: 'Tutti i trade e le operazioni visibili in un\'unica interfaccia'
          },
          backtest: {
            title: 'Verifica Backtest (2018 - 2023)',
            netProfit: '+27.672%',
            netProfitLabel: 'Profitto Netto Totale',
            maxDrawdown: '0.08%',
            maxDrawdownLabel: 'Drawdown Max',
            profitFactor: '1.47',
            profitFactorLabel: 'Profit Factor',
            totalTrades: '3.907',
            totalTradesLabel: 'Trade Totali'
          }
        },
        algoEngine: {
          title: 'CTC Algo Engine 2.0',
          subtitle: 'Sala segnali algoritmica',
          badge: 'SEGNALI ALGORITMICI',
          telegramBtn: 'Ricevi Segnali su Telegram',
          pricelistBtn: 'Scarica Listino',
          f1: 'Algoritmo dedicato per ogni asset',
          f2: 'Strategia swing evoluta',
          f3: 'Operatività a ordini pendenti',
          detailedDesc: 'CTC Algo Engine 2.0 è la nostra sala segnali algoritmica professionale di nuova generazione. Basata su un algoritmo proprietario avanzato, progettato e ottimizzato singolarmente per ogni asset (oltre 11.000 backtest per strumento), fornisce segnali di trading chiari, strutturati e replicabili. Opera con strategia swing evoluta integrando Teoria di Gann, livelli di resistenza chiave, zone psicologiche, breakout e proiezioni future. Operatività esclusiva a ordini pendenti (90% dei casi) per massima precisione e zero emotività. Include dashboard real-time per monitorare ogni trade, percentuali di successo e storico completo con report PDF mensili scaricabili.',
          updating: {
            title: 'In Aggiornamento',
            subtitle: 'Stiamo effettuando aggiornamenti sull\'infrastruttura del servizio.',
            cta: 'Stay tuned!'
          },
          dashboard: {
            title: 'Dashboard Real-Time Disponibile',
            desc: 'Monitora in tempo reale ogni trade, le percentuali di successo e lo storico mensile. Dashboard interattiva con grafici avanzati, filtri personalizzabili e report PDF scaricabili per ogni mese.',
            button: 'Apri Dashboard Live'
          },
          specs: [
            { label: 'Settembre 2025', value: '+4.070 Pips' },
            { label: 'Ottobre 2025', value: '+17.770 Pips' },
            { label: 'Novembre 2025', value: '+18.155 Pips' },
            { label: 'Dicembre 2025', value: '+15.920 Pips' },
            { label: 'Asset Class', value: 'Forex, Indices, Crypto' }
          ]
        },
        copyService: {
          title: 'CTC Copy Service',
          subtitle: 'Replica automatica operazioni',
          badge: 'REPLICA AUTO-TRADING',
          btn: 'Attiva Servizio Copia',
          f1: 'Collegamento automatico',
          f2: 'Replica real-time',
          f3: 'Server dedicati FPG',
          detailedDesc: 'CTC Copy Service offre la replica automatica dell\'operatività dei conti ChartTower (Master Account) per fini proprietari, sfruttando l\'infrastruttura di piattaforme broker esterne. L\'algoritmo lavora utilizzando una logica swing reattiva che utilizziamo con successo da oltre due anni sui mercati Forex, Commodity e Crypto.',
          partner: {
            title: '',
            name: 'FPG Broker',
            desc: 'Poiché i Master Account di ChartTower operano sui server di liquidità di FPG, la replica del segnale è tecnicamente possibile esclusivamente per account gestiti nello stesso server. Tentare di replicare questa operatività ad alta frequenza su broker gestiti su server diversi causerebbe ritardi (latenza) rendendo la strategia inefficace.'
          },
          logic: [
            { title: 'Logica Dinamica', desc: 'Analisi "Day-by-Day" della volatilità per adattare Take Profit e Stop Loss alle reali condizioni di mercato.' },
            { title: 'Gestione Rischio', desc: 'Nessuna griglia o martingala. Una sola operazione alla volta con focus sulla preservazione del capitale.' },
            { title: 'Mercati & Asset', desc: 'Operatività swing medio-lunga su Forex, Commodity (XAU/USD) e Criptovalute selezionate.' },
            { title: 'Take Profit Avanzati', desc: '3 livelli di TP dinamici (chiusura 33% ciascuno) e Stop Loss a Breakeven dopo il primo target.' }
          ],
          steps: [
            { title: 'Apertura Conto FPG', desc: 'Apri un conto con il nostro Broker partner ufficiale FPG seguendo la procedura guidata.' },
            { title: 'Connessione Rapida', desc: 'Collega il tuo account al sistema di replica CTC Copy Service in pochi click.' },
            { title: 'Relax & Monitoraggio', desc: 'Lascia che la logica swing lavori per te e monitora i risultati dal tuo dispositivo.' }
          ],
          benefits: [
            { title: 'Logica Swing Reattiva', desc: 'Strategia basata su sbilanciamenti e rotture di livelli con estensioni di prezzo significative.' },
            { title: 'Zero Latenza', desc: 'Infrastruttura ottimizzata con il partner FPG per una replica istantanea degli ordini.' },
            { title: 'Pieno Controllo', desc: 'Massima trasparenza con possibilità di interrompere la copia in qualsiasi momento.' }
          ]
        },
      },
    },
    realEstate: {
      heroTitle: 'IMMOBILIARE',
      heroDesc: 'La divisione Immobiliare unisce la solidità del mattone a modelli di investimento innovativi. Sfruttando i vantaggi dell\'ecosistema ChartTower e attraverso lo studio di investimenti strategici e mirati, costruiremo nel tempo un portafoglio immobiliare che possa essere una riserva di valore per l\'ecosistema stesso.',
      comingSoon: 'Coming Soon',
      pillars: {
        title: 'I NOSTRI',
        titlePart2: 'PILASTRI',
        subtitle: 'Ogni investimento immobiliare è selezionato con cura per garantire valore duraturo e rendimenti sostenibili.',
        cards: {
          solidity: 'Solidità del Mattone',
          solidityDesc: 'Investimenti immobiliari che uniscono la stabilità tradizionale a modelli innovativi.',
          strategic: 'Portafoglio Strategico',
          strategicDesc: 'Studio di investimenti mirati per costruire una riserva di valore per l\'ecosistema ChartTower.',
          ecosystem: 'Vantaggi Ecosistema',
          ecosystemDesc: 'Sfruttamento completo dei vantaggi dell\'ecosistema CTC per massimizzare i rendimenti.',
        }
      },
      strategy: {
        title: 'STRATEGIA DI',
        titlePart2: 'INVESTIMENTO',
        description: 'La nostra strategia di investimento immobiliare si basa su tre principi fondamentali: selezione accurata, diversificazione geografica e gestione professionale. Ogni proprietà viene valutata non solo per il suo valore attuale, ma per il potenziale di crescita a lungo termine.',
        items: {
          growth: 'Crescita Sostenibile',
          growthDesc: 'Investimenti mirati in aree con forte potenziale di apprezzamento',
          risk: 'Risk Management',
          riskDesc: 'Diversificazione geografica e tipologica degli asset',
          positions: 'Posizioni Strategiche',
          positionsDesc: 'Selezione di proprietà in location di alto valore'
        },
        portfolio: {
          title: 'Portafoglio Immobiliare',
          residential: 'Asset Residenziali',
          commercial: 'Asset Commerciali',
          development: 'Sviluppo Progetti',
          desc: 'Il portafoglio è in continua evoluzione e viene costantemente ottimizzato per massimizzare i rendimenti e ridurre i rischi.',
          button: 'Scopri di Più'
        }
      },
      vision: {
        title: 'LA NOSTRA VISIONE',
        description: 'Crediamo che l\'immobiliare rappresenti un pilastro fondamentale per la stabilità e la crescita dell\'ecosistema ChartTower. Attraverso una gestione professionale e trasparente, costruiamo un patrimonio immobiliare che genera valore sostenibile nel tempo, contribuendo alla solidità dell\'intero progetto e ai rendimenti per i detentori di token CTC.',
        stats: {
          transparency: '100%',
          transparencyLabel: 'TRASPARENZA',
          longTerm: 'LONG-TERM',
          longTermLabel: 'VISIONE',
          global: 'GLOBAL',
          globalLabel: 'DIVERSIFICAZIONE'
        }
      },
      requestInfoBtn: 'Chiedi Maggiori Info'
    },
    token: {
      hero: {
        badge: 'LIQUIDITY POOL LIVE SU RAYDIUM',
        titlePart1: 'TOKEN',
        titlePart2: 'CTC',
        description: 'Il cuore dell\'ecosistema ChartTower: un utility token basato su rete Solana che dà accesso a servizi esclusivi e crea un\'economia circolare sostenibile.',
        buyBtn: 'Acquista su Raydium',
        whitepaperBtn: 'Leggi il White Paper',
        check1: 'Solana Blockchain',
        check2: '9 Wallet Ufficiali',
        check3: 'MICA COMPLIANT',
        card: {
          title: 'CTC Token',
          subtitle: 'Utility Token • Solana Network',
          item1Title: 'I VANTAGGI DELLA DETENZIONE DI CTC TOKEN',
          item1Desc: 'Sconti, cashback e ricompense speciali in ogni airdrop',
          item2Title: 'MICA COMPLIANT',
          item2Desc: 'White Paper notificato agli enti competenti ed inserito nei registri ESMA',
          item3Title: 'ECONOMIA CIRCOLARE',
          item3Desc: 'Tokenomics trasparente e sostenibile'
        }
      },
      contract: {
        titlePart1: 'CONTRACT',
        titlePart2: 'ADDRESS',
        addressLabel: 'Program ID / Contract Address',
        copyBtn: 'Copia Indirizzo',
        solscanBtn: 'Solscan',
        dtiLabel: 'DTI Code',
        dtiIdLabel: 'Digital Token Identifier',
      },
      distribution: {
        titlePart1: 'TOKEN',
        titlePart2: 'DISTRIBUTION',
        description: 'La distribuzione del token è progettata per garantire sostenibilità a lungo termine, con vantaggi da utility che premiano i detentori attraverso sconti o cashback, e meccanismi di gestione della Tesoreria Aziendale pensati per supportare la crescita dell\'ecosistema.',
        items: [
          { label: 'Tesoreria Aziendale', percentage: '38%', amount: '7.980.000 CTC', desc: 'Vincolato da condizioni stringenti di liquidità, incluso il divieto di vendita diretta su CEX/DEX e accumulo BTC obbligatorio tra 2-5% dei profitti netti' },
          { label: 'Listing pubblico su CEX', percentage: '15%', amount: '3.150.000 CTC', desc: 'Allocazione dedicata per i listing su exchange centralizzati pubblici' },
          { label: 'Founders', percentage: '12%', amount: '2.520.000 CTC', desc: 'Sblocco progressivo dei token su molteplici milestone di avanzamento del progetto, esclusa la gestione operativa' },
          { label: '2° Airdrop', percentage: '10%', amount: '2.100.000 CTC', desc: 'Calcolato tramite smart contract basato sulla media delle detenzioni di token durante periodi specifici' },
          { label: '3° Airdrop', percentage: '10%', amount: '2.100.000 CTC', desc: 'Calcolato tramite smart contract basato sulla media delle detenzioni di token durante periodi specifici' },
          { label: 'Liquidity Pool su Raydium DEX', percentage: '9%', amount: '1.890.000 CTC', desc: 'Token generati da Raydium immediatamente bruciati per prevenire prelievi USDC' },
          { label: '1° Airdrop', percentage: '4%', amount: '840.000 CTC', desc: 'Distribuito attraverso meccanismi interattivi basati sulla conoscenza dell\'ecosistema ChartTower e del mondo crypto in generale' },
          { label: 'Vendita Privata', percentage: '2%', amount: '420.000 CTC', desc: 'Limitato a 20.000 token per wallet a 0.005 USDC/token (completata)' }
        ]
      },
      whitepaper: {
        titlePart1: 'WHITE',
        titlePart2: 'PAPER',
        description: 'Il White Paper di ChartTower Corp. descrive in dettaglio la visione, l\'architettura tecnica, la tokenomics e la roadmap del progetto. Un documento completo che illustre come l\'ecosistema CTC integra finanza tradizionale, immobiliare e blockchain per creare valore sostenibile.',
        downloadBtn: 'Scarica White Paper (PDF)',
        cards: [
          { title: 'Visione & Mission', desc: 'ChartTower Corp. nasce con l\'obiettivo di creare un ecosistema finanziario integrato che unisce i vantaggi della finanza tradizionale, dell\'immobiliare e della blockchain. La nostra missione è democratizzare l\'accesso a servizi finanziari professionali attraverso tecnologie innovative e trasparenza totale.' },
          { title: 'Architettura Tecnica', desc: 'Il token CTC è costruito su blockchain Solana, scelta per le sue elevate prestazioni, basse commissioni di transazione e scalabilità. L\'infrastruttura garantisce sicurezza, velocità e accessibilità globale per tutti gli utenti dell\'ecosistema.' },
          { title: 'Tokenomics', desc: 'La distribuzione del token è progettata per garantire sostenibilità a lungo termine, con meccanismi di utility che premiano i detentori e supportano la crescita dell\'ecosistema attraverso cashback, governance e rendimenti dalle attività operative.' }
        ]
      },
      utility: {
        titlePart1: 'Meccanismi di',
        titlePart2: 'Utility Token',
        comingSoon: 'Coming Soon',
        cards: [
          { title: 'Cashback Automatico', desc: 'Presto attivi meccanismi di cashback: quando paghi i servizi dell\'ecosistema ChartTower in valuta fiat, ricevi automaticamente un rimborso in token CTC. Un sistema che premia la fedeltà e incentiva l\'utilizzo continuo dei nostri servizi.' },
          { title: 'Sconti con Pagamento in CTC', desc: 'Sconti dedicati se paghi in CTC: utilizzando i token CTC per acquistare servizi della Divisione Finanza & Investimenti o Immobiliare, ottieni sconti esclusivi e condizioni preferenziali riservate solo ai detentori.' }
        ]
      },
      compliance: {
        titlePart1: 'Conformità Normativa',
        titlePart2: 'MICA EU',
        description: 'CTC Token è emesso nel pieno rispetto delle normative europee. Il White Paper è stato notificato ai sensi della normativa MICA EU (Markets in Crypto-Assets), il nuovo quadro regolamentare dell\'Unione Europea per i crypto-asset, garantendo massima trasparenza, tutela degli investitori e conformità agli standard internazionali.',
        checks: ['Regolamentazione EU', 'Trasparenza Totale', 'Tutela Investitori']
      },
      metrics: {
        titlePart1: 'TOKEN',
        titlePart2: 'METRICS',
        items: [
          { value: 'SOLANA', label: 'BLOCKCHAIN' },
          { value: 'LIVE', label: 'LIQUIDITY POOL' },
          { value: '9', label: 'WALLET UFFICIALI' },
          { value: '24/7', label: 'SUPPORT' }
        ]
      }
    },
    corporateInfo: {
      hero: {
        titlePart1: 'INFORMAZIONI',
        titlePart2: 'SOCIETARIE',
        subtitle: 'Trasparenza totale: tutti i dati aziendali verificabili, wallet ufficiali e documentazione legale di ChartTower Corp.',
      },
      about: {
        title: 'Chi Siamo & La Nostra Storia',
        readMore: 'Leggi tutto',
        readLess: 'Mostra meno',
        advantagesTitle: 'Vantaggi esclusivi:',
        paragraphs: [
          'ChartTower Corp. nasce da un gruppo di amici uniti dalla stessa ambizione: costruire qualcosa di solido, innovativo e duraturo. Un percorso iniziato con curiosità e determinazione, animato dalla voglia di comprendere a fondo il funzionamento dei mercati e dell\'economia reale, e di trasformare la teoria in valore concreto.',
          'Non è stato un cammino lineare: abbiamo fatto errori, raccolto esperienze, imparato a nostre spese. Ma proprio attraverso questi passaggi abbiamo sviluppato una mentalità fondata sullo studio continuo, sull\'analisi critica e sull\'evoluzione costante. È da questo spirito che nascono i nostri valori fondamentali: qualità, fiducia e soprattutto trasparenza.',
          'ChartTower Corp. si fonda su una visione chiara: unire settori diversi e renderli complementari tra loro sfruttando anche la tecnologia blockchain. Questa visione prende forma concreta con l\'emissione di CTC Token, un utility-token sviluppato su rete Solana, pensato per integrare in modo organico i servizi offerti dalle nostre Divisioni aziendali.',
          'Per incrementare ulteriormente le potenzialità delle due Divisioni, stiamo approfondendo i benefici di AI & Automazione per ottimizzare processi per privati ed aziende. Le stesse reportistiche degli strumenti di investimento da noi offerti e già consultabili in tempo reale su questo sito web sono in corso di automazione, e saranno ultimate a breve.',
          'Grazie a questa struttura modulare e integrata, ChartTower Corp. è in grado di interfacciarsi con qualsiasi tipologia di cliente, offrendo servizi costruiti su misura. CTC Token rappresenta il filo conduttore di tutto il nostro ecosistema: chi lo detiene può accedere a vantaggi sulla detenzione del token stesso e condizioni speciali su ogni servizio delle nostre Divisioni.'
        ],
        advantages: [
          'La Divisione Real Estate si distingue per solidità, struttura e aderenza al mondo economico tradizionale.',
          'La Divisione Finanza & Investimenti valorizza la nostra esperienza nei mercati, offrendo soluzioni dinamiche e accessibili.'
        ]
      },
      team: {
        titlePart1: 'TEAM',
        titlePart2: 'OPERATIVO',
        description: 'Il team di ChartTower Corp. è composto dai founder che guidano le divisioni strategiche dell\'azienda, combinando esperienza finanziaria, visione immobiliare e competenza tecnologica.',
        members: [
          {
            name: 'Andrea Cascino',
            role: 'Founder',
            title: 'CEO Finance & Investments Division',
            areas: ['AI & Automation']
          },
          {
            name: 'Luca Marcialli',
            role: 'Founder',
            title: 'CEO Real Estate Division',
            areas: ['Legal & Compliance']
          },
          {
            name: 'Thomas Tapella',
            role: 'CTO',
            title: 'IT Manager',
            areas: ['AI & Automation']
          }
        ]
      },
      data: {
        titlePart1: 'DATI',
        titlePart2: 'AZIENDALI',
        companyNameLabel: 'RAGIONE SOCIALE',
        companyNameValue: 'ChartTower Corp. OÜ',
        regNumberLabel: 'NUMERO REGISTRAZIONE',
        regNumberValue: '17288413',
        leiCodeLabel: 'LEI CODE',
        leiCodeValue: '9845001C375D5E411F72',
        emailLabel: 'EMAIL',
        emailValue: 'info@ctc-corp.eu',
        addressLabel: 'SEDE LEGALE',
        addressValue: 'Ruunaoja 3, 11415 Tallinn, Estonia',
        addressSub: '(presso Nomad Consulting OÜ)',
        docs: {
          title: 'Archivio Documentale',
          whitepaper: 'White Paper',
          whitepaperSub: 'MICA Compliant',
          registration: 'Ricevuta di Registrazione',
          registrationDate: '23/07/2025',
          registrationUrl: 'https://ctc-corp.eu/wp-content/uploads/2025/08/Iscrizione-registro-imprese-arakiri_A_50287702.pdf',
          statute: 'Statuto Aziendale',
          statuteDate: '23/07/2025',
          statuteUrl: 'https://ctc-corp.eu/wp-content/uploads/2025/08/ChartTower_Corp._OU-pohikiri_3556957.pdf'
        }
      },
      wallets: {
        titlePart1: 'WALLET',
        titlePart2: 'AZIENDALI',
        subtitle: 'I 9 wallet ufficiali di ChartTower Corp. sulla rete Solana. Tutti gli indirizzi sono verificabili pubblicamente on-chain.',
        colDest: 'DESTINATION',
        colAddr: 'INDIRIZZO WALLET',
        colAction: 'AZIONI',
        copy: 'Copia',
        solscan: 'Solscan',
        items: walletItems
      },
      roadmap: {
        titlePart1: 'ROADMAP',
        titlePart2: 'DINAMICA',
        subtitle: 'La Roadmap Dinamica guida passo-passo nel presente e nel futuro del progetto. Ogni milestone è tracciata per garantire trasparenza agli investitori e alla community.',
        btnRealtime: 'Milestone in Tempo Reale',
        btnHistory: 'Versione Storica',
        notionLabel: 'Roadmap Estesa su Notion',
        filters: {
          all: 'Tutti',
          completed: 'Completati',
          inprogress: 'In Corso',
          planned: 'In Programma',
        },
        items: [
          { title: 'Costituzione Societaria & Compliance', status: 'completed', statusLabel: 'Completato', desc: 'Registrazione ChartTower Corp. OÜ in Estonia e ottenimento codici LEI.', date: 'Q3 2025', category: 'corporate' },
          { title: 'Rilascio White Paper & Tokenomics', status: 'completed', statusLabel: 'Completato', desc: 'Pubblicazione documentazione tecnica e struttura economica del token CTC.', date: 'Q3 2025', category: 'token' },
          { title: 'Vendita Privata (Private Sale)', status: 'completed', statusLabel: 'Completato', desc: 'Allocazione iniziale token a investitori strategici.', date: 'Q4 2025', category: 'token' },
          { title: 'Lancio Liquidity Pool (Raydium)', status: 'completed', statusLabel: 'Completato', desc: 'Listing ufficiale su DEX Solana e burn immediato LP token.', date: 'Q4 2025', category: 'token' },
          { title: 'Lancio Blue Strike', status: 'completed', statusLabel: 'Completato', desc: 'Expert Advisor 24/7 su XAU/USD operativo con 6 strategie indipendenti e slippage optimizer.', date: 'Q4 2025', category: 'finance' },
          { title: 'Audit Smart Contract', status: 'inprogress', statusLabel: 'In Corso', desc: 'Verifica di sicurezza del contratto token da parte di enti terzi.', date: 'Q1 2026', category: 'token' },
          { title: 'Attivazione Servizi Finanziari', status: 'completed', statusLabel: 'Completato', desc: 'CTC Blue Strike, Algo Engine e Copy Service attivi e operativi.', date: 'Q1 2026', category: 'finance' },
          { title: 'Campagna Airdrop "Early Adopter"', status: 'planned', statusLabel: 'In Programma', desc: 'Distribuzione reward alla community attiva su Telegram.', date: 'Q2 2026', category: 'token' },
          { title: 'Acquisizione Asset Immobiliari', status: 'planned', statusLabel: 'In Programma', desc: 'Primo acquisto strategico Divisione Immobiliare a Tallinn.', date: 'Q2 2026', category: 'realEstate' },
          { title: 'Listing CEX (Centralized Exchange)', status: 'planned', statusLabel: 'In Programma', desc: 'Quotazione su exchange centralizzato per aumentare liquidità.', date: 'Q3 2026', category: 'token' },
          { title: 'Piattaforma Cashback & Utility', status: 'planned', statusLabel: 'In Programma', desc: 'Integrazione pagamenti in CTC per servizi e sconti automatici.', date: 'Q4 2026', category: 'token' },
        ]
      },
      transparency: {
        title: 'Massima Trasparenza',
        desc: 'ChartTower Corp. si impegna a garantire la massima trasparenza in tutte le sue operazioni. Tutti i wallet aziendali sono pubblicamente verificabili sulla blockchain Solana.',
        stats: {
          verifiable: '100%',
          verifiableLabel: 'VERIFICABILE',
          wallets: '9',
          walletsLabel: 'WALLET UFFICIALI',
          onchain: '24/7',
          onchainLabel: 'ON-CHAIN'
        }
      },
    },

    aiAutomation: {
      title: 'AI & Automation',
      subtitle: 'Il Futuro è Adesso.',
      description: 'Nessuna azienda dovrebbe soffrire per colpa di procedimenti interni lunghi, noiosi e manuali. Sei alla ricerca di un assistente personale per la tua posta? Un sistema per gestire gli appuntamenti? O una piattaforma di ricerca per creare contenuti di successo? Noi possiamo aiutarti a fare tutto questo (e molto altro) con soluzioni veloci e su misura studiate per valorizzare ed espandere il tuo business.',
      notifyBtn: 'Avvisami al Lancio',
      features: {
        title1: 'Soluzioni a 360 gradi',
        desc1: 'Hai già un sito operativo? Parti da 0? Non importa. I nostri specialisti sono a tua disposizione per accompagnarti in ogni fase del progetto.',
        title2: 'Scalabile e disponibile',
        desc2: 'Le nostre infrastrutture cloud sono state progettate per essere facilmente scalabili e con una disponibilità continua garantita del 99.9%.',
        title3: 'Security Oriented',
        desc3: 'Oltre ad avere strette politiche interne sulla sicurezza dei dati, sfruttiamo sistemi intelligenti proprietari per proteggere la sicurezza operativa dei nostri clienti.',
      },
      skills: {
        sectionTitle: 'SERVIZI E PROGETTI CTC AUTOMATION',
        sectionSubtitle: 'Soluzioni intelligenti per ottimizzare ogni aspetto del tuo business',
        skill1: 'Sviluppo e Integrazione Agenti AI',
        skill1Desc: 'Progettazione e sviluppo di agenti intelligenti personalizzati, integrabili nei tuoi sistemi aziendali. Automazione decisionale, elaborazione linguaggio naturale e integrazione API con LLM avanzati (GPT, Claude, Gemini).',
        skill2: 'Gestione Workflow Automatizzati',
        skill2Desc: 'Creazione di flussi di lavoro complessi e automatizzati per ridurre task ripetitivi. Integrazione multi-piattaforma (n8n, Make, Zapier) con trigger intelligenti, gestione errori e scalabilità enterprise.',
        skill3: 'Computer Vision & Analisi Dati',
        skill3Desc: 'Sistemi di analisi visiva per riconoscimento oggetti, classificazione immagini, OCR e video analysis. Machine Learning applicato per pattern recognition, anomaly detection e predictive analytics.',
        skill4: 'Generative AI per la Creazione Contenuti',
        skill4Desc: 'Automazione nella generazione di contenuti testuali, visivi e multimediali. Content strategy basata su AI, copywriting automatizzato, image generation e personalizzazione dinamica per campagne marketing.',
        skill5: 'Sviluppo Web App & Dashboard Intelligenti',
        skill5Desc: 'Applicazioni web moderne con AI integrata. Dashboard real-time con analytics predittivi, interfacce conversazionali e visualizzazioni dati avanzate. Stack moderno: React, Next.js, Node.js.',
        skill6: 'Chatbot & Assistenza Conversazionale',
        skill6Desc: 'Assistenti virtuali intelligenti per customer service, supporto tecnico e vendite. NLP avanzato, multi-lingua, integrazione CRM/database e training personalizzato su knowledge base aziendali.'
      }
    },
    algoDashboard: {
      backToFinance: 'Torna a Finanza',
      title: 'ALGO ENGINE 2.0',
      titleHighlight: 'DASHBOARD',
      subtitle: 'Monitoraggio Real-Time Performance Algoritmica',
      filterAll: 'Tutto',
      filter3m: '3 Mesi',
      filter1m: '1 Mese',
      kpi: {
        totalPips: 'Pips Totali',
        totalPipsLabel: 'TOTALE',
        winRate: 'Win Rate',
        winRateLabel: 'ACCURACY',
        profitFactor: 'Profit Factor',
        profitFactorLabel: 'RATIO',
        totalTrades: 'Trade Totali',
        totalTradesLabel: 'OPERAZIONI'
      },
      charts: {
        equityTitle: 'Crescita Equity (Pips)',
        assetDistTitle: 'Distribuzione Asset',
        monthlyPerfTitle: 'Performance Mensile',
        pipsLabel: 'Pips:',
        tradesLabel: 'Trade:',
        winRateLabel: 'Win Rate:'
      },
      table: {
        title: 'Ultimi Trade',
        dateCol: 'Data',
        assetCol: 'Asset',
        typeCol: 'Tipo',
      }
    },
    consultation: {
      title: 'Consulenza',
      titleHighlight: 'Gratuita',
      subtitle: 'Non sai quale servizio fa per te? Raccontaci le tue esigenze e ti aiuteremo a trovare la soluzione su misura per la tua situazione.',
      cta: 'Richiedi Consulenza Gratuita',
      bullets: ['Nessun impegno', 'Risposta entro 24h', '100% personalizzata'],
      services: {
        blueStrike: 'CTC Blue Strike',
        algoEngine: 'CTC Algo Engine',
        copyService: 'CTC Copy Service',
        realEstate: 'Divisione Immobiliare',
        ai: 'AI \u0026 Automation',
        notSure: 'Non so ancora \u2014 aiutami a scegliere'
      },
      modal: {
        title: 'Richiedi Consulenza Gratuita',
        desc: 'Compila il modulo e ti contatteremo per fissare la consulenza nel momento pi\u00f9 comodo per te.',
        fields: {
          name: 'Nome Completo',
          telegram: 'Telegram',
          optional: 'Opzionale',
          service: 'Servizio di Interesse',
          servicePlaceholder: '\u2014 Seleziona un servizio \u2014',
          needs: 'Le tue esigenze',
          needsPlaceholder: 'Descrivici brevemente la tua situazione e cosa stai cercando...'
        },
        submit: 'Invia Richiesta',
        successTitle: 'Richiesta inviata!',
        successDesc: 'Ti risponderemo entro 24 ore. Controlla il tuo client email.'
      }
    },
    linktree: {
      subtitle: 'Finanza, Blockchain, Immobiliare. Tutto in un unico ecosistema.',
      officialChannels: 'Canali Ufficiali',
      corporateGroup: 'Gruppo Corporate',
      corporateGroupDesc: 'Accesso riservato su approvazione',
      website: 'Sito Web Ufficiale',
      websiteDesc: 'Esplora l\'ecosistema completo',
      tokenChannel: 'CTC Token Channel',
      tokenChannelDesc: 'News e aggiornamenti token',
      twitter: 'Twitter / X',
      twitterDesc: 'Seguici per le ultime novità',
      instagram: 'Instagram',
      instagramDesc: 'Contenuti esclusivi e insights',
      rightsReserved: 'Tutti i diritti riservati.'
    },
    footer: {
      tagline: 'Inspired by the fear of being average.',
      divisions: 'Divisioni',
      resources: 'Risorse',
      legal: 'Legal & Contatti',
      items: {
        home: 'Home',
        finance: 'Finanza & Investimenti',
        realEstate: 'Immobiliare',
        token: 'Token CTC',
        roadmap: 'Roadmap Dinamica',
        whitepaper: 'White Paper',
        community: 'Community Telegram',
        liquidity: 'Liquidity Pool',
        privacy: 'Privacy Policy',
        terms: 'Termini di Servizio',
        cookie: 'Cookie Policy',
        about: 'Chi Siamo'
      },
      address: 'ChartTower Corp. OÜ c/o Nomad Consulting OÜ; Ruunaoja 3, 11415 Tallinn, Estonia',
      copyright: '© 2025 ChartTower Corp. All rights reserved.',
      backToTop: 'Back to Top'
    },
    privacyPolicy: {
      subtitle: 'La tua privacy è fondamentale per noi. Qui spieghiamo come trattiamo i tuoi dati in conformità al GDPR e alle normative europee sulla protezione dei dati personali.',
      lastUpdated: 'Ultimo aggiornamento:',
      lastUpdatedDate: '20 Gennaio 2026',
      s1: {
        title: '1. Titolare del Trattamento',
        desc: 'Il Titolare del trattamento dei dati personali è:',
        company: 'Ragione Sociale',
        address: 'Sede Legale',
        regNum: 'Numero di Registrazione',
      },
      s2: {
        title: '2. Responsabile della Protezione dei Dati (DPO)',
        desc: 'Abbiamo nominato un Responsabile della Protezione dei Dati (DPO) che puoi contattare per qualsiasi questione relativa al trattamento dei tuoi dati personali:',
        dpo: 'DPO',
      },
      s3: {
        title: '3. Tipologie di Dati Raccolti',
        intro: 'Durante la navigazione sul nostro sito, raccogliamo le seguenti categorie di dati:',
        navTitle: '3.1 Dati di Navigazione',
        navDesc: "I sistemi informatici preposti al funzionamento del sito acquisiscono, nel normale esercizio, alcuni dati la cui trasmissione è implicita nell'uso dei protocolli di comunicazione Internet:",
        navItems: ['Indirizzi IP', 'Tipo di browser e sistema operativo', 'Data e ora delle richieste', 'Pagine visitate'],
        chatTitle: '3.2 Dati del ChatBot',
        chatDesc: 'Il nostro assistente virtuale (ChartTower BOT AI) raccoglie:',
        chatItems: ["Messaggi inviati dall'utente", 'ID di sessione (generato automaticamente e memorizzato localmente)', 'Timestamp delle conversazioni'],
        chatWarning: 'Avviso importante:',
        chatWarningDesc: 'Ti consigliamo di NON inserire informazioni personali sensibili nelle conversazioni con il ChatBot.',
        cookiesTitle: '3.3 Preferenze Cookie',
        cookiesDesc: 'Memorizziamo le tue preferenze relative ai cookie (vedi',
      },
      s4: {
        title: '4. Finalità e Base Giuridica del Trattamento',
        intro: 'I tuoi dati personali sono trattati per le seguenti finalità:',
        p1Title: 'Funzionamento del Sito Web',
        p1Desc: 'Garantire la corretta navigazione e fruizione dei contenuti.',
        p1Legal: 'Base giuridica: Legittimo Interesse (Art. 6.1.f GDPR)',
        p2Title: 'Assistenza tramite ChatBot',
        p2Desc: "Fornire supporto e informazioni sui nostri servizi attraverso l'assistente virtuale.",
        p2Legal: "Base giuridica: Consenso implicito all'utilizzo (Art. 6.1.a GDPR)",
        p3Title: 'Miglioramento del Servizio ChatBot',
        p3Desc: "I log delle conversazioni vengono utilizzati esclusivamente per l'auto-apprendimento del bot e per migliorare la qualità delle risposte.",
        p3Legal: 'Base giuridica: Legittimo Interesse (Art. 6.1.f GDPR)',
        p4Title: 'Adempimenti Legali',
        p4Desc: 'Ottemperare ad obblighi previsti dalla legge, regolamenti o normative europee.',
        p4Legal: 'Base giuridica: Obbligo legale (Art. 6.1.c GDPR)',
      },
      s5: {
        title: '5. Destinatari e Responsabili del Trattamento',
        intro: 'I tuoi dati possono essere comunicati a:',
        h1Title: 'Hosting Provider',
        h1Desc: 'Cloudflare Inc. - Hosting e distribuzione del sito web (Cloudflare Pages)',
        h1Note: 'Sede: USA - Trasferimento dati regolato da Standard Contractual Clauses (SCC) e Data Processing Addendum',
        h2Title: 'Servizio ChatBot',
        h2Desc: "I dati delle conversazioni con il ChatBot vengono elaborati tramite server situati su app.thomastapella.it per la gestione delle risposte e l'auto-apprendimento del sistema AI.",
        noteLabel: 'Nota importante:',
        note: 'NON vendiamo, affittiamo o condividiamo i tuoi dati personali con terze parti per finalità di marketing. Non utilizziamo cookie di tracciamento o analytics di terze parti.',
      },
      s6: {
        title: '6. Periodo di Conservazione dei Dati',
        intro: 'I dati personali sono conservati per il tempo strettamente necessario a conseguire le finalità per cui sono stati raccolti:',
        i1Label: 'Dati di navigazione:',
        i1Desc: 'Cancellati entro 7 giorni dalla raccolta',
        i2Label: 'Log ChatBot:',
        i2Desc: "Utilizzati per l'apprendimento AI, poi anonimizzati",
        i3Label: 'Preferenze Cookie:',
        i3Desc: '12 mesi dalla scelta',
      },
      s7: {
        title: '7. I Tuoi Diritti (GDPR Art. 15-22)',
        intro: 'In qualità di interessato, hai il diritto di:',
        r1Label: 'Accesso',
        r1Desc: "Ottenere conferma dell'esistenza di un trattamento e accedere ai tuoi dati",
        r2Label: 'Rettifica',
        r2Desc: 'Richiedere la correzione di dati inesatti o incompleti',
        r3Label: 'Cancellazione',
        r3Desc: 'Chiedere la cancellazione dei dati ("Diritto all\'oblio")',
        r4Label: 'Limitazione',
        r4Desc: 'Richiedere la limitazione del trattamento',
        r5Label: 'Portabilità',
        r5Desc: 'Ricevere i dati in formato strutturato e leggibile',
        r6Label: 'Opposizione',
        r6Desc: 'Opporsi al trattamento in qualsiasi momento',
        r7Label: 'Revoca del consenso',
        r7Desc: 'Revocare il consenso prestato in precedenza',
        exercise: 'Per esercitare i tuoi diritti:',
        complaint: 'Diritto di Reclamo:',
        complaintBody: "Hai il diritto di proporre reclamo all'Autorità di controllo competente:",
        complaintAuthority: 'Andmekaitse Inspektsioon (Autorità Estone per la Protezione dei Dati)',
      },
      s8: {
        title: '8. Sicurezza dei Dati',
        intro: 'Adottiamo misure tecniche e organizzative appropriate per proteggere i tuoi dati personali:',
        items: [
          'Crittografia HTTPS per tutte le comunicazioni',
          'Accesso limitato ai dati personali solo al personale autorizzato',
          'Hosting su infrastrutture sicure e certificate',
          'Nessuna raccolta di dati di pagamento sul sito',
        ],
      },
      s9: {
        title: '9. Modifiche alla Privacy Policy',
        desc: 'Questa Privacy Policy può essere aggiornata periodicamente. In caso di modifiche sostanziali, pubblicheremo un avviso ben visibile sul sito. Ti invitiamo a consultare regolarmente questa pagina per rimanere informato su come proteggiamo i tuoi dati.',
      },
      contact: {
        title: 'Contatti',
        desc: 'Per qualsiasi domanda relativa alla presente Privacy Policy o al trattamento dei tuoi dati personali:',
        email: 'Email',
        dpo: 'DPO',
        address: 'Sede',
      },
    },
    termsOfService: {
      title: 'Termini di Servizio',
      subtitle: "Condizioni legali che regolano l'utilizzo dei Servizi offerti da ChartTower Corp. OÜ.",
      backToHome: 'Torna alla Home',
      lastUpdated: 'Ultimo aggiornamento:',
      lastUpdatedDate: '28 Febbraio 2026',
      s1: {
        title: '1. Accettazione dei Termini',
        p: "Accedendo al sito web l'Utente accetta incondizionatamente di essere vincolato dai presenti Termini di Servizio. Se l'Utente non accetta questi termini, è pregato di interrompere immediatamente l'utilizzo del sito web e dei Servizi offerti da ChartTower Corp. OÜ.",
      },
      s2: {
        title: '2. Divisione Finanza & Investimenti: fornitore di dati storici e software',
        p: "L'Utente riconosce e accetta che ChartTower Corp. OÜ non è un fornitore di Servizi finanziari certificato ai sensi delle normative territoriali di settore, e che opera esclusivamente come fornitore di tecnologia e analisi Dati. I vari Servizi meglio dettagliati in seguito consistono in analisi di mercato, segnali algoritmici e dati storici. Nessun contenuto fornito da ChartTower Corp. deve essere interpretato come \"consulenza in materia di investimenti\" personalizzata (ai sensi della Direttiva MiFID II o normative equivalenti).",
        warningTitle: "IL TRADING DI CFD, FOREX E CRIPTOVALUTE COMPORTA UN ALTO LIVELLO DI RISCHIO E PUÒ PORTARE ALLA PERDITA DELL'INTERO CAPITALE INVESTITO. L'Utente dichiara di essere consapevole che:",
        w1: 'I risultati storici (Backtest) che emergono dalle varie dashboard e reportistiche sui Servizi messe a disposizione degli utenti sono ipotetici e non garantiscono i risultati futuri.',
        w2: "L'utilizzo della leva finanziaria amplifica sia i guadagni che le perdite.",
        w3: 'L\'Utente dovrebbe investire solo capitali che può permettersi di perdere ("Risk Capital").',
      },
      s3: {
        title: '3. CTC Blue Strike',
        h1: 'Software, non gestione',
        h1p: "ChartTower Corp. fornisce software che elaborano dati di mercato e operano con parametri personalizzabili, in funzione del risultato di backtest eseguiti su intervalli di tempo pluriennali passati. L'Utente mantiene il pieno controllo della configurazione e quindi la responsabilità finale delle proprie decisioni di investimento. ChartTower Corp. non agisce come gestore patrimoniale e non ha accesso diretto ai fondi dell'Utente.",
        h2: 'VPS',
        h2p: 'CTC Blue Strike necessita installazione e configurazione su VPS di caratteristiche idonee a carico del cliente, se non diversamente concordato.',
        h3: 'Backtest e scarico di responsabilità',
        h3p1: "Vengono messi a disposizione dell'utente i risultati di backtest effettuati su periodi pluriennali pregressi per dare evidenza delle potenziali performance, senza tuttavia costituire alcuna garanzia di rendimenti futuri.",
        h3p2: "ChartTower Corp. non sarà responsabile nei confronti del Cliente né di eventuali terzi per perdite finanziarie, mancati profitti, perdite di opportunità, o altri danni indiretti, consequenziali o speciali derivanti dall'uso (o dal mancato uso, o dall'uso non conforme alle indicazioni e ai settaggi/parametri forniti) del software CTC Blue Strike.",
        h3p3: 'Esempi di "uso non conforme" che possono portare alla perdita dei propri fondi includono: interruzione manuale e improvvisa del collegamento alla VPS; modifica manuale dei settaggi preimpostati; apertura o chiusura manuale di ordini; tentativi di manomissione del software per qualsiasi finalità.',
        h4: 'Copyright',
        h4p: 'CTC Blue Strike è un software protetto da copyright. Ogni tentativo non autorizzato di copia, modifica, manomissione o rivendita verrà perseguito mediante ogni opportuna azione civile e/o penale.',
      },
      s4: {
        title: '4. CTC Algo Engine 2.0',
        h1: 'Sala segnali e natura informativa',
        h1p: 'Il Servizio consiste nella fornitura di flussi informativi generati da un algoritmo proprietario basato su logiche di analisi tecnica avanzata. Tali informazioni vengono distribuite sotto forma di "segnali didattici" strutturati, contenenti parametri quali Entry Point, Stop Loss e Take Profit multipli.',
        h2: 'Esecuzione manuale e Ordini Pendenti',
        h2p: "L'operatività suggerita dal Servizio si basa prevalentemente sull'utilizzo di ordini pendenti. L'Utente riconosce che tale modalità operativa implica necessariamente un intervento manuale di inserimento parametri sulla propria piattaforma di trading. Il Servizio si limita a fornire i livelli di prezzo; l'utente mantiene la piena ed esclusiva discrezionalità nel decidere se, quando e come eseguire tali ordini, mantenendo il totale controllo del proprio capitale. Non vi è alcuna connessione automatica tra l'algoritmo di ChartTower Corp. e il conto di trading dell'Utente.",
        h3: 'Terze Parti (Piattaforma di consegna)',
        h3p: "I segnali vengono distribuiti tramite piattaforme di messaggistica terze (Telegram). ChartTower Corp. non è responsabile per ritardi nella ricezione delle notifiche, malfunzionamenti dei server di messaggistica o mancata esecuzione dell'ordine dovuta a problemi tecnici della piattaforma dell'Utente o del Broker utilizzato.",
        h4: 'Backtest e scarico di responsabilità',
        h4p1: "Vengono forniti all'utente i risultati di simulazioni effettuate su periodi pluriennali pregressi per dare evidenza delle potenziali performance, senza tuttavia costituire alcuna garanzia di rendimenti futuri.",
        h4p2: "ChartTower Corp. non sarà responsabile nei confronti del Cliente né di eventuali terzi per perdite finanziarie, mancati profitti, perdite di opportunità, o altri danni indiretti, consequenziali o speciali derivanti dall'utilizzo dei segnali generati dal Servizio CTC Algo Engine 2.0.",
      },
      s5: {
        title: '5. CTC Copy Service',
        h1: 'Natura del Servizio, infrastruttura tecnologica e vincolo di piattaforma',
        h1p1: "L'Utente riconosce che la natura del Servizio è limitata alla fornitura di dati e impulsi telematici (segnali estratti da un conto Master proprietario di ChartTower Corp.). L'intera infrastruttura tecnologica di esecuzione, il matching degli ordini e la custodia dei fondi sono di proprietà esclusiva e sotto la responsabilità di terze parti (Broker).",
        h1p2: "Poiché la Strategia Master opera all'interno dei server del broker FPG, è requisito indispensabile che l'utente disponga di un conto attivo presso il medesimo intermediario per abilitare la connessione. Il servizio non è tecnicamente supportato né attivabile su piattaforme o broker terzi.",
        h2: 'Scarico di responsabilità',
        h2p: "ChartTower Corp. non sarà responsabile nei confronti del Cliente né di eventuali terzi per perdite finanziarie, mancati profitti, perdite di opportunità, o altri danni indiretti, consequenziali o speciali derivanti dall'utilizzo della replica automatica delle operazioni dei conti Master CTC Copy Service.",
      },
      s6: {
        title: '6. Divisione AI & Automation: personalizzazione e servizi su misura',
        p: "La divisione AI & Automation fornisce servizi elettronici su misura per realizzazione di siti internet, web-app, automazioni di flussi di lavoro e cyber security. Data la natura altamente personalizzata del servizio, le specifiche tecniche, i tempi di consegna, i costi e le funzionalità esatte di ogni progetto sono definiti caso per caso nella Proposta Commerciale sottoscritta tra le parti. In caso di conflitto tra i Termini generali e il contratto specifico, prevarrà quest'ultimo.",
        h1: 'Dipendenze da terze parti (API) e manutenzione',
        h1p: "L'Utente riconosce che le automazioni possono dipendere da servizi, API o piattaforme di terze parti (es. OpenAI, Telegram, Google, n8n). ChartTower Corp. non è responsabile per interruzioni, malfunzionamenti o modifiche unilaterali apportate da tali terze parti che potrebbero compromettere la funzionalità del prodotto consegnato. Salvo diversi accordi scritti (es. canone di manutenzione), il servizio si intende concluso al momento della consegna e collaudo. Eventuali aggiornamenti successivi richiesti a causa di modifiche esterne potranno essere oggetto di nuova quotazione.",
        h2: "Proprietà intellettuale (licenza d'uso)",
        h2p: "Salvo diversa pattuizione scritta, ChartTower Corp. mantiene la piena proprietà intellettuale (Copyright) del codice sorgente, delle librerie e dei metodi sviluppati. Al Cliente viene concessa una Licenza d'Uso perpetua, non esclusiva e non trasferibile per l'utilizzo del software all'interno della propria organizzazione. È fatto divieto al Cliente di rivendere, sub-licenziare o distribuire il codice sorgente del software a terzi a scopo di lucro, salvo diverso accordo scritto tra le parti.",
      },
      s7: {
        title: '7. Divisione Real Estate: Divisione in via di sviluppo',
        p: "L'Utente prende atto che la divisione Real Estate e i relativi contenuti descritti sul Sito sono attualmente in fase di sviluppo e strutturazione preliminare. Qualsiasi materiale informativo, render grafico, roadmap o proiezione economica presente in questa sezione ha natura illustrativa e non costituisce in alcun modo un'offerta al pubblico di risparmio o prodotti finanziari o una sollecitazione all'investimento immobiliare.",
        h1: 'Termini futuri',
        h1p: "Le condizioni legali, i requisiti di accesso e le modalità operative specifiche per la divisione Real Estate saranno disciplinate da Termini di Servizio che verrà pubblicato in seguito. ChartTower Corp. si riserva il diritto di riorganizzare lo sviluppo di tale divisione senza alcun preavviso e senza che ciò comporti alcuna responsabilità verso l'Utente.",
        h2: 'Manifestazioni di interesse e programmi pilota',
        h2p: "Nonostante lo stato di sviluppo della divisione, ChartTower Corp. si rende disponibile a valutare, su richiesta specifica e spontanea dell'Utente (reverse solicitation), l'opportunità di erogare servizi di consulenza preliminare o accessi anticipati a progetti pilota. L'Utente interessato può contattare l'azienda per una valutazione esplorativa. Tali interlocuzioni si intendono a titolo puramente informativo, senza alcun impegno vincolante per le parti e non costituiscono garanzia di erogazione del servizio. Eventuali accordi derivanti da tali contatti saranno formalizzati tramite contratti privati separati e personalizzati in base alle esigenze dello specifico caso.",
      },
    },
    cookiePolicy: {
      title: 'Cookie Policy',
      subtitle: 'Trasparenza totale su come utilizziamo i cookie. La tua privacy è la nostra priorità.',
      lastUpdated: 'Ultimo aggiornamento:',
      lastUpdatedDate: '20 Gennaio 2026',
      importantTitle: 'La Tua Privacy è Importante',
      importantP: 'ChartTower Corp. NON utilizza cookie di tracciamento, analytics di terze parti o cookie di marketing. Utilizziamo esclusivamente cookie tecnici strettamente necessari al funzionamento del sito.',
      whatTitle: 'Cosa sono i Cookie?',
      whatP1: "I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente (computer, smartphone, tablet) durante la navigazione. Vengono utilizzati per memorizzare informazioni e preferenze, migliorando l'esperienza di navigazione.",
      whatP2: 'La presente Cookie Policy è redatta in conformità al Regolamento (UE) 2016/679 (GDPR) e alla Direttiva 2002/58/CE (ePrivacy), come recepita dalle normative nazionali applicabili.',
      techTitle: 'Cookie Tecnici (Necessari)',
      techAlways: 'Sempre Attivi',
      techDesc: "Questi cookie sono essenziali per il funzionamento del sito web e non possono essere disabilitati. Vengono impostati in risposta ad azioni da te effettuate, come la gestione delle preferenze sulla privacy. Non richiedono il consenso dell'utente ai sensi dell'Art. 122 del Codice Privacy.",
      tableCol1: 'Cookie',
      tableCol2: 'Dominio',
      tableCol3: 'Durata',
      tableCol4: 'Finalità',
      row1Duration: '12 mesi',
      row1Purpose: "Memorizza le preferenze cookie dell'utente",
      row2Duration: 'Persistente',
      row2Purpose: 'Identificatore sessione ChatBot per continuità conversazione',
      analyticsTitle: 'Cookie Analitici',
      notUsed: 'Non Utilizzati',
      analyticsDesc: 'ChartTower Corp. non utilizza Google Analytics, Facebook Pixel o altri strumenti di tracciamento. Rispettiamo la tua privacy e non monitoriamo il tuo comportamento di navigazione.',
      marketingTitle: 'Cookie di Marketing e Profilazione',
      marketingDesc: 'Non utilizziamo cookie pubblicitari, di remarketing o per la profilazione degli utenti. Non vendiamo né condividiamo i tuoi dati con network pubblicitari.',
      thirdPartyTitle: 'Cookie di Terze Parti',
      thirdPartyP: 'Il nostro sito potrebbe includere contenuti incorporati (es. video, mappe) da servizi esterni. Questi servizi potrebbero impostare i propri cookie.',
      prefsTitle: 'Gestione delle Preferenze',
      prefsP: 'Puoi modificare le tue preferenze sui cookie in qualsiasi momento:',
      resetTitle: 'Reimposta le Preferenze Cookie',
      resetDesc: 'Clicca il pulsante sottostante per cancellare le tue preferenze salvate. Il banner di consenso comparirà nuovamente alla prossima visita.',
      resetBtn: 'Reimposta Preferenze Cookie',
      browserTitle: 'Impostazioni del Browser',
      browserDesc: 'Puoi anche gestire i cookie direttamente dalle impostazioni del tuo browser:',
      controllerTitle: 'Titolare del Trattamento',
      controllerCompany: 'Ragione Sociale',
      controllerAddress: 'Sede Legale',
      controllerDPO: 'DPO',
      moreInfoTitle: 'Ulteriori Informazioni',
      moreInfoP: 'Per informazioni complete sul trattamento dei tuoi dati personali, consulta la nostra Privacy Policy.',
      moreInfoBtn: 'Vai alla Privacy Policy',
    },
  },
  en: {
    nav: {
      home: 'Home',
      finance: 'Finance',
      realEstate: 'Real Estate',
      token: 'CTC Token',
      infoSocietarie: 'Corporate Info',
      community: 'Telegram Community',
      aiAutomation: 'AI & Automation'
    },
    common: {
      learnMore: 'Learn More',
      comingSoon: 'Coming Soon',
      live: 'LIVE',
      explore: 'Explore Ecosystem',
      buyCtc: 'Buy CTC',
      joinCommunity: 'Join Community',
      back: 'Back',
      viewPresentation: 'View Presentation',
      downloadList: 'List & Backtest',
      technicalSpecs: 'Technical Specs',
      glossary: 'Official CTC Glossary',
      recentPerformance: 'Recent Performance',
      partialRoadmapNote: 'You are viewing only the Roadmap for this section.',
      viewFullRoadmap: 'View Full Roadmap',
      verified: 'VERIFIED',
      screenshot: 'Screenshot',
      feedbackTitle: 'Verified Feedback & Real Results',
      viewMoreFeedback: 'View more feedback in Corporate Group',
      excellent: 'Excellent',
      copied: 'Copied!',
      copy: 'Copy',
      freeTrial: 'Request 1-Month Trial',
      contactChoice: 'Choose how to contact us:',
      contactEmail: 'Email',
      contactTelegram: 'Telegram',
      searchGlossary: 'Search a term...',
      noResultsFound: 'No terms found',
      tryAnotherKeyword: 'Try with another keyword'
    },
    cookies: {
      title: 'Cookie Usage',
      gdprCompliant: 'GDPR Compliant',
      description: 'We use essential cookies to ensure the proper functioning of the site and optional cookies to improve your experience. You can customize your preferences at any time.',
      acceptAll: 'Accept All',
      rejectAll: 'Necessary Only',
      customize: 'Customize',
      savePreferences: 'Save Preferences',
      back: 'Back',
      required: 'Required',
      learnMore: 'For more information, see our',
      privacyPolicy: 'Privacy Policy',
      necessary: {
        title: 'Necessary Cookies',
        desc: 'Essential for the site to function. Cannot be disabled.'
      },
      analytics: {
        title: 'Analytics Cookies',
        desc: 'Help us understand how visitors interact with the site by collecting anonymous data.'
      },
      marketing: {
        title: 'Marketing Cookies',
        desc: 'Used to track visitors across websites and display relevant ads.'
      }
    },
    socialSection: {
      titlePart1: 'OFFICIAL',
      titlePart2: 'CHANNELS',
      subtitle: 'A structured communication ecosystem to ensure transparency, support, and timely updates.',
      telegramTitle: 'Telegram Ecosystem',
      telegramDesc: 'Three distinct channels for every need: corporate information, token updates, and community.',
      telegramChannels: {
        corporate: {
          title: 'Official Corporate Group',
          desc: 'Access on Approval. The operational heart: Real Estate, Finance, Market Analysis, and News services. Find results and reviews here first.',
          action: 'Request Access'
        },
        token: {
          title: 'CTC Token Channel',
          desc: 'Public official channel. Only verified announcements and important news regarding the CTC Token and Roadmap.',
          action: 'Join Channel'
        },
        community: {
          title: 'CTC Token Community',
          desc: 'Public group open to all. Dedicated topics for Governance, Technical Support, Airdrops, and general discussions. Protected by Recaptcha.',
          action: 'Join Community'
        }
      },
      twitter: 'X (Twitter)',
      twitterDesc: 'The reference point for the crypto ecosystem. Real-time updates, partnerships, and direct interaction with the DeFi community.',
      instagram: 'Instagram',
      instagramDesc: 'Our visual showcase: Blue Strike results, Algo Engine monthly performance, client reviews, and service illustrations.'
    },
    feedSection: {
      title: 'Wall of Excellence',
      subtitle: 'Real results, Transparent feedback. We constantly update the community with our service performance and client opinions.',
      viewAll: 'View all in Corporate Group'
    },
    home: {
      hero: {
        badge: 'AI & AUTOMATION FOR PRIVATE & BUSINESS - LIVE',
        titlePart1: 'ChartTower',
        titlePart2: 'Corp.',
        subtitle: 'Inspired by the fear of being average.',
        cards: {
          corporate: 'Corporate',
          corporateDesc: 'Company data and transparency',
          finance: 'Finance',
          financeDesc: 'Management and investments',
          token: 'CTC Token',
          tokenDesc: 'Utility token on Solana',
          realEstate: 'Real Estate',
          realEstateDesc: 'Real estate portfolio'
        },
        verify: {
          title: 'Verifiable Data',
          companyNameLabel: 'Company Name',
          companyNameValue: 'ChartTower Corp. OÜ',
          regLabel: 'Registration Number',
          regValue: '17288413',
          leiLabel: 'LEI Code',
          leiValue: '9845001C375D5E411F72',
          legalLabel: 'Legal Address',
          legalValue: 'Ruunaoja 3, 11415 Tallinn, Estonia',
          tokenComplianceLabel: 'Token Compliance', // Updated Label
          tokenComplianceValue: 'CTC Token MICA Compliant', // Updated Value
          button: 'Learn More'
        }
      },
      structure: {
        titlePart1: 'CORPORATE',
        titlePart2: 'STRUCTURE',
        description: 'Every relevant piece of information regarding our integrated management combining various asset types will always be made available to the public, from holdings in diversified financial assets to real estate properties, as well as CTC token shares held by the Treasury.',
        cards: {
          finance: 'Finance & Investment Division',
          financeDesc: 'Diversified portfolio management, risk management, and total transparency to optimize returns.',
          realEstate: 'Real Estate Division',
          realEstateDesc: 'Strategic investments in the real estate sector building a value reserve for the ecosystem.',
          token: 'CTC Token',
          tokenDesc: 'Utility token on Solana network with cashback, dedicated discounts, and ecosystem yields.',
          aiAutomation: 'AI & Automation',
          aiAutomationDesc: 'Intelligent solutions to automate business processes and optimize productivity.'
        }
      },
      roadmap: {
        leftCard: {
          title: 'Dynamic Roadmap',
          desc: 'An interactive timeline tracking every project milestone: from White Paper publication to private sale, from liquidity pool launch to airdrops, up to Finance and Real Estate division services.',
          bullets: [
            'Real-time updates',
            'Historical version available',
            'Indicative dates and technical deliverables'
          ]
        },
        rightContent: {
          titlePart1: 'TRANSPARENT',
          titlePart2: 'ROADMAP',
          desc1: 'The ChartTower Dynamic Roadmap guides you step-by-step through the present and future of the project. Every achieved goal is documented, every future milestone is planned with indicative dates and clear deliverables.',
          desc2: 'From the MiCA EU regulatory path to operational services, from token management to real estate developments: everything is traceable and verifiable by the community.',
          button: 'View Roadmap'
        },
        teaser: {
          q3Title: 'Company Setup',
          q3Status: 'Completed',
          q4Title: 'Token & Finance',
          q4Status: 'Completed',
          q1Title: 'Expansion',
          q1Status: 'In Progress'
        }
      },
      stats: {
        transparency: '100% TRANSPARENCY',
        transparencyLabel: 'TRANSPARENCY',
        solana: 'SOLANA BLOCKCHAIN NETWORK',
        solanaLabel: 'NETWORK',
        live: 'LIVE LIQUIDITY POOL',
        liveLabel: 'LIQUIDITY POOL',
        support: '24/7 COMMUNITY SUPPORT',
        supportLabel: 'SUPPORT',
        verifiable: '100%',
        verifiableLabel: 'VERIFIABLE',
        publicWallets: '9',
        publicWalletsLabel: 'PUBLIC WALLETS'
      },
      testimonials: {
        title: 'What they say about us',
        reviews: [
          {
            text: 'Great signals, following for months and results speak clearly. Very useful dashboard to monitor performance!',
            author: 'Algo Engine Client',
            service: 'Algo Engine',
            date: '2025-11-01'
          },
          {
            text: 'Good evening Andrea, this morning thanks to CTC Blue Strike\'s performance I woke up with a smile 😁. Thank you for introducing me to this product, I am more and more satisfied that I invested in it... thank you so much 🙏🔥🔥',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2025-12-01'
          },
          {
            text: 'NOTHING TO SAY, THE EARLY BIRD CATCHES THE WORM 💰🔥 You are welcome dear, thanks to you 💪🏻',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2025-12-22'
          },
          {
            text: 'After CTC Blue Strike took a day off 🤣 today it came back performing better than ever 🔥🔥💪',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2026-01-01'
          },
          {
            text: 'A great wake up this morning thanks to Blue Strike software. A great start to the week🔥',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2026-01-12'
          },
          {
            text: 'Good morning again from the automatic software I would say 😂😂🔥🔥 Yes I would say so, can\'t wait for it to continue making these returns 💪🏻',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2026-01-16'
          },
          {
            text: 'Attaching today\'s software history. Starting to grind😁 few but good💪',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2026-01-30'
          },
          {
            text: 'Zero stress, perfect replication. Total transparency on commissions. Starting soon with Copy too charged up🔥🔥🔥',
            author: 'Copy Service Client',
            service: 'Copy Service',
            date: '2026-01-30'
          },
          {
            text: 'Mega profit anyway🚀 Would you recommend this service?😁 Absolutely yes 🔥🔥🔥',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2026-02-01'
          },
          {
            text: 'Hi Andrea, well what can I say, the morning brings gold AND silver 😂 💪💪🔥, all thanks to your great services, CTC Blue Strike and Copy trading... thank you so much ☺️',
            author: 'Blue Strike & Copy Service Client',
            service: 'Blue Strike',
            date: '2026-02-23'
          },
          {
            text: 'In less than 3 months I recovered the full cost of the service plus another $1000! It\'s insane 😍',
            author: 'Blue Strike & Copy Service Client',
            service: 'Blue Strike',
            date: '2026-02-25'
          },
          {
            text: 'Absolutely yes, these are services worthy of being called that! Compared to all the things you read on the internet, buy a course here, spend money there and you\'ll be successful blah blah blah, this actually works!',
            author: 'Blue Strike & Copy Service Client',
            service: 'Copy Service',
            date: '2026-02-25'
          },
          {
            text: 'Hi Andrea, I have to say we couldn\'t have started the week better 💪💪',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2026-03-16'
          },
          {
            text: 'Conflicts or not, Blue Strike doesn\'t care, in fact it brought us some volatility to exploit!! It\'s incredible ahaha I\'ve officially made more than 50% in about 5 months 😁😁',
            author: 'Blue Strike Client',
            service: 'Blue Strike',
            date: '2026-04-08'
          }
        ]
      },

      ecosystem: {
        title: 'Technology Stack & Ecosystem',
        solana: 'SOLANA',
        solanaDesc: 'Blockchain',
        raydium: 'RAYDIUM',
        raydiumDesc: 'Liquidity',
        telegram: 'TELEGRAM',
        telegramDesc: 'Community',
        estonia: 'ESTONIA',
        estoniaDesc: 'Regulation',
        button: 'Join Community'
      },
      faq: {
        title: 'Frequently Asked Questions',
        items: [
          {
            question: 'What is the CTC token?',
            answer: 'CTC is the utility token of ChartTower Corp., built on Solana blockchain. It offers automatic cashback on services paid in fiat, dedicated discounts when paying in CTC, governance participation, and periodic airdrops. Total supply: 21 million CTC, MICA EU Compliant.'
          },
          {
            question: 'What services do you offer?',
            answer: 'We offer three active financial services: CTC Blue Strike (24/7 Expert Advisor on XAU/USD), CTC Algo Engine (algorithmic signals room with real-time dashboard), and CTC Copy Service (automatic replication via FPG broker). We are also developing the Real Estate Division and AI & Automation services.'
          },
          {
            question: 'How can I verify company transparency?',
            answer: 'All 9 official wallets are publicly verifiable on-chain on Solscan 24/7. Official documents (White Paper, Articles, Registration Receipt) are available on the website. Blue Strike performance is certified on MyFXbook with verified trading privileges.'
          },
          {
            question: 'Where can I buy the CTC token?',
            answer: 'The CTC token is available on Solana decentralized exchanges (DEX): Raydium and Jupiter. You can buy it by swapping SOL or USDC. The liquidity pool is live on Raydium with LP tokens burned for security.'
          },
          {
            question: 'What is the Dynamic Roadmap?',
            answer: 'It is an interactive tool showing the project progress status in real-time. It tracks every milestone: from company incorporation to token launch, from financial services to real estate developments. It also includes a historical version for consultation.'
          },
          {
            question: 'Are you regulated?',
            answer: 'Yes. ChartTower Corp. OÜ is registered in Estonia with verifiable LEI Code 9845001C375D5E411F72. The CTC token is MICA EU Compliant with White Paper notified according to European Markets in Crypto-Assets regulation, ensuring maximum transparency and investor protection.'
          },
          {
            question: 'What are the benefits of holding CTC?',
            answer: 'By holding CTC you get: automatic cashback when paying for services in fiat, exclusive discounts when paying in CTC, priority access to new services, participation in periodic airdrops, and ecosystem governance. The more CTC you hold, the greater the benefits.'
          },
          {
            question: 'How can I try the financial services?',
            answer: 'For Blue Strike and Algo Engine you can request a 1-month trial via the button on the respective service pages. For Copy Service, contact us via email (info@ctc-corp.eu) or Telegram. The trial allows you to personally test the performance.'
          }
        ]
      },
      bottomCta: {
        titlePart1: 'ENTER THE ECOSYSTEM',
        titlePart2: 'ChartTower',
        description: 'Join the community and discover how the CTC token can transform your investment approach. Transparency, concrete returns, and an ever-growing network.',
        btn1: 'Join Community',
        btn2: 'Buy CTC'
      }
    },
    finance: {
      heroTitle: 'FINANCE & INVESTMENTS',
      heroDesc: 'Professional strategies for your capital growth.',
      activeServicesTitle: 'SERVICES',
      activeServicesSubtitle: 'ACTIVE',
      badgeOperative: 'OPERATIONAL NOW',
      services: {
        blueStrike: {
          title: 'CTC Blue Strike',
          subtitle: '24/7 Expert Advisor on XAU/USD',
          badge: 'EXPERT ADVISOR 24/7',
          f1: 'MyFXbook Monitoring',
          f2: 'Total Transparency',
          f3: 'Advanced Synergic Strategies',
          detailedDesc: 'CTC Blue Strike is our flagship Expert Advisor, operating 24/7 on the XAU/USD (Gold) pair. The software works on breakout with 6 independent strategies that can work in synergy or detached. Fully automatic, includes "slippage optimizer" to avoid surprises during news.',
          amazonBanner: {
            title: 'COMING SOON ON AMAZON',
            desc: 'We are working to bring Blue Strike to the world\'s largest marketplace. Time-limited licenses (e.g. 3 or 6 months) will be available in addition to the lifetime license option, making it accessible for everyone to test and personally verify our Expert Advisor\'s performance.'
          },
          specs: [
            { label: 'Asset', value: 'XAU/USD (Gold)' },
            { label: 'Profit Factor', value: '1.47 (Verified 6 Years)' },
            { label: 'Net Profit', value: '+27.672% (Compound)' },
            { label: 'Max Drawdown', value: '0.08% (Compound)' },
            { label: 'Win Rate', value: '55% (3907 Trades)' },
            { label: 'Strategies', value: '6 Independent' }
          ],
          glossary: [
            { term: 'Absolute Drawdown', def: 'Maximum difference between initial capital and minimum balance reached during the test. Lower is better.' },
            { term: 'Average Profit/Loss Trade', def: 'Average gain for winning trades and loss for losing trades. Ratio must be > 1 to be profitable.' },
            { term: 'Backtest Quality', def: 'Percentage indicating how faithfully the simulation reproduces real historical market conditions. 99% is excellent.' },
            { term: 'Bars in Test', def: 'Total number of time units (candles) considered in the backtest simulation. Higher numbers mean more reliable tests.' },
            { term: 'Expected Payoff', def: 'Average expected gain (or loss) for each individual trade executed. Must be positive.' },
            { term: 'Gross Loss', def: 'Sum of all losing trades, without considering gains. Indicates operational cost of losses.' },
            { term: 'Gross Profit', def: 'Sum of all winning trades, without subtracting losses. Must exceed Gross Loss.' },
            { term: 'Initial Deposit', def: 'Starting capital for the backtest. Standard €1,000 for uniformity.' },
            { term: 'Largest Loss Trade', def: 'The single trade that generated the largest loss. Should never compromise capital.' },
            { term: 'Largest Profit Trade', def: 'The single trade that generated the largest gain. If too high, could be a coincidence.' },
            { term: 'Lot', def: 'Size of the position opened in the market. It is the "weight" of each trade (0.01 = micro lot).' },
            { term: 'Lot Size Step', def: 'Automatic rule increasing lot size as capital grows (compounding).' },
            { term: 'Loss Trades (%)', def: 'Percentage of losing trades. Even 45% is acceptable if profits cover losses.' },
            { term: 'Magic Number', def: 'Unique ID assigned to the bot to distinguish and manage its operations.' },
            { term: 'Maximal Drawdown', def: 'Maximum loss suffered from the highest equity peak to the subsequent lowest point.' },
            { term: 'Modelling Quality', def: 'Accuracy of historical data used. 99% means every tick is real.' },
            { term: 'Net Profit Percent', def: 'Total percentage growth of capital relative to the initial deposit.' },
            { term: 'Profit Factor', def: 'Ratio between total gross profit and total gross loss. > 1.0 means profit.' },
            { term: 'Profit Trades (%)', def: 'Percentage of winning trades. > 50% is generally good.' },
            { term: 'Relative Drawdown', def: 'Maximum drawdown expressed as a percentage of capital at the peak.' },
            { term: 'Short Positions (won %)', def: 'Success rate in short selling operations (betting on price drop).' },
            { term: 'Slippage', def: 'Difference between expected price and real execution price. Optimizer tries to reduce it.' },
            { term: 'Spread', def: 'Transaction cost (difference between ask and bid price). Lower is better.' },
            { term: 'Take Profit / Stop Loss', def: 'Automatic closure levels for profit (TP) or loss (SL) to protect capital.' },
            { term: 'Ticks Modeled', def: 'Total number of price changes considered. Millions of ticks indicate high precision.' },
            { term: 'Total Net Profit', def: 'Final net gain (Final Capital - Initial Capital).' },
            { term: 'Total Trades', def: 'Total number of executed operations. A valid statistical sample requires many trades.' },
            { term: 'Max Consecutive Wins/Losses', def: 'Longest streak of consecutive winning or losing trades.' },
            { term: 'Max Consecutive Profit/Loss', def: 'Amount gained or lost during the longest consecutive streak.' },
            { term: 'Long Positions (won %)', def: 'Success rate in buying operations (betting on price rise).' }
          ],
          monitoring: {
            title: 'Certified Monitoring',
            desc: 'CTC Blue Strike performance is monitored and certified by MyFXbook. Total transparency allowing every user to verify historical returns in real-time.',
            btn: 'Go to MyFXbook',
            verified: 'VERIFIED',
            privileges: 'Trading Privileges Verified'
          },
          apiDashboard: {
            title: 'Real-Time MyFXBook Dashboard',
            desc: 'Integrated dashboard that uses MyFXBook to display real-time performance data directly on our website.',
            button: 'Go to Live Dashboard',
            feature1: 'Real-Time Data',
            feature1Desc: 'MyFXBook integration for live performance updates',
            feature2: 'Interactive Charts',
            feature2Desc: 'Advanced visualization of equity, drawdown, and trading statistics',
            feature3: 'Complete History',
            feature3Desc: 'Access to all historical data and performance metrics',
            feature4: 'Total Transparency',
            feature4Desc: 'All trades and operations visible in a single interface'
          },
          backtest: {
            title: 'Backtest Verification (2018 - 2023)',
            netProfit: '+27.672%',
            netProfitLabel: 'Total Net Profit',
            maxDrawdown: '0.08%',
            maxDrawdownLabel: 'Max Drawdown',
            profitFactor: '1.47',
            profitFactorLabel: 'Profit Factor',
            totalTrades: '3.907',
            totalTradesLabel: 'Total Trades'
          }
        },
        algoEngine: {
          title: 'CTC Algo Engine',
          subtitle: 'Algorithmic Signal Room',
          badge: 'ALGORITHMIC SIGNALS',
          telegramBtn: 'Get Signals on Telegram',
          pricelistBtn: 'Download Pricelist',
          f1: 'Real-time Dashboard',
          f2: 'Monthly PDF Reports',
          f3: 'Demo Account Included',
          detailedDesc: 'CTC Algo Engine is our professional algorithmic signal room providing market analysis and operational triggers on Forex, Indices, and Crypto. Based on proprietary Core v2.4 algorithmic engines, the service integrates a real-time dashboard to monitor every trade, success rates, and complete monthly history. Detailed monthly PDF reports downloadable directly from the dashboard.',
          updating: {
            title: 'Updating',
            subtitle: 'We are updating the service infrastructure.',
            cta: 'Stay tuned!'
          },
          dashboard: {
            title: 'Real-Time Dashboard Available',
            desc: 'Monitor every trade in real-time, success rates, and monthly history. Interactive dashboard with advanced charts, customizable filters, and downloadable PDF reports for each month.',
            button: 'Open Live Dashboard'
          },
          specs: [
            { label: 'September 2025', value: '+4.070 Pips' },
            { label: 'October 2025', value: '+17.770 Pips' },
            { label: 'November 2025', value: '+18.155 Pips' },
            { label: 'December 2025', value: '+15.920 Pips' },
            { label: 'Asset Class', value: 'Forex, Indices, Crypto' }
          ]
        },
        copyService: {
          title: 'CTC Copy Service',
          subtitle: 'Automatic Trade Replication',
          badge: 'AUTO-TRADING REPLICATION',
          btn: 'Activate Copy Service',
          f1: 'Automatic Connection',
          f2: 'Real-time Replication',
          f3: 'Official Partner FPG',
          detailedDesc: 'The CTC Copy Service offers automatic replication of our Reactive Swing Logic. Fully operational since mid-January through our partner Broker FPG, this service allows you to replicate operations we have successfully used for over two years on Forex, Commodity, and Crypto markets.',
          partner: {
            title: 'Exclusive Partner',
            name: 'FPG Broker',
            desc: 'The service is managed in exclusive partnership with FPG to ensure maximum reliability, execution speed, and fund security.'
          },
          logic: [
            { title: 'Dynamic Logic', desc: 'Day-by-Day volatility analysis to adapt Take Profit and Stop Loss to real market conditions.' },
            { title: 'Risk Management', desc: 'No grid or martingale. Only one trade at a time with a focus on capital preservation.' },
            { title: 'Markets & Assets', desc: 'Medium-long term swing trading on Forex, Commodity (XAU/USD), and selected Cryptocurrencies.' },
            { title: 'Advanced Take Profit', desc: '3 dynamic TP levels (33% closing each) and Stop Loss at Breakeven after the first target.' }
          ],
          steps: [
            { title: 'Open FPG Account', desc: 'Open an account with our official partner broker FPG following the guided procedure.' },
            { title: 'Quick Connection', desc: 'Connect your account to the CTC Copy Service replication system in just a few clicks.' },
            { title: 'Relax & Monitor', desc: 'Let the swing logic work for you and monitor results from your device.' }
          ],
          benefits: [
            { title: 'Reactive Swing Logic', desc: 'Strategy based on imbalances and level breaks with significant price extensions.' },
            { title: 'Zero Latency', desc: 'Infrastructure optimized with partner FPG for instant order replication.' },
            { title: 'Full Control', desc: 'Maximum transparency with the ability to stop copying at any time.' }
          ]
        },
      },
    },
    realEstate: {
      heroTitle: 'REAL ESTATE',
      heroDesc: 'The Real Estate division combines the solidity of brick with innovative investment models. Leveraging the ChartTower ecosystem benefits and through strategic and targeted investment studies, we will build a real estate portfolio over time that serves as a value reserve for the ecosystem itself.',
      comingSoon: 'Coming Soon',
      pillars: {
        title: 'OUR',
        titlePart2: 'PILLARS',
        subtitle: 'Every real estate investment is carefully selected to ensure lasting value and sustainable returns.',
        cards: {
          solidity: 'Brick Solidity',
          solidityDesc: 'Real estate investments combining traditional stability with innovative models.',
          strategic: 'Strategic Portfolio',
          strategicDesc: 'Targeted investment study to build a value reserve for the ChartTower ecosystem.',
          ecosystem: 'Ecosystem Benefits',
          ecosystemDesc: 'Full exploitation of CTC ecosystem benefits to maximize returns.',
        }
      },
      strategy: {
        title: 'INVESTMENT',
        titlePart2: 'STRATEGY',
        description: 'Our real estate investment strategy is based on three fundamental principles: accurate selection, geographical diversification, and professional management. Each property is evaluated not only for its current value but for long-term growth potential.',
        items: {
          growth: 'Sustainable Growth',
          growthDesc: 'Targeted investments in areas with strong appreciation potential',
          risk: 'Risk Management',
          riskDesc: 'Geographical and typological asset diversification',
          positions: 'Strategic Positions',
          positionsDesc: 'Selection of properties in high-value locations'
        },
        portfolio: {
          title: 'Real Estate Portfolio',
          residential: 'Residential Assets',
          commercial: 'Commercial Assets',
          development: 'Project Development',
          desc: 'The portfolio is constantly evolving and optimized to maximize returns and reduce risks.',
          button: 'Learn More'
        }
      },
      vision: {
        title: 'OUR VISION',
        description: 'We believe real estate represents a fundamental pillar for the stability and growth of the ChartTower ecosystem. Through professional and transparent management, we build a real estate heritage generating sustainable value over time, contributing to the project\'s solidity and returns for CTC token holders.',
        stats: {
          transparency: '100%',
          transparencyLabel: 'TRANSPARENCY',
          longTerm: 'LONG-TERM',
          longTermLabel: 'VISION',
          global: 'GLOBAL',
          globalLabel: 'DIVERSIFICATION'
        }
      },
      requestInfoBtn: 'Request More Info'
    },
    token: {
      hero: {
        badge: 'LIQUIDITY POOL LIVE ON RAYDIUM',
        titlePart1: 'TOKEN',
        titlePart2: 'CTC',
        description: 'The heart of the ChartTower ecosystem: a utility token based on the Solana network providing access to exclusive services and creating a sustainable circular economy.',
        buyBtn: 'Buy on Raydium',
        whitepaperBtn: 'Read White Paper',
        check1: 'Solana Blockchain',
        check2: '9 Official Wallets',
        check3: 'MICA COMPLIANT',
        card: {
          title: 'CTC Token',
          subtitle: 'Utility Token • Solana Network',
          item1Title: 'BENEFITS OF HOLDING CTC TOKEN',
          item1Desc: 'Discounts, cashback, and special rewards in every airdrop',
          item2Title: 'MICA COMPLIANT',
          item2Desc: 'White Paper notified to competent bodies and inserted in ESMA registers',
          item3Title: 'CIRCULAR ECONOMY',
          item3Desc: 'Transparent and sustainable tokenomics'
        }
      },
      contract: {
        titlePart1: 'CONTRACT',
        titlePart2: 'ADDRESS',
        addressLabel: 'Program ID / Contract Address',
        copyBtn: 'Copy Address',
        solscanBtn: 'Solscan',
        dtiLabel: 'DTI Code',
        dtiIdLabel: 'Digital Token Identifier',
      },
      distribution: {
        titlePart1: 'TOKEN',
        titlePart2: 'DISTRIBUTION',
        description: 'The token distribution is designed to ensure long-term sustainability, with utility benefits rewarding holders via discounts or cashback, and Corporate Treasury management mechanisms designed to support ecosystem growth.',
        items: [
          { label: 'Corporate Treasury', percentage: '38%', amount: '7.980.000 CTC', desc: 'Locked by stringent liquidity conditions, including ban on direct CEX/DEX sales and mandatory BTC accumulation (2-5% of net profits)' },
          { label: 'Public CEX Listing', percentage: '15%', amount: '3.150.000 CTC', desc: 'Dedicated allocation for listings on public centralized exchanges' },
          { label: 'Founders', percentage: '12%', amount: '2.520.000 CTC', desc: 'Progressive token unlock on multiple project milestones, excluding operational management' },
          { label: '2nd Airdrop', percentage: '10%', amount: '2.100.000 CTC', desc: 'Calculated via smart contract based on average token holdings during specific periods' },
          { label: '3rd Airdrop', percentage: '10%', amount: '2.100.000 CTC', desc: 'Calculated via smart contract based on average token holdings during specific periods' },
          { label: 'Liquidity Pool on Raydium DEX', percentage: '9%', amount: '1.890.000 CTC', desc: 'Tokens generated by Raydium immediately burned to prevent USDC withdrawals' },
          { label: '1st Airdrop', percentage: '4%', amount: '840.000 CTC', desc: 'Distributed through interactive mechanisms based on knowledge of the ChartTower ecosystem and the crypto world in general' },
          { label: 'Private Sale', percentage: '2%', amount: '420.000 CTC', desc: 'Limited to 20,000 tokens per wallet at 0.005 USDC/token (completed)' }
        ]
      },
      whitepaper: {
        titlePart1: 'WHITE',
        titlePart2: 'PAPER',
        description: 'The ChartTower Corp. White Paper details the vision, technical architecture, tokenomics, and project roadmap. A comprehensive document illustrating how the CTC ecosystem integrates traditional finance, real estate, and blockchain to create sustainable value.',
        downloadBtn: 'Download White Paper (PDF)',
        cards: [
          { title: 'Vision & Mission', desc: 'ChartTower Corp. aims to create an integrated financial ecosystem combining traditional finance, real estate, and blockchain benefits. Our mission is to democratize access to professional financial services through innovative technologies and total transparency.' },
          { title: 'Technical Architecture', desc: 'The CTC token is built on Solana blockchain, chosen for its high performance, low transaction fees, and scalability. The infrastructure ensures security, speed, and global accessibility for all ecosystem users.' },
          { title: 'Tokenomics', desc: 'Token distribution is designed for long-term sustainability, with utility mechanisms rewarding holders and supporting ecosystem growth through cashback, governance, and operational activity returns.' }
        ]
      },
      utility: {
        titlePart1: 'Utility Token',
        titlePart2: 'Mechanisms',
        comingSoon: 'Coming Soon',
        cards: [
          { title: 'Automatic Cashback', desc: 'Soon active cashback mechanisms: when paying for ChartTower ecosystem services in fiat currency, automatically receive a refund in CTC tokens. A system rewarding loyalty and incentivizing continuous service use.' },
          { title: 'Discounts with CTC Payment', desc: 'Dedicated discounts if paying in CTC: using CTC tokens to purchase Finance & Investment or Real Estate services grants exclusive discounts and preferential conditions reserved only for holders.' }
        ]
      },
      compliance: {
        titlePart1: 'Regulatory Compliance',
        titlePart2: 'MICA EU',
        description: 'CTC Token is issued in full compliance with European regulations. The White Paper has been notified under MICA EU (Markets in Crypto-Assets), the new EU regulatory framework for crypto-assets, ensuring maximum transparency, investor protection, and compliance with international standards.',
        checks: ['EU Regulation', 'Total Transparency', 'Investor Protection']
      },
      metrics: {
        titlePart1: 'TOKEN',
        titlePart2: 'METRICS',
        items: [
          { value: 'SOLANA', label: 'BLOCKCHAIN' },
          { value: 'LIVE', label: 'LIQUIDITY POOL' },
          { value: '9', label: 'OFFICIAL WALLETS' },
          { value: '24/7', label: 'SUPPORT' }
        ]
      }
    },
    corporateInfo: {
      hero: {
        titlePart1: 'CORPORATE',
        titlePart2: 'INFORMATION',
        subtitle: 'Total transparency: all verifiable company data, official wallets, and ChartTower Corp. legal documentation.',
      },
      about: {
        title: 'Who We Are & Our Story',
        readMore: 'Read more',
        readLess: 'Show less',
        advantagesTitle: 'Exclusive advantages:',
        paragraphs: [
          'ChartTower Corp. was born from a group of friends united by the same ambition: to build something solid, innovative, and lasting. A journey that began with curiosity and determination, driven by the desire to deeply understand the functioning of markets and the real economy, and to transform theory into concrete value.',
          'It has not been a linear path: we made mistakes, gathered experiences, learned the hard way. But it is precisely through these steps that we developed a mindset based on continuous study, critical analysis, and constant evolution. It is from this spirit that our core values are born: quality, trust, and above all transparency.',
          'ChartTower Corp. is founded on a clear vision: to unite different sectors and make them complementary by also leveraging blockchain technology. This vision takes concrete form with the issuance of CTC Token, a utility token developed on the Solana network, designed to organically integrate the services offered by our business Divisions.',
          'To further increase the potential of the two Divisions, we are exploring the benefits of AI & Automation to optimize processes for individuals and businesses. The same reporting tools for investment instruments we offer, already available in real-time on this website, are being automated and will be completed soon.',
          'Thanks to this modular and integrated structure, ChartTower Corp. is able to interface with any type of client, offering tailor-made services. CTC Token represents the common thread of our entire ecosystem: those who hold it can access advantages on token holding itself and special conditions on every service of our Divisions.'
        ],
        advantages: [
          'The Real Estate Division stands out for solidity, structure, and adherence to the traditional economic world.',
          'The Finance & Investments Division leverages our market experience, offering dynamic and accessible solutions.'
        ]
      },
      team: {
        titlePart1: 'OPERATIONAL',
        titlePart2: 'TEAM',
        description: 'ChartTower Corp.\'s team consists of the founders who lead the company\'s strategic divisions, combining financial expertise, real estate vision, and technological competence.',
        members: [
          {
            name: 'Andrea Cascino',
            role: 'Founder',
            title: 'CEO Finance & Investments Division',
            areas: ['AI & Automation']
          },
          {
            name: 'Luca Marcialli',
            role: 'Founder',
            title: 'CEO Real Estate Division',
            areas: ['Legal & Compliance']
          },
          {
            name: 'Thomas Tapella',
            role: 'CTO',
            title: 'IT Manager',
            areas: ['AI & Automation']
          }
        ]
      },
      data: {
        titlePart1: 'COMPANY',
        titlePart2: 'DATA',
        companyNameLabel: 'COMPANY NAME',
        companyNameValue: 'ChartTower Corp. OÜ',
        regNumberLabel: 'REGISTRATION NUMBER',
        regNumberValue: '17288413',
        leiCodeLabel: 'LEI CODE',
        leiCodeValue: '9845001C375D5E411F72',
        emailLabel: 'EMAIL',
        emailValue: 'info@ctc-corp.eu',
        addressLabel: 'LEGAL ADDRESS',
        addressValue: 'Ruunaoja 3, 11415 Tallinn, Estonia',
        addressSub: '(c/o Nomad Consulting OÜ)',
        docs: {
          title: 'Document Archive',
          whitepaper: 'White Paper',
          whitepaperSub: 'MICA Compliant',
          registration: 'Registration Receipt',
          registrationDate: '23/07/2025',
          registrationUrl: 'https://ctc-corp.eu/wp-content/uploads/2025/08/Iscrizione-registro-imprese-arakiri_A_50287702.pdf',
          statute: 'Corporate Statute',
          statuteDate: '23/07/2025',
          statuteUrl: 'https://ctc-corp.eu/wp-content/uploads/2025/08/ChartTower_Corp._OU-pohikiri_3556957.pdf'
        }
      },
      wallets: {
        titlePart1: 'CORPORATE',
        titlePart2: 'WALLETS',
        subtitle: 'The 9 official ChartTower Corp. wallets on the Solana network. All addresses are publicly verifiable on-chain.',
        colDest: 'DESTINATION',
        colAddr: 'WALLET ADDRESS',
        colAction: 'ACTIONS',
        copy: 'Copy',
        solscan: 'Solscan',
        items: walletItemsEn
      },
      roadmap: {
        titlePart1: 'DYNAMIC',
        titlePart2: 'ROADMAP',
        subtitle: 'The Dynamic Roadmap guides step-by-step through the present and future of the project. Every milestone is tracked to ensure transparency for investors and the community.',
        btnRealtime: 'Real-time Milestones',
        btnHistory: 'Historical Version',
        notionLabel: 'Extended Roadmap on Notion',
        filters: {
          all: 'All',
          completed: 'Completed',
          inprogress: 'In Progress',
          planned: 'Planned',
        },
        items: [
          { title: 'Company Incorporation & Compliance', status: 'completed', statusLabel: 'Completed', desc: 'ChartTower Corp. OÜ registration in Estonia and LEI code acquisition.', date: 'Q3 2025', category: 'corporate' },
          { title: 'White Paper Release & Tokenomics', status: 'completed', statusLabel: 'Completed', desc: 'Publication of technical documentation and token economic structure.', date: 'Q3 2025', category: 'token' },
          { title: 'Private Sale', status: 'completed', statusLabel: 'Completed', desc: 'Initial token allocation to strategic investors.', date: 'Q4 2025', category: 'token' },
          { title: 'Liquidity Pool Launch (Raydium)', status: 'completed', statusLabel: 'Completed', desc: 'Official listing on Solana DEX and immediate LP token burn.', date: 'Q4 2025', category: 'token' },
          { title: 'Blue Strike Launch', status: 'completed', statusLabel: 'Completed', desc: '24/7 Expert Advisor on XAU/USD operational with 6 independent strategies and slippage optimizer.', date: 'Q4 2025', category: 'finance' },
          { title: 'Smart Contract Audit', status: 'inprogress', statusLabel: 'In Progress', desc: 'Token contract security verification by third-party entities.', date: 'Q1 2026', category: 'token' },
          { title: 'Financial Services Activation', status: 'completed', statusLabel: 'Completed', desc: 'CTC Blue Strike, Algo Engine, and Copy Service active and operational.', date: 'Q1 2026', category: 'finance' },
          { title: 'Early Adopter Airdrop Campaign', status: 'planned', statusLabel: 'Planned', desc: 'Reward distribution to active Telegram community.', date: 'Q2 2026', category: 'token' },
          { title: 'Real Estate Asset Acquisition', status: 'planned', statusLabel: 'Planned', desc: 'First strategic Real Estate Division purchase in Tallinn.', date: 'Q2 2026', category: 'realEstate' },
          { title: 'CEX Listing (Centralized Exchange)', status: 'planned', statusLabel: 'Planned', desc: 'Listing on centralized exchange to increase liquidity.', date: 'Q3 2026', category: 'token' },
          { title: 'Cashback & Utility Platform', status: 'planned', statusLabel: 'Planned', desc: 'CTC payment integration for services and automatic discounts.', date: 'Q4 2026', category: 'token' },
        ]
      },
      transparency: {
        title: 'Maximum Transparency',
        desc: 'ChartTower Corp. commits to ensuring maximum transparency in all its operations. All corporate wallets are publicly verifiable on the Solana blockchain.',
        stats: {
          verifiable: '100%',
          verifiableLabel: 'VERIFIABLE',
          wallets: '9',
          walletsLabel: 'OFFICIAL WALLETS',
          onchain: '24/7',
          onchainLabel: 'ON-CHAIN'
        }
      },
    },

    aiAutomation: {
      title: 'AI & Automation',
      subtitle: 'The Future is Now.',
      description: 'We offer advanced AI and Automation solutions for individuals and businesses. Optimize processes, reduce costs, and increase productivity with ChartTower technology. Contact us to discover how we can transform your business.',
      notifyBtn: 'Notify Me at Launch',
      features: {
        title1: 'Web App & Intelligent Dashboards',
        desc1: 'Development of AI-powered web applications and interactive dashboards to visualize data and insights in real-time.',
        title2: 'Chatbot & Conversational Assistance',
        desc2: 'Intelligent virtual assistants for 24/7 customer support, communication automation, and request management.',
        title3: 'AI Agents & Automated Workflows',
        desc3: 'Creation of intelligent agents and management of automated workflows to optimize business processes.',
      },
      skills: {
        sectionTitle: 'AI & Automation Skills',
        sectionSubtitle: 'Intelligent solutions to optimize every aspect of your business',
        skill1: 'AI Agent Development & Integration',
        skill1Desc: 'Design and development of custom intelligent agents, integrable into your business systems. Decision automation, natural language processing, and API integration with advanced LLMs (GPT, Claude, Gemini).',
        skill2: 'Automated Workflow Management',
        skill2Desc: 'Creation of complex automated workflows to reduce repetitive tasks. Multi-platform integration (n8n, Make, Zapier) with intelligent triggers, error handling, and enterprise scalability.',
        skill3: 'Computer Vision & Data Analysis',
        skill3Desc: 'Visual analysis systems for object recognition, image classification, OCR, and video analysis. Applied Machine Learning for pattern recognition, anomaly detection, and predictive analytics.',
        skill4: 'Generative AI for Content Creation',
        skill4Desc: 'Automation in generating textual, visual, and multimedia content. AI-based content strategy, automated copywriting, image generation, and dynamic personalization for marketing campaigns.',
        skill5: 'Web App & Intelligent Dashboard Development',
        skill5Desc: 'Modern web applications with integrated AI. Real-time dashboards with predictive analytics, conversational interfaces, and advanced data visualizations. Modern stack: React, Next.js, Node.js.',
        skill6: 'Chatbot & Conversational Assistance',
        skill6Desc: 'Intelligent virtual assistants for customer service, technical support, and sales. Advanced NLP, multi-language, CRM/database integration, and custom training on corporate knowledge bases.'
      }
    },
    algoDashboard: {
      backToFinance: 'Back to Finance',
      title: 'ALGO ENGINE 2.0',
      titleHighlight: 'DASHBOARD',
      subtitle: 'Real-Time Algorithmic Performance Monitoring',
      filterAll: 'All',
      filter3m: '3 Months',
      filter1m: '1 Month',
      kpi: {
        totalPips: 'Total Pips',
        totalPipsLabel: 'TOTAL',
        winRate: 'Win Rate',
        winRateLabel: 'ACCURACY',
        profitFactor: 'Profit Factor',
        profitFactorLabel: 'RATIO',
        totalTrades: 'Total Trades',
        totalTradesLabel: 'OPERATIONS'
      },
      charts: {
        equityTitle: 'Equity Growth (Pips)',
        assetDistTitle: 'Asset Distribution',
        monthlyPerfTitle: 'Monthly Performance',
        pipsLabel: 'Pips:',
        tradesLabel: 'Trades:',
        winRateLabel: 'Win Rate:'
      },
      table: {
        title: 'Recent Trades',
        dateCol: 'Date',
        assetCol: 'Asset',
        typeCol: 'Type',
      }
    },
    footer: {
      tagline: 'Inspired by the fear of being average.',
      divisions: 'Divisions',
      resources: 'Resources',
      legal: 'Legal & Contacts',
      items: {
        home: 'Home',
        finance: 'Finance & Investments',
        realEstate: 'Real Estate',
        token: 'CTC Token',
        roadmap: 'Dynamic Roadmap',
        whitepaper: 'White Paper',
        community: 'Telegram Community',
        liquidity: 'Liquidity Pool',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        cookie: 'Cookie Policy',
        about: 'About Us'
      },
      address: 'ChartTower Corp. OÜ c/o Nomad Consulting OÜ; Ruunaoja 3, 11415 Tallinn, Estonia',
      copyright: '© 2025 ChartTower Corp. All rights reserved.',
      backToTop: 'Back to Top'
    },
    consultation: {
      title: 'Free',
      titleHighlight: 'Consultation',
      subtitle: "Not sure which service suits you? Tell us about your needs and we'll help you find the right solution tailored to your situation.",
      cta: 'Request Free Consultation',
      bullets: ['No commitment', 'Reply within 24h', '100% personalized'],
      services: {
        blueStrike: 'CTC Blue Strike',
        algoEngine: 'CTC Algo Engine',
        copyService: 'CTC Copy Service',
        realEstate: 'Real Estate Division',
        ai: 'AI \u0026 Automation',
        notSure: "Not sure yet \u2014 help me choose"
      },
      modal: {
        title: 'Request Free Consultation',
        desc: 'Fill in the form and we will contact you to schedule the consultation at the most convenient time for you.',
        fields: {
          name: 'Full Name',
          telegram: 'Telegram',
          optional: 'Optional',
          service: 'Service of Interest',
          servicePlaceholder: '\u2014 Select a service \u2014',
          needs: 'Your needs',
          needsPlaceholder: 'Briefly describe your situation and what you are looking for...'
        },
        submit: 'Send Request',
        successTitle: 'Request sent!',
        successDesc: 'We will reply within 24 hours. Check your email client.'
      }
    },
    linktree: {
      subtitle: 'Finance, Blockchain, Real Estate. All in one ecosystem.',
      officialChannels: 'Official Channels',
      corporateGroup: 'Corporate Group',
      corporateGroupDesc: 'Reserved access upon approval',
      website: 'Official Website',
      websiteDesc: 'Explore the complete ecosystem',
      tokenChannel: 'CTC Token Channel',
      tokenChannelDesc: 'Token news and updates',
      twitter: 'Twitter / X',
      twitterDesc: 'Follow us for the latest news',
      instagram: 'Instagram',
      instagramDesc: 'Exclusive content and insights',
      rightsReserved: 'All rights reserved.'
    },
    privacyPolicy: {
      subtitle: 'Your privacy is fundamental to us. Here we explain how we handle your data in accordance with GDPR and European personal data protection regulations.',
      lastUpdated: 'Last updated:',
      lastUpdatedDate: '20 January 2026',
      s1: {
        title: '1. Data Controller',
        desc: 'The Data Controller of personal data is:',
        company: 'Company Name',
        address: 'Registered Address',
        regNum: 'Registration Number',
      },
      s2: {
        title: '2. Data Protection Officer (DPO)',
        desc: 'We have appointed a Data Protection Officer (DPO) whom you can contact for any questions related to the processing of your personal data:',
        dpo: 'DPO',
      },
      s3: {
        title: '3. Types of Data Collected',
        intro: 'During your visit to our site, we collect the following categories of data:',
        navTitle: '3.1 Navigation Data',
        navDesc: 'The computer systems responsible for operating the site automatically acquire, during normal operation, certain data whose transmission is implicit in the use of Internet communication protocols:',
        navItems: ['IP Addresses', 'Browser type and operating system', 'Date and time of requests', 'Pages visited'],
        chatTitle: '3.2 ChatBot Data',
        chatDesc: 'Our virtual assistant (ChartTower BOT AI) collects:',
        chatItems: ['Messages sent by the user', 'Session ID (automatically generated and stored locally)', 'Conversation timestamps'],
        chatWarning: 'Important notice:',
        chatWarningDesc: 'We recommend you do NOT enter sensitive personal information in conversations with the ChatBot.',
        cookiesTitle: '3.3 Cookie Preferences',
        cookiesDesc: 'We store your cookie preferences (see',
      },
      s4: {
        title: '4. Purposes and Legal Basis for Processing',
        intro: 'Your personal data is processed for the following purposes:',
        p1Title: 'Website Operation',
        p1Desc: 'Ensuring correct navigation and access to content.',
        p1Legal: 'Legal basis: Legitimate Interest (Art. 6.1.f GDPR)',
        p2Title: 'ChatBot Assistance',
        p2Desc: 'Providing support and information about our services through the virtual assistant.',
        p2Legal: 'Legal basis: Implicit consent to use (Art. 6.1.a GDPR)',
        p3Title: 'ChatBot Service Improvement',
        p3Desc: "Conversation logs are used exclusively for the bot's self-learning and to improve the quality of responses.",
        p3Legal: 'Legal basis: Legitimate Interest (Art. 6.1.f GDPR)',
        p4Title: 'Legal Compliance',
        p4Desc: 'Fulfilling obligations required by law, regulations, or European standards.',
        p4Legal: 'Legal basis: Legal obligation (Art. 6.1.c GDPR)',
      },
      s5: {
        title: '5. Recipients and Data Processors',
        intro: 'Your data may be shared with:',
        h1Title: 'Hosting Provider',
        h1Desc: 'Cloudflare Inc. - Website hosting and distribution (Cloudflare Pages)',
        h1Note: 'Location: USA - Data transfer governed by Standard Contractual Clauses (SCC) and Data Processing Addendum',
        h2Title: 'ChatBot Service',
        h2Desc: 'ChatBot conversation data is processed via servers located at app.thomastapella.it for response management and AI system self-learning.',
        noteLabel: 'Important note:',
        note: 'We do NOT sell, rent, or share your personal data with third parties for marketing purposes. We do not use tracking cookies or third-party analytics.',
      },
      s6: {
        title: '6. Data Retention Period',
        intro: 'Personal data is retained for the time strictly necessary to achieve the purposes for which it was collected:',
        i1Label: 'Navigation data:',
        i1Desc: 'Deleted within 7 days of collection',
        i2Label: 'ChatBot logs:',
        i2Desc: 'Used for AI learning, then anonymized',
        i3Label: 'Cookie preferences:',
        i3Desc: '12 months from selection',
      },
      s7: {
        title: '7. Your Rights (GDPR Art. 15-22)',
        intro: 'As a data subject, you have the right to:',
        r1Label: 'Access',
        r1Desc: 'Obtain confirmation of the existence of processing and access your data',
        r2Label: 'Rectification',
        r2Desc: 'Request the correction of inaccurate or incomplete data',
        r3Label: 'Erasure',
        r3Desc: 'Request the deletion of data ("Right to be forgotten")',
        r4Label: 'Restriction',
        r4Desc: 'Request restriction of processing',
        r5Label: 'Portability',
        r5Desc: 'Receive data in a structured, machine-readable format',
        r6Label: 'Objection',
        r6Desc: 'Object to processing at any time',
        r7Label: 'Withdrawal of consent',
        r7Desc: 'Withdraw previously given consent',
        exercise: 'To exercise your rights:',
        complaint: 'Right to Lodge a Complaint:',
        complaintBody: 'You have the right to lodge a complaint with the competent supervisory authority:',
        complaintAuthority: 'Andmekaitse Inspektsioon (Estonian Data Protection Authority)',
      },
      s8: {
        title: '8. Data Security',
        intro: 'We adopt appropriate technical and organizational measures to protect your personal data:',
        items: [
          'HTTPS encryption for all communications',
          'Limited access to personal data to authorized personnel only',
          'Hosting on secure, certified infrastructure',
          'No collection of payment data on the site',
        ],
      },
      s9: {
        title: '9. Changes to Privacy Policy',
        desc: 'This Privacy Policy may be updated periodically. In the event of significant changes, we will publish a clearly visible notice on the site. We encourage you to regularly check this page to stay informed about how we protect your data.',
      },
      contact: {
        title: 'Contact',
        desc: 'For any questions regarding this Privacy Policy or the processing of your personal data:',
        email: 'Email',
        dpo: 'DPO',
        address: 'Address',
      },
    },
    termsOfService: {
      title: 'Terms of Service',
      subtitle: 'Legal conditions governing the use of Services offered by ChartTower Corp. OÜ.',
      backToHome: 'Back to Home',
      lastUpdated: 'Last updated:',
      lastUpdatedDate: '28 February 2026',
      s1: {
        title: '1. Acceptance of Terms',
        p: 'By accessing the website the User unconditionally agrees to be bound by these Terms of Service. If the User does not accept these terms, they are asked to immediately cease use of the website and Services offered by ChartTower Corp. OÜ.',
      },
      s2: {
        title: '2. Finance & Investment Division: provider of historical data and software',
        p: 'The User acknowledges and accepts that ChartTower Corp. OÜ is not a certified financial services provider under applicable sector regulations, and operates exclusively as a technology and data analytics provider. The various Services detailed below consist of market analysis, algorithmic signals, and historical data. No content provided by ChartTower Corp. should be interpreted as personalized "investment advice" (within the meaning of MiFID II Directive or equivalent regulations).',
        warningTitle: 'CFD, FOREX AND CRYPTOCURRENCY TRADING INVOLVES A HIGH LEVEL OF RISK AND MAY RESULT IN THE LOSS OF YOUR ENTIRE INVESTED CAPITAL. The User declares to be aware that:',
        w1: 'Historical results (Backtests) shown in the various dashboards and service reports are hypothetical and do not guarantee future results.',
        w2: 'The use of financial leverage amplifies both gains and losses.',
        w3: 'The User should only invest capital they can afford to lose ("Risk Capital").',
      },
      s3: {
        title: '3. CTC Blue Strike',
        h1: 'Software, not asset management',
        h1p: "ChartTower Corp. provides software that processes market data and operates with customizable parameters, based on backtests conducted over multi-year historical periods. The User retains full control of the configuration and therefore the final responsibility for their investment decisions. ChartTower Corp. does not act as an asset manager and has no direct access to the User's funds.",
        h2: 'VPS',
        h2p: "CTC Blue Strike requires installation and configuration on a VPS with suitable specifications at the client's expense, unless otherwise agreed.",
        h3: 'Backtests and disclaimer',
        h3p1: 'The results of backtests conducted over historical multi-year periods are made available to users to demonstrate potential performance, without however constituting any guarantee of future returns.',
        h3p2: "ChartTower Corp. shall not be liable to the Client or any third parties for financial losses, lost profits, loss of opportunity, or other indirect, consequential or special damages arising from the use (or non-use, or use not in accordance with the provided instructions and settings/parameters) of the CTC Blue Strike software.",
        h3p3: '"Non-compliant use" examples that may lead to the loss of funds include: manual and sudden interruption of the VPS connection; manual modification of preset settings; manual opening or closing of orders; attempts to tamper with the software for any purpose.',
        h4: 'Copyright',
        h4p: 'CTC Blue Strike is copyright-protected software. Any unauthorized attempt to copy, modify, tamper with, or resell it will be pursued through all appropriate civil and/or criminal actions.',
      },
      s4: {
        title: '4. CTC Algo Engine 2.0',
        h1: 'Signal room and informational nature',
        h1p: 'The Service consists of providing information flows generated by a proprietary algorithm based on advanced technical analysis logic. This information is distributed in the form of structured "educational signals" containing parameters such as Entry Point, Stop Loss, and multiple Take Profits.',
        h2: 'Manual execution and Pending Orders',
        h2p: "The operational approach suggested by the Service is primarily based on the use of pending orders. The User acknowledges that this operational mode necessarily implies manual parameter entry on their trading platform. The Service is limited to providing price levels; the user retains full and exclusive discretion in deciding whether, when, and how to execute such orders, maintaining total control of their capital. There is no automatic connection between ChartTower Corp.'s algorithm and the User's trading account.",
        h3: 'Third Parties (Delivery Platform)',
        h3p: "Signals are distributed via third-party messaging platforms (Telegram). ChartTower Corp. is not responsible for delays in receiving notifications, messaging server malfunctions, or order non-execution due to technical issues on the User's platform or the Broker used.",
        h4: 'Backtests and disclaimer',
        h4p1: 'The results of simulations conducted over historical multi-year periods are provided to users to demonstrate potential performance, without however constituting any guarantee of future returns.',
        h4p2: 'ChartTower Corp. shall not be liable to the Client or any third parties for financial losses, lost profits, loss of opportunity, or other indirect, consequential or special damages arising from the use of signals generated by the CTC Algo Engine 2.0 Service.',
      },
      s5: {
        title: '5. CTC Copy Service',
        h1: 'Nature of the Service, technological infrastructure and platform requirement',
        h1p1: "The User acknowledges that the nature of the Service is limited to providing data and telematic impulses (signals extracted from a proprietary Master account of ChartTower Corp.). The entire technological execution infrastructure, order matching, and custody of funds are exclusively owned by and under the responsibility of third parties (Broker).",
        h1p2: "Since the Master Strategy operates within the FPG broker's servers, it is an indispensable requirement that the user has an active account with the same intermediary to enable the connection. The service is not technically supported or activatable on third-party platforms or brokers.",
        h2: 'Disclaimer',
        h2p: 'ChartTower Corp. shall not be liable to the Client or any third parties for financial losses, lost profits, loss of opportunity, or other indirect, consequential or special damages arising from the use of automatic replication of operations from CTC Copy Service Master accounts.',
      },
      s6: {
        title: '6. AI & Automation Division: customization and tailored services',
        p: 'The AI & Automation division provides custom electronic services for website development, web-apps, workflow automation, and cyber security. Given the highly customized nature of the service, the technical specifications, delivery times, costs, and exact functionalities of each project are defined case by case in the Commercial Proposal signed between the parties. In case of conflict between these general Terms and the specific contract, the latter shall prevail.',
        h1: 'Third-party dependencies (APIs) and maintenance',
        h1p: 'The User acknowledges that automations may depend on third-party services, APIs or platforms (e.g. OpenAI, Telegram, Google, n8n). ChartTower Corp. is not responsible for interruptions, malfunctions, or unilateral changes made by such third parties that could compromise the functionality of the delivered product. Unless otherwise agreed in writing (e.g. maintenance fee), the service is considered concluded upon delivery and testing. Any subsequent updates required due to external changes may be subject to a new quotation.',
        h2: 'Intellectual property (usage license)',
        h2p: "Unless otherwise agreed in writing, ChartTower Corp. retains full intellectual property (Copyright) of the source code, libraries, and methods developed. The Client is granted a perpetual, non-exclusive, non-transferable Usage License for use of the software within their organization. The Client is prohibited from reselling, sublicensing, or distributing the software source code to third parties for profit, unless otherwise agreed in writing between the parties.",
      },
      s7: {
        title: '7. Real Estate Division: Division under development',
        p: 'The User acknowledges that the Real Estate division and related content described on the Site are currently under development and preliminary structuring. Any informational material, graphic renders, roadmaps, or financial projections in this section are illustrative in nature and do not constitute in any way a public offering of savings or financial products or a solicitation for real estate investment.',
        h1: 'Future terms',
        h1p: 'The legal conditions, access requirements, and specific operating procedures for the Real Estate division will be governed by Terms of Service to be published subsequently. ChartTower Corp. reserves the right to reorganize the development of this division without notice and without this entailing any liability toward the User.',
        h2: 'Expressions of interest and pilot programs',
        h2p: 'Despite the development status of the division, ChartTower Corp. is available to evaluate, upon specific and spontaneous request by the User (reverse solicitation), the opportunity to provide preliminary consulting services or early access to pilot projects. Interested Users may contact the company for an exploratory evaluation. Such discussions are purely informational, without any binding commitment for the parties, and do not constitute a guarantee of service provision. Any agreements arising from such contacts will be formalized through separate, personalized private contracts based on the specific case requirements.',
      },
    },
    cookiePolicy: {
      title: 'Cookie Policy',
      subtitle: 'Full transparency on how we use cookies. Your privacy is our priority.',
      lastUpdated: 'Last updated:',
      lastUpdatedDate: '20 January 2026',
      importantTitle: 'Your Privacy Matters',
      importantP: 'ChartTower Corp. does NOT use tracking cookies, third-party analytics, or marketing cookies. We exclusively use strictly necessary technical cookies for the site to function.',
      whatTitle: 'What are Cookies?',
      whatP1: "Cookies are small text files that websites save on the user's device (computer, smartphone, tablet) during browsing. They are used to store information and preferences, improving the browsing experience.",
      whatP2: 'This Cookie Policy is drafted in compliance with Regulation (EU) 2016/679 (GDPR) and Directive 2002/58/EC (ePrivacy), as transposed by applicable national regulations.',
      techTitle: 'Technical Cookies (Necessary)',
      techAlways: 'Always Active',
      techDesc: 'These cookies are essential for the website to function and cannot be disabled. They are set in response to actions you take, such as managing privacy preferences. They do not require user consent under Art. 122 of the Privacy Code.',
      tableCol1: 'Cookie',
      tableCol2: 'Domain',
      tableCol3: 'Duration',
      tableCol4: 'Purpose',
      row1Duration: '12 months',
      row1Purpose: "Stores the user's cookie preferences",
      row2Duration: 'Persistent',
      row2Purpose: 'ChatBot session identifier for conversation continuity',
      analyticsTitle: 'Analytics Cookies',
      notUsed: 'Not Used',
      analyticsDesc: 'ChartTower Corp. does not use Google Analytics, Facebook Pixel, or other tracking tools. We respect your privacy and do not monitor your browsing behavior.',
      marketingTitle: 'Marketing and Profiling Cookies',
      marketingDesc: 'We do not use advertising, remarketing, or user profiling cookies. We do not sell or share your data with advertising networks.',
      thirdPartyTitle: 'Third-Party Cookies',
      thirdPartyP: 'Our site may include embedded content (e.g. videos, maps) from external services. These services may set their own cookies.',
      prefsTitle: 'Preference Management',
      prefsP: 'You can change your cookie preferences at any time:',
      resetTitle: 'Reset Cookie Preferences',
      resetDesc: 'Click the button below to clear your saved preferences. The consent banner will appear again on your next visit.',
      resetBtn: 'Reset Cookie Preferences',
      browserTitle: 'Browser Settings',
      browserDesc: 'You can also manage cookies directly from your browser settings:',
      controllerTitle: 'Data Controller',
      controllerCompany: 'Company Name',
      controllerAddress: 'Registered Address',
      controllerDPO: 'DPO',
      moreInfoTitle: 'Further Information',
      moreInfoP: 'For complete information on the processing of your personal data, see our Privacy Policy.',
      moreInfoBtn: 'Go to Privacy Policy',
    },
  },
  et: {
    nav: {
      home: 'Avaleht',
      finance: 'Rahandus',
      realEstate: 'Kinnisvara',
      token: 'CTC Token',
      infoSocietarie: 'Ettevõtte Info',
      community: 'Kogukond',
      aiAutomation: 'AI & Automaatika'
    },
    common: {
      learnMore: 'Loe lisaks',
      comingSoon: 'Tulekul',
      live: 'LIVE',
      explore: 'Uuri ökosüsteemi',
      buyCtc: 'Osta CTC',
      joinCommunity: 'Liitu kogukonnaga',
      back: 'Tagasi',
      viewPresentation: 'Vaata esitlust',
      downloadList: 'Hinnakiri & Backtest',
      technicalSpecs: 'Tehnilised spetsifikatsioonid',
      glossary: 'Ametlik CTC sõnastik',
      recentPerformance: 'Hiljutine tulemuslikkus',
      partialRoadmapNote: 'Vaatate ainult selle jaotise tegevuskava.',
      viewFullRoadmap: 'Vaata täielikku tegevuskava',
      verified: 'KINNITATUD',
      screenshot: 'Ekraanipilt',
      feedbackTitle: 'Kinnitatud tagasiside & Reaalsed tulemused',
      viewMoreFeedback: 'Vaata rohkem tagasisidet ettevõtte grupis',
      excellent: 'Suurepärane',
      copied: 'Kopeeritud!',
      copy: 'Kopeeri',
      freeTrial: 'Taotlege 1-kuulist prooviperioodi',
      contactChoice: 'Valige, kuidas meiega ühendust võtta:',
      contactEmail: 'E-post',
      contactTelegram: 'Telegram',
      searchGlossary: 'Otsi terminit...',
      noResultsFound: 'Termineid ei leitud',
      tryAnotherKeyword: 'Proovige mõne muu märksõnaga'
    },
    cookies: {
      title: 'Küpsiste kasutamine',
      gdprCompliant: 'GDPR Compliant',
      description: 'Kasutame olulisi küpsiseid saidi nõuetekohase toimimise tagamiseks ja valikulisi küpsiseid teie kogemuse parandamiseks. Saate oma eelistusi igal ajal kohandada.',
      acceptAll: 'Nõustu kõigega',
      rejectAll: 'Ainult vajalikud',
      customize: 'Kohanda',
      savePreferences: 'Salvesta eelistused',
      back: 'Tagasi',
      required: 'Kohustuslikud',
      learnMore: 'Lisateabe saamiseks vaadake meie',
      privacyPolicy: 'Privaatsuspoliitika',
      necessary: {
        title: 'Vajalikud küpsised',
        desc: 'Saidi toimimiseks hädavajalikud. Ei saa keelata.'
      },
      analytics: {
        title: 'Analüütika küpsised',
        desc: 'Aitavad meil mõista, kuidas külastajad saidiga suhtlevad, kogudes anonüümseid andmeid.'
      },
      marketing: {
        title: 'Turundusküpsised',
        desc: 'Kasutatakse külastajate jälgimiseks veebisaitidel ja asjakohaste reklaamide kuvamiseks.'
      }
    },
    socialSection: {
      titlePart1: 'AMETLIKUD',
      titlePart2: 'KANALID',
      subtitle: 'Struktureeritud suhtlusökosüsteem, et tagada läbipaistvus, tugi ja õigeaegsed uuendused.',
      telegramTitle: 'Telegrami Ökosüsteem',
      telegramDesc: 'Kolm eraldi kanalit igaks vajaduseks: ettevõtte info, tokeni uuendused ja kogukond.',
      telegramChannels: {
        corporate: {
          title: 'Ametlik ettevõtte grupp',
          desc: 'Juurdepääs kinnitamisel. Operatiivne süda: Kinnisvara, Rahandus, Turuanalüüs ja Uudised. Leia tulemused ja arvustused siit esimesena.',
          action: 'Taotle juurdepääsu'
        },
        token: {
          title: 'CTC Tokeni Kanal',
          desc: 'Avalik ametlik kanal. Ainult kontrollitud teadaanded ja olulised uudised seoses CTC Tokeni ja Tegevuskavaga.',
          action: 'Liitu kanaliga'
        },
        community: {
          title: 'CTC Tokeni Kogukond',
          desc: 'Avalik grupp, avatud kõigile. Pühendatud teemad halduseks, tehniliseks toeks, airdrop\'ideks ja üldisteks aruteludeks. Kaitstud Recaptcha abil.',
          action: 'Liitu kogukonnaga'
        }
      },
      twitter: 'X (Twitter)',
      twitterDesc: 'Krüptoökosüsteemi viitepunkt. Reaalajas uuendused, partnerlused ja otsene suhtlus DeFi kogukonnaga.',
      instagram: 'Instagram',
      instagramDesc: 'Meie visuaalne vitriin: Blue Strike tulemused, Algo Engine igakuine tootlus, klientide arvustused ja teenuste illustratsioonid.'
    },
    feedSection: {
      title: 'Tipptaseme sein',
      subtitle: 'Reaalsed tulemused, Läbipaistev tagasiside. Uuendame kogukonda pidevalt meie teenuste tootluse ja klientide arvamustega.',
      viewAll: 'Vaata kõiki ettevõtte grupis'
    },
    home: {
      hero: {
        badge: 'AI & AUTOMAATIKA ERA- JA ÄRIKLIENTIDELE - TULEKUL',
        titlePart1: 'ChartTower',
        titlePart2: 'Corp.',
        subtitle: 'Inspired by the fear of being average.',
        cards: {
          corporate: 'Ettevõte',
          corporateDesc: 'Ettevõtte andmed ja läbipaistvus',
          finance: 'Rahandus',
          financeDesc: 'Haldamine ja investeeringud',
          token: 'CTC Token',
          tokenDesc: 'Utiliidi token Solanas',
          realEstate: 'Kinnisvara',
          realEstateDesc: 'Kinnisvaraportfell'
        },
        verify: {
          title: 'Kontrollitavad andmed',
          companyNameLabel: 'Ettevõtte nimi',
          companyNameValue: 'ChartTower Corp. OÜ',
          regLabel: 'Registrikood',
          regValue: '17288413',
          leiLabel: 'LEI kood',
          leiValue: '9845001C375D5E411F72',
          legalLabel: 'Juriidiline aadress',
          legalValue: 'Ruunaoja 3, 11415 Tallinn, Estonia',
          tokenComplianceLabel: 'Tokeni Vastavus',
          tokenComplianceValue: 'CTC Token MICA Vastav',
          button: 'Loe lisaks'
        }
      },
      structure: {
        titlePart1: 'ETTEVÕTTE',
        titlePart2: 'STRUKTUUR',
        description: 'Iga oluline teave, mis puudutab meie integreeritud juhtimist, mis ühendab erinevaid varatüüpe, tehakse alati avalikkusele kättesaadavaks, alates osalustest hajutatud finantsvarades kuni kinnisvaraobjektideni, samuti varakambris hoitavad CTC tokeni osad.',
        cards: {
          finance: 'Rahanduse ja investeeringute osakond',
          financeDesc: 'Hajutatud portfellihaldus, riskijuhtimine ja täielik läbipaistvus tootluse optimeerimiseks.',
          realEstate: 'Kinnisvara osakond',
          realEstateDesc: 'Strateegilised investeeringud kinnisvarasektorisse, ehitades ökosüsteemile väärtusreservi.',
          token: 'CTC Token',
          tokenDesc: 'Utiliidi token Solana võrgus koos cashbacki, pühendatud allahindluste ja ökosüsteemi tootlusega.',
          aiAutomation: 'AI & Automaatika',
          aiAutomationDesc: 'Intelligentsed lahendused äriprotsesside automatiseerimiseks ja tootlikkuse optimeerimiseks.'
        }
      },
      roadmap: {
        leftCard: {
          title: 'Dünaamiline tegevuskava',
          desc: 'Interaktiivne ajajoon, mis jälgib iga projekti verstaposti: alates valge raamatu avaldamisest kuni eramüügini, likviidsusbasseini käivitamisest kuni airdrop\'ideni, kuni rahanduse ja kinnisvara osakonna teenusteni.',
          bullets: [
            'Reaalajas uuendused',
            'Ajalooline versioon saadaval',
            'Orienteeruvad kuupäevad ja tehnilised tarned'
          ]
        },
        rightContent: {
          titlePart1: 'LÄBIPAISTEV',
          titlePart2: 'TEGEVUSKAVA',
          desc1: 'ChartToweri dünaamiline tegevuskava juhendab teid samm-sammult läbi projekti oleviku ja tuleviku. Iga saavutatud eesmärk on dokumenteeritud, iga tulevane verstapost on kavandatud koos orienteeruvate kuupäevade ja selgete tarnetega.',
          desc2: 'Alates MiCA EL regulatiivsest teekonnast kuni operatiivsete teenusteni, tokeni haldamisest kuni kinnisvaraarendusteni: kõik on kogukonna poolt jälgitav ja kontrollitav.',
          button: 'Vaata tegevuskava'
        },
        teaser: {
          q3Title: 'Ettevõtte asutamine',
          q3Status: 'Tehtud',
          q4Title: 'Token ja Rahandus',
          q4Status: 'Tehtud',
          q1Title: 'Laienemine',
          q1Status: 'Käimas'
        }
      },
      stats: {
        transparency: '100% LÄBIPAISTVUS',
        transparencyLabel: 'LÄBIPAISTVUS',
        solana: 'SOLANA PLOKIAHELA VÕRK',
        solanaLabel: 'VÕRK',
        live: 'LIVE LIKVIIDSUSBASSEIN',
        liveLabel: 'LIKVIIDSUSBASSEIN',
        support: '24/7 KOGUKONNA TUGI',
        supportLabel: 'TUGI',
        verifiable: '100%',
        verifiableLabel: 'KONTROLLITAV',
        publicWallets: '9',
        publicWalletsLabel: 'AVALIKUD RAHAKOTID'
      },
      testimonials: {
        title: 'Mida meie kohta öeldakse',
        reviews: [
          {
            text: 'Suurepärased signaalid, jälgin juba kuid ja tulemused räägivad enda eest. Väga kasulik juhtpaneel jõudluse jälgimiseks!',
            author: 'Algo Engine klient',
            service: 'Algo Engine',
            date: '2025-11-01'
          },
          {
            text: 'Hea õhtu Andrea, tänu CTC Blue Strike tulemuslikkusele ärkasin täna hommikul naeratusega 😁. Tänan, et tutvustasid mulle seda toodet, olen üha enam rahul, et investeerisin sellesse... aitäh 🙏🔥🔥',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2025-12-01'
          },
          {
            text: 'MIDAGI ÖELDA POLE, HOMMIK TOOB KULDA 💰🔥 Palun väga kallim, tänu sinule 💪🏻',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2025-12-22'
          },
          {
            text: 'Pärast seda, kui CTC Blue Strike võttis päeva puhkust 🤣, tuli ta täna tagasi paremini kui kunagi varem 🔥🔥💪',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2026-01-01'
          },
          {
            text: 'Tore ärkamine täna hommikul tänu Blue Strike tarkvarale. Suurepärane nädala algus 🔥',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2026-01-12'
          },
          {
            text: 'Tere taas hommikust automaatse tarkvara poolt 😂😂🔥🔥 Jah, ütleksin küll, ei oota ära et see jätkaks neid tootlusi 💪🏻',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2026-01-16'
          },
          {
            text: 'Lisan tänase tarkvara ajaloo. Alustame jahvatama😁 vähe aga head💪',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2026-01-30'
          },
          {
            text: 'Zero stress, täiuslik kopeerimine. Täielik läbipaistvus komisjonide osas. Varsti alustame ka Copy teenusega, laaditud 🔥🔥🔥',
            author: 'Copy Service klient',
            service: 'Copy Service',
            date: '2026-01-30'
          },
          {
            text: 'Mega kasum igal juhul🚀 Soovitaksid seda teenust?😁 Absoluutselt jah 🔥🔥🔥',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2026-02-01'
          },
          {
            text: 'Tere Andrea, noh, mida öelda – hommik toob kulda JA hõbedat 😂 💪💪🔥, kõik tänu sinu suurepärastele teenustele, CTC Blue Strike ja Copy trading... suuräitäh ☺️',
            author: 'Blue Strike & Copy Service klient',
            service: 'Blue Strike',
            date: '2026-02-23'
          },
          {
            text: 'Vähem kui 3 kuuga taastus kogu teenuse kulu pluss veel 1000$ umbes! See on hullujulge 😍',
            author: 'Blue Strike & Copy Service klient',
            service: 'Blue Strike',
            date: '2026-02-25'
          },
          {
            text: 'Absoluutselt jah, need on teenused, mida väärib nimetada teenusteks! Võrreldes kõige sellega, mida Internetis loetakse – see töötab tõesti!',
            author: 'Blue Strike & Copy Service klient',
            service: 'Copy Service',
            date: '2026-02-25'
          },
          {
            text: 'Tere Andrea, pean ütlema, et me ei saanuks nädalat paremini alustada 💪💪',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2026-03-16'
          },
          {
            text: 'Konfliktid või mitte, Blue Strike ei hooli, vastupidi – see tõi meile kasutamiseks volatiilsust!! See on uskumatu ahaha, olen ametlikult teeninud üle 50% umbes 5 kuuga 😁😁',
            author: 'Blue Strike klient',
            service: 'Blue Strike',
            date: '2026-04-08'
          }
        ]
      },

      ecosystem: {
        title: 'Tehnoloogiline Stack ja Ökosüsteem',
        solana: 'SOLANA',
        solanaDesc: 'Plokiahel',
        raydium: 'RAYDIUM',
        raydiumDesc: 'Likviidsus',
        telegram: 'TELEGRAM',
        telegramDesc: 'Kogukond',
        estonia: 'ESTONIA',
        estoniaDesc: 'Regulatsioon',
        button: 'Liitu kogukonnaga'
      },
      faq: {
        title: 'Korduma Kippuvad Küsimused',
        items: [
          {
            question: 'Mis on CTC token?',
            answer: 'CTC on ChartTower Corp. utiliidi token, mis on ehitatud Solana plokiahelale. See pakub automaatset tagasimakset fiat-valuutas makstud teenuste eest, erisoodustusi CTC-ga maksmisel, osalemist juhtimises ja perioodilisi õhutõsteid. Kogupakkumine: 21 miljonit CTC, MICA EU nõuetele vastav.'
          },
          {
            question: 'Milliseid teenuseid te pakute?',
            answer: 'Pakume kolme aktiivset finantsteenust: CTC Blue Strike (24/7 ekspertnõustaja XAU/USD-l), CTC Algo Engine (algoritmiliste signaalide tuba reaalajas juhtpaneelig) ja CTC Copy Service (automaatne kopeerimine FPG maaklerilt). Arendame ka kinnisvara divisjoni ja AI & automatiseerimise teenuseid.'
          },
          {
            question: 'Kuidas saan kontrollida ettevõtte läbipaistvust?',
            answer: 'Kõik 9 ametlikku rahakotti on avalikult kontrollitavad plokiahelas Solscanis 24/7. Ametlikud dokumendid (valge raamat, põhikiri, registreerimistõend) on saadaval veebisaidil. Blue Strike\'i tulemused on sertifitseeritud MyFXbookis kontrollitud kauplemisõigustega.'
          },
          {
            question: 'Kust ma saan osta CTC tokenit?',
            answer: 'CTC token on saadaval Solana detsentraliseeritud börsidel (DEX): Raydium ja Jupiter. Saate seda osta vahetades SOL või USDC. Likviidsusbasen on aktiivne Raydiumis, LP tokenid on turvalisuse tagamiseks põletatud.'
          },
          {
            question: 'Mis on dünaamiline tegevuskava?',
            answer: 'See on interaktiivne tööriist, mis näitab projekti edenemise staatust reaalajas. See jälgib iga verstapost: ettevõtte asutamisest tokeni käivitamiseni, finantsteenustest kinnisvaraarenduste. Sisaldab ka ajaloolist versiooni konsulteerimiseks.'
          },
          {
            question: 'Kas olete reguleeritud?',
            answer: 'Jah. ChartTower Corp. OÜ on registreeritud Eestis kontrollitava LEI koodiga 9845001C375D5E411F72. CTC token on MICA EU nõuetele vastav, valge raamat on teatatud vastavalt Euroopa krüptovarade turgude regulatsioonile, tagades maksimaalse läbipaistvuse ja investorite kaitse.'
          },
          {
            question: 'Millised on CTC omamise eelised?',
            answer: 'CTC omamisel saate: automaatse tagasimakse fiat-valuutas teenuste eest maksmisel, eksklusiivsed allahindlused CTC-ga maksmisel, prioriteetse juurdepääsu uutele teenustele, osalemise perioodilistes õhutõstetes ja ökosüsteemi juhtimises. Mida rohkem CTC-d omistate, seda suuremad on eelised.'
          },
          {
            question: 'Kuidas saan finantsteenuseid proovida?',
            answer: 'Blue Strike ja Algo Engine jaoks saate taotleda 1-kuulist prooviperioodi vastavate teenuste lehtede nupust. Copy Service jaoks võtke meiega ühendust e-posti (info@ctc-corp.eu) või Telegrami teel. Prooviperiood võimaldab teil isiklikult tulemusi testida.'
          }
        ]
      },
      bottomCta: {
        titlePart1: 'SISENE ÖKOSÜSTEEMI',
        titlePart2: 'ChartTower',
        description: 'Liitu kogukonnaga ja avasta, kuidas CTC token võib muuta sinu investeerimisalast lähenemist. Läbipaistvus, konkreetne tootlus ja pidevalt kasvav võrgustik.',
        btn1: 'Liitu kogukonnaga',
        btn2: 'Osta CTC'
      }
    },
    finance: {
      heroTitle: 'RAHANDUS JA INVESTEERINGUD',
      heroDesc: 'Professionaalsed strateegiad teie kapitali kasvuks.',
      activeServicesTitle: 'TEENUSED',
      activeServicesSubtitle: 'AKTIIVSED',
      badgeOperative: 'TÖÖTAB NÜÜD',
      services: {
        blueStrike: {
          title: 'CTC Blue Strike',
          subtitle: '24/7 Ekspertnõustaja XAU/USD',
          badge: '24/7 EKSPERTNÕUSTAJA',
          f1: 'MyFXbook seire',
          f2: 'Täielik läbipaistvus',
          f3: 'Täiustatud sünergilised strateegiad',
          detailedDesc: 'CTC Blue Strike on meie juhtiv Ekspertnõustaja, mis töötab 24/7 XAU/USD (Kuld) paaril. Tarkvara töötab läbimurdel 6 sõltumatu strateegiaga, mis võivad töötada sünergias või eraldi. Täiesti automaatne, sisaldab "slippage optimeerijat", et vältida üllatusi uudiste ajal.',
          amazonBanner: {
            title: 'VARSTI AMAZONIST',
            desc: 'Töötame selle nimel, et tuua Blue Strike maailma suurimale turuplatsile. Saadaval on ajaliselt piiratud litsentsid (nt 3 või 6 kuud) lisaks eluaegse litsentsi võimalusele, muutes kõigile kättesaadavaks võimaluse testida ja isiklikult kontrollida meie Expert Advisori jõudlust.'
          },
          specs: [
            { label: 'Vara', value: 'XAU/USD (Kuld)' },
            { label: 'Kasumitegur', value: '1.47 (Kontrollitud 6 aastat)' },
            { label: 'Puhaskasum', value: '+27.672% (Liitintress)' },
            { label: 'Maksimaalne langus', value: '0.08% (Liitintress)' },
            { label: 'Võidumäär', value: '55% (3907 tehingut)' },
            { label: 'Strateegiad', value: '6 sõltumatut' }
          ],
          glossary: [
            { term: 'Absolute Drawdown', def: 'Maksimaalne erinevus algkapitali ja testi jooksul saavutatud minimaalse saldo vahel.' },
            { term: 'Average Profit/Loss Trade', def: 'Keskmine kasum võitvatel tehingutel ja keskmine kahjum kaotavatel tehingutel.' },
            { term: 'Backtest Quality', def: 'Protsent, mis näitab, kui tõetruult simulatsioon taasesitab reaalseid turutingimusi (99% on parim).' },
            { term: 'Bars in Test', def: 'Testis kasutatud küünalde (ajaühikute) koguarv.' },
            { term: 'Expected Payoff', def: 'Keskmine oodatav kasum (või kahjum) iga üksiku tehingu kohta.' },
            { term: 'Gross Loss', def: 'Kõigi kaotavate tehingute kogusumma.' },
            { term: 'Gross Profit', def: 'Kõigi võitvate tehingute kogusumma.' },
            { term: 'Initial Deposit', def: 'Algkapital, millega backtesti alustatakse.' },
            { term: 'Largest Loss Trade', def: 'Suurima kahjumiga üksiktehing.' },
            { term: 'Largest Profit Trade', def: 'Suurima kasumiga üksiktehing.' },
            { term: 'Lot', def: 'Positsiooni suurus turul.' },
            { term: 'Lot Size Step', def: 'Reegel, mis suurendab positsiooni suurust kapitali kasvades.' },
            { term: 'Loss Trades (%)', def: 'Kahjumiga lõppenud tehingute protsent.' },
            { term: 'Magic Number', def: 'Unikaalne ID kood tehingute eristamiseks.' },
            { term: 'Maximal Drawdown', def: 'Maksimaalne väärtuse langus tipust põhjani.' },
            { term: 'Modelling Quality', def: 'Andmete täpsus (99% tähendab reaalsete tick-andmete kasutamist).' },
            { term: 'Net Profit Percent', def: 'Kapitali koguprotsendiline kasv.' },
            { term: 'Profit Factor', def: 'Brutokasumi ja brutokahjumi suhe.' },
            { term: 'Profit Trades (%)', def: 'Kasumiga lõppenud tehingute protsent.' },
            { term: 'Relative Drawdown', def: 'Maksimaalne langus protsendina tipust.' },
            { term: 'Short Positions (won %)', def: 'Müügitehingute (langusele panustamine) edukuse protsent.' },
            { term: 'Slippage', def: 'Erinevus oodatud hinna ja täitmishinna vahel.' },
            { term: 'Spread', def: 'Tehingu kulu (ostu- ja müügihinna vahe).' },
            { term: 'Take Profit / Stop Loss', def: 'Automaatsed sulgemistasemed kasumi võtmiseks või kahjumi piiramiseks.' },
            { term: 'Ticks Modeled', def: 'Hinna liikumiste koguarv simulatsioonis.' },
            { term: 'Total Net Profit', def: 'Lõplik puhaskasum.' },
            { term: 'Total Trades', def: 'Tehingute koguarv.' },
            { term: 'Max Consecutive Wins/Losses', def: 'Pikim järjestikuste võitude või kaotuste seeria.' },
            { term: 'Max Consecutive Profit/Loss', def: 'Suurim rahaline võit või kaotus järjestikuse seeria jooksul.' },
            { term: 'Long Positions (won %)', def: 'Ostutehingute (tõusule panustamine) edukuse protsent.' }
          ],
          monitoring: {
            title: 'Sertifitseeritud Seire',
            desc: 'CTC Blue Strike\'i tulemusi jälgib ja sertifitseerib MyFXbook. Täielik läbipaistvus, mis võimaldab igal kasutajal ajaloolisi tulusid reaalajas kontrollida.',
            btn: 'Mine MyFXbooki',
            verified: 'KONTROLLITUD',
            privileges: 'Kauplemisõigused Kontrollitud'
          },
          apiDashboard: {
            title: 'Reaalajas MyFXBook Juhtpaneel',
            desc: 'Integreeritud juhtpaneel, mis kasutab MyFXBook, et kuvada reaalajas tulemuslikkuse andmeid otse meie veebisaidil.',
            button: 'Mine Reaalajas Juhtpaneelile',
            feature1: 'Reaalajas Andmed',
            feature1Desc: 'MyFXBook integratsioon reaalajas tulemuslikkuse uuendusteks',
            feature2: 'Interaktiivsed Graafikud',
            feature2Desc: 'Täiustatud visualiseerimine equity, drawdown ja kauplemisstatistika jaoks',
            feature3: 'Täielik Ajalugu',
            feature3Desc: 'Juurdepääs kõigile ajaloolistele andmetele ja tulemuslikkuse mõõdikutele',
            feature4: 'Täielik Läbipaistvus',
            feature4Desc: 'Kõik tehingud ja operatsioonid nähtavad ühes liideses'
          },
          backtest: {
            title: 'Backtest Kontroll (2018 - 2023)',
            netProfit: '+27.672%',
            netProfitLabel: 'Kogu Puhaskasum',
            maxDrawdown: '0.08%',
            maxDrawdownLabel: 'Maksimaalne Langus',
            profitFactor: '1.47',
            profitFactorLabel: 'Kasumitegur',
            totalTrades: '3.907',
            totalTradesLabel: 'Tehingute Koguarv'
          }
        },
        algoEngine: {
          title: 'CTC Algo Engine',
          subtitle: 'Algoritmiline signaaliruum',
          badge: 'ALGORITHMIC SIGNALS',
          telegramBtn: 'Saa signaale Telegramis',
          pricelistBtn: 'Lae alla hinnakiri',
          f1: 'Reaalajas juhtpaneel',
          f2: 'Igakuised PDF-aruanded',
          f3: 'Demokonto hinna sees',
          detailedDesc: 'CTC Algo Engine signaaliruum pakub analüüsi ja operatiivseid trigereid, mis põhinevad patenteeritud algoritmilistel mootoritel. Teenus pakub üksikasjalikke igakuiseid aruandeid ja peagi interaktiivset juhtpaneeli.',
          updating: {
            title: 'Uuenemisel',
            subtitle: 'Uuendame teenuse infrastruktuuri.',
            cta: 'Stay tuned!'
          },
          dashboard: {
            title: 'Juhtpaneel Tulekul',
            desc: 'Integreerime reaalajas juhtpaneeli, mis on välja töötatud AI Studio kaudu. Saate jälgida iga tehingut, edukuse määra ja igakuist ajalugu ühes läbipaistvas liideses.',
            status: 'Arenduses'
          },
          specs: [
            { label: 'September 2025', value: '+4.070 Pipsi' },
            { label: 'Oktoober 2025', value: '+17.770 Pipsi' },
            { label: 'November 2025', value: '+18.155 Pipsi' },
            { label: 'Varaklass', value: 'Forex, Indeksid, Krüpto' }
          ]
        },
        copyService: {
          title: 'CTC Copy Service',
          subtitle: 'Automaatne tehingute kopeerimine',
          badge: 'AUTOMAATNE KAUPLEMISE KOPEERIMINE',
          btn: 'Aktiveeri Kopeerimisteenus',
          f1: 'Automaatne ühendus',
          f2: 'Reaalajas kopeerimine',
          f3: 'Ametlik Partner FPG',
          detailedDesc: 'CTC Copy Service pakub meie reaktiivse Swing-loogika automaatset replikatsiooni. Täielikult toimiv alates jaanuari keskpaigast meie partnermaakleri FPG kaudu, võimaldab see teenus kopeerida tehinguid, mida oleme edukalt kasutanud üle kahe aasta Forex, toorainete ja krüptoturgudel.',
          partner: {
            title: 'Eksklusiivne Partner',
            name: 'FPG Broker',
            desc: 'Teenust hallatakse eksklusiivses koostöös FPG-iga, et tagada maksimaalne usaldusväärsus, täitmise kiirus ja rahaliste vahendite turvalisus.'
          },
          logic: [
            { title: 'Dünaamiline Loogika', desc: 'Igapäevane volatiilsuse analüüs, et kohandada Take Profit ja Stop Loss vastavalt reaalsetele turutingimustele.' },
            { title: 'Riskijuhtimine', desc: 'Ei mingit võrku ega martingalet. Ainult üks tehing korraga, keskendudes kapitali säilitamisele.' },
            { title: 'Turud ja Varad', desc: 'Keskmise pikkusega swing-kauplemine Forexis, toorainetes (XAU/USD) ja valitud krüptovaluutades.' },
            { title: 'Täiustatud Take Profit', desc: '3 dünaamilist TP taset (33% sulgemine igaüks) ja Stop Loss Breakevenis pärast esimest eesmärki.' }
          ],
          steps: [
            { title: 'Ava FPG Konto', desc: 'Avage konto meie ametliku partnermaakleri FPG juures, järgides juhendatud protseduuri.' },
            { title: 'Kiire Ühendus', desc: 'Ühendage oma konto CTC Copy Service replikatsioonisüsteemiga vaid mõne klikiga.' },
            { title: 'Lõõgastu ja Jälgi', desc: 'Lase swing-loogikal enda heaks töötada ja jälgi tulemusi oma seadmest.' }
          ],
          benefits: [
            { title: 'Reaktiivne Swing Loogika', desc: 'Strateegia, mis põhineb tasakaalustamatusel ja tasemete murdmisel koos oluliste hinnalaiendustega.' },
            { title: 'Null Latentsust', desc: 'Infrastruktuur on optimeeritud partneriga FPG koheseks tellimuste replikatsiooniks.' },
            { title: 'Täielik Kontroll', desc: 'Maksimaalne läbipaistvus koos võimalusega kopeerimine igal ajal peatada.' }
          ]
        },
      },
    },
    realEstate: {
      heroTitle: 'KINNISVARA',
      heroDesc: 'Kinnisvara osakond ühendab tellise kindluse innovaatiliste investeerimismudelitega. Kasutades ChartToweri ökosüsteemi eeliseid ja strateegiliste ning suunatud investeeringute uuringuid, ehitame aja jooksul üles kinnisvaraportfelli, mis toimib väärtusreservina ökosüsteemile endale.',
      comingSoon: 'Tulekul',
      pillars: {
        title: 'MEIE',
        titlePart2: 'SAMBAD',
        subtitle: 'Iga kinnisvarainvesteering on hoolikalt valitud, et tagada püsiv väärtus ja jätkusuutlik tootlus.',
        cards: {
          solidity: 'Tellise kindlus',
          solidityDesc: 'Kinnisvarainvesteeringud, mis ühendavad traditsioonilise stabiilsuse innovaatiliste mudelitega.',
          strategic: 'Strateegiline portfell',
          strategicDesc: 'Suunatud investeeringute uuring, et luua väärtusreserv ChartToweri ökosüsteemile.',
          ecosystem: 'Ökosüsteemi eelised',
          ecosystemDesc: 'CTC ökosüsteemi eeliste täielik ärakasutamine tootluse maksimeerimiseks.',
        }
      },
      strategy: {
        title: 'INVESTEERIMIS',
        titlePart2: 'STRATEEGIA',
        description: 'Meie kinnisvarainvesteeringute strateegia põhineb kolmel aluspõhimõttel: täpne valik, geograafiline hajutatus ja professionaalne juhtimine. Iga kinnisvara hinnatakse mitte ainult selle praeguse väärtuse, vaid ka pikaajalise kasvupotentsiaali järgi.',
        items: {
          growth: 'Jätkusuutlik kasv',
          growthDesc: 'Suunatud investeeringud piirkondadesse, millel on tugev kallinemispotentsiaal',
          risk: 'Riskijuhtimine',
          riskDesc: 'Varade geograafiline ja tüpoloogiline hajutamine',
          positions: 'Strateegilised positsioonid',
          positionsDesc: 'Kinnisvara valik kõrge väärtusega asukohtades'
        },
        portfolio: {
          title: 'Kinnisvaraportfell',
          residential: 'Eluvarad',
          commercial: 'Ärivarad',
          development: 'Projektiarendus',
          desc: 'Portfell areneb pidevalt ja on optimeeritud tootluse maksimeerimiseks ja riskide vähendamiseks.',
          button: 'Loe lisaks'
        }
      },
      vision: {
        title: 'MEIE VISIOON',
        description: 'Usume, et kinnisvara esindab ChartToweri ökosüsteemi stabiilsuse ja kasvu alustala. Professionaalse ja läbipaistva juhtimise kaudu ehitame kinnisvarapärandit, mis genereerib aja jooksul jätkusuutlikku väärtust, aidates kaasa projekti kindlusele ja CTC tokeni hoidjate tootlusele.',
        stats: {
          transparency: '100%',
          transparencyLabel: 'LÄBIPAISTVUS',
          longTerm: 'PIKAAJALINE',
          longTermLabel: 'VISIOON',
          global: 'GLOBAALNE',
          globalLabel: 'HAJUTAMINE'
        }
      },
      requestInfoBtn: 'Küsi Lisainfot'
    },
    token: {
      hero: {
        badge: 'LIKVIIDSUSBASSEIN LIVE RAYDIUMIS',
        titlePart1: 'CTC',
        titlePart2: 'TOKEN',
        description: 'ChartToweri ökosüsteemi süda: utiliidi token, mis põhineb Solana võrgul, pakkudes juurdepääsu eksklusiivsetele teenustele ja luues jätkusuutliku ringmajanduse.',
        buyBtn: 'Osta Raydiumist',
        whitepaperBtn: 'Loe valget raamatut',
        check1: 'Solana plokiahel',
        check2: '9 ametlikku rahakotti',
        check3: 'MICA VASTAVUS',
        card: {
          title: 'CTC Token',
          subtitle: 'Utiliidi Token • Solana võrk',
          item1Title: 'CTC TOKENI HOIDMISE EELISED',
          item1Desc: 'Allahindlused, cashback ja eripreemiad igas airdropis',
          item2Title: 'MICA VASTAVUS',
          item2Desc: 'Valge raamat teavitatud pädevatele asutustele ja kantud ESMA registritesse',
          item3Title: 'RINGMAJANDUS',
          item3Desc: 'Läbipaistev ja jätkusuutlik tokenoomika'
        }
      },
      contract: {
        titlePart1: 'LEPINGU',
        titlePart2: 'AADRESS',
        addressLabel: 'Programmi ID / Lepingu aadress',
        copyBtn: 'Kopeeri aadress',
        solscanBtn: 'Solscan',
        dtiLabel: 'DTI kood',
        dtiIdLabel: 'Digitaalse tokeni identifikaator',
      },
      distribution: {
        titlePart1: 'TOKENI',
        titlePart2: 'JAOTAMINE',
        description: 'Tokeni jaotamine on kavandatud tagamaks pikaajalist jätkusuutlikkust, pakkudes utiliidi eeliseid, mis premeerivad hoidjaid allahindluste või cashbacki kaudu, ning ettevõtte varakambri haldusmehhanisme, mis on loodud ökosüsteemi kasvu toetamiseks.',
        items: [
          { label: 'Ettevõtte varakamber', percentage: '38%', amount: '7.980.000 CTC', desc: 'Lukustatud rangete likviidsustingimustega, sealhulgas otsese CEX/DEX müügi keeld ja kohustuslik BTC kogumine (2-5% puhaskasumist)' },
          { label: 'Avalik CEX noteerimine', percentage: '15%', amount: '3.150.000 CTC', desc: 'Spetsiaalne eraldis avalikele tsentraliseeritud börsidele noteerimiseks' },
          { label: 'Asutajad', percentage: '12%', amount: '2.520.000 CTC', desc: 'Järkjärguline tokeni vabastamine mitmetel projekti verstapostidel, välja arvatud operatiivjuhtimine' },
          { label: '2. Airdrop', percentage: '10%', amount: '2.100.000 CTC', desc: 'Arvutatud nutilepingu kaudu, tuginedes keskmisele tokeni hoidmisele teatud perioodidel' },
          { label: '3. Airdrop', percentage: '10%', amount: '2.100.000 CTC', desc: 'Arvutatud nutilepingu kaudu, tuginedes keskmisele tokeni hoidmisele teatud perioodidel' },
          { label: 'Likviidsusbassein Raydium DEX-is', percentage: '9%', amount: '1.890.000 CTC', desc: 'Raydiumis genereeritud tokenid põletatakse koheselt USDC väljavõtmise vältimiseks' },
          { label: '1. Airdrop', percentage: '4%', amount: '840.000 CTC', desc: 'Jaotatud interaktiivsete mehhanismide kaudu, mis põhinevad ChartTower ökosüsteemi ja krüptomaailma üldiste teadmiste põhjal' },
          { label: 'Eramüük', percentage: '2%', amount: '420.000 CTC', desc: 'Piiratud 20 000 tokeniga rahakoti kohta hinnaga 0,005 USDC/token (lõpetatud)' }
        ]
      },
      whitepaper: {
        titlePart1: 'VALGE',
        titlePart2: 'RAAMAT',
        description: 'ChartTower Corp.i valge raamat kirjeldab üksikasjalikult visiooni, tehnilist arhitektuuri, tokenoomikat ja projekti tegevuskava. Põhjalik dokument, mis illustreerib, kuidas CTC ökosüsteem integreerib traditsioonilise rahanduse, kinnisvara ja plokiahela, et luua jätkusuutlikku väärtust.',
        downloadBtn: 'Lae alla valge raamat (PDF)',
        cards: [
          { title: 'Visioon ja missioon', desc: 'ChartTower Corp.i eesmärk on luua integreeritud finantsökosüsteem, mis ühendab traditsioonilise rahanduse, kinnisvara ja plokiahela eelised. Meie missioon on demokratiseerida juurdepääs professionaalsetele finantsteenustele innovaatiliste tehnoloogiate ja täieliku läbipaistvuse kaudu.' },
          { title: 'Tehniline arhitektuur', desc: 'CTC token on ehitatud Solana plokiahelale, mis on valitud selle suure jõudluse, madalate tehingukulude ja skaleeritavuse tõttu. Infrastruktuur tagab turvalisuse, kiiruse ja globaalse juurdepääsetavuse kõigile ökosüsteemi kasutajatele.' },
          { title: 'Tokenoomika', desc: 'Tokeni jaotamine on kavandatud pikaajaliseks jätkusuutlikkuseks, utiliidi mehhanismidega, mis premeerivad hoidjaid ja toetavad ökosüsteemi kasvu cashbacki, halduse ja operatiivtegevuse tulude kaudu.' }
        ]
      },
      utility: {
        titlePart1: 'Utiliidi Tokeni',
        titlePart2: 'Mehhanismid',
        comingSoon: 'Tulekul',
        cards: [
          { title: 'Automaatne Cashback', desc: 'Peagi aktiivsed cashbacki mehhanismid: kui maksate ChartToweri ökosüsteemi teenuste eest fiat-valuutas, saate automaatselt tagasimakse CTC tokenites. Süsteem, mis premeerib lojaalsust ja motiveerib pidevat teenuse kasutamist.' },
          { title: 'Allahindlused CTC maksega', desc: 'Spetsiaalsed allahindlused, kui maksate CTC-s: kasutades CTC tokeneid Rahanduse ja investeeringute või Kinnisvara teenuste ostmiseks, saate eksklusiivseid allahindlusi ja eelistingimusi, mis on reserveeritud ainult hoidjatele.' }
        ]
      },
      compliance: {
        titlePart1: 'Regulatiivne',
        titlePart2: 'Vastavus',
        description: 'CTC Token väljastatakse täielikus vastavuses Euroopa määrustega. Valge raamat on teavitatud MiCA EL (Markets in Crypto-Assets) alusel, mis on uus EL-i krüptovarade regulatiivne raamistik, tagades maksimaalse läbipaistvuse, investorite kaitse ja vastavuse rahvusvahelistele standarditele.',
        checks: ['EL Määrus', 'Täielik läbipaistvus', 'Investorite kaitse']
      },
      metrics: {
        titlePart1: 'TOKENI',
        titlePart2: 'MÕÕDIKUD',
        items: [
          { value: 'SOLANA', label: 'PLOKIAHEL' },
          { value: 'LIVE', label: 'LIKVIIDSUSBASSEIN' },
          { value: '9', label: 'AMETLIKKU RAHAKOTTI' },
          { value: '24/7', label: 'TUGI' }
        ]
      }
    },
    corporateInfo: {
      hero: {
        titlePart1: 'ETTEVÕTTE',
        titlePart2: 'TEAVE',
        subtitle: 'Täielik läbipaistvus: kõik kontrollitavad ettevõtte andmed, ametlikud rahakotid ja ChartTower Corp.i juriidiline dokumentatsioon.',
      },
      about: {
        title: 'Kes me oleme ja meie lugu',
        readMore: 'Loe rohkem',
        readLess: 'Näita vähem',
        advantagesTitle: 'Eksklusiivsed eelised:',
        paragraphs: [
          'ChartTower Corp. sündis sõprade rühmast, keda ühendab sama ambitsioon: ehitada midagi kindlat, uuenduslikku ja kestvat. Teekond, mis algas uudishimust ja otsustavusest, mida ajendas soov mõista sügavalt turgude ja reaalmajanduse toimimist ning muuta teooria konkreetseks väärtuseks.',
          'See ei ole olnud sirgjooneline tee: tegime vigu, kogesime, õppisime raskel moel. Kuid just nende sammude kaudu arendasime välja mõtteviisi, mis põhineb pidevalt õppimisel, kriitilisel analüüsil ja pidevalt arengul. Just sellest vaimust sünnivad meie põhiväärtused: kvaliteet, usaldus ja eelkõige läbipaistvus.',
          'ChartTower Corp. põhineb selgel visioonil: ühendada erinevaid sektoreid ja muuta need üksteist täiendavaks, kasutades ka plokiahela tehnoloogiat. See visioon võtab konkreetse kuju CTC Tokeni emiteerimisega, mis on Solana võrgus välja töötatud utiliidi-token, mis on mõeldud meie ärijaotuste pakutavate teenuste orgaaniliseks integreerimiseks.',
          'Kahe jaotuse potentsiaali veelgi suurendamiseks uurime AI ja automatiseerimise eeliseid, et optimeerida protsesse eraisikutele ja ettevõtetele. Samad aruandlusvahendid meie pakutavate investeerimisinstrumentide jaoks, mis on juba reaalajas sellel veebisaidil kättesaadavad, automatiseeritakse ja need valmivad varsti.',
          'Tänu sellele modulaarsele ja integreeritud struktuurile suudab ChartTower Corp. suhelda igat tüüpi kliendiga, pakkudes kohandatud teenuseid. CTC Token esindab meie kogu ökosüsteemi punast niiti: need, kes seda hoiavad, saavad juurdepääsu eeliste tokeni hoidmisele ja eriteenustele meie jaotuste igal teenusel.'
        ],
        advantages: [
          'Kinnisvarajaotus eristub kindluse, struktuuri ja traditsioonilist majandusmaailma järgimise poolest.',
          'Rahandus- ja investeerimisjaotus kasutab meie turukogemust, pakkudes dünaamilisi ja kättesaadavaid lahendusi.'
        ]
      },
      team: {
        titlePart1: 'OPERATIIV',
        titlePart2: 'MEESKOND',
        description: 'ChartTower Corp.i meeskond koosneb asutajatest, kes juhivad ettevõtte strateegilisi divisjone, ühendades finantsteadmisi, kinnisvaravisioon ja tehnoloogilist pädevust.',
        members: [
          {
            name: 'Andrea Cascino',
            role: 'Asutaja',
            title: 'Rahandus- ja investeerimisdivisjoni tegevjuht',
            areas: ['AI ja automatiseerimine']
          },
          {
            name: 'Luca Marcialli',
            role: 'Asutaja',
            title: 'Kinnisvaradivisjoni tegevjuht',
            areas: ['Õigus ja vastavus']
          },
          {
            name: 'Thomas Tapella',
            role: 'Tehnoloogiajuht',
            title: 'IT-juht',
            areas: ['AI ja automatiseerimine']
          }
        ]
      },
      data: {
        titlePart1: 'ETTEVÕTTE',
        titlePart2: 'ANDMED',
        companyNameLabel: 'ETTEVÕTTE NIMI',
        companyNameValue: 'ChartTower Corp. OÜ',
        regNumberLabel: 'REGISTRIKOOD',
        regNumberValue: '17288413',
        leiCodeLabel: 'LEI KOOD',
        leiCodeValue: '9845001C375D5E411F72',
        emailLabel: 'E-POST',
        emailValue: 'info@ctc-corp.eu',
        addressLabel: 'JURIIDILINE AADRESS',
        addressValue: 'Ruunaoja 3, 11415 Tallinn, Estonia',
        addressSub: '(c/o Nomad Consulting OÜ)',
        docs: {
          title: 'Dokumendiarhiiv',
          whitepaper: 'Valge raamat',
          whitepaperSub: 'MICA Vastavus',
          registration: 'Registreerimistõend',
          registrationDate: '23/07/2025',
          registrationUrl: 'https://ctc-corp.eu/wp-content/uploads/2025/08/Iscrizione-registro-imprese-arakiri_A_50287702.pdf',
          statute: 'Põhikiri',
          statuteDate: '23/07/2025',
          statuteUrl: 'https://ctc-corp.eu/wp-content/uploads/2025/08/ChartTower_Corp._OU-pohikiri_3556957.pdf'
        }
      },
      wallets: {
        titlePart1: 'ETTEVÕTTE',
        titlePart2: 'RAHAKOTID',
        subtitle: '9 ametlikku ChartTower Corp.i rahakotti Solana võrgus. Kõik aadressid on plokiahelas avalikult kontrollitavad.',
        colDest: 'SIHTKOHT',
        colAddr: 'RAHAKOTI AADRESS',
        colAction: 'TEGEVUSED',
        copy: 'Kopeeri',
        solscan: 'Solscan',
        items: walletItemsEt
      },
      roadmap: {
        titlePart1: 'DÜNAAMILINE',
        titlePart2: 'TEGEVUSKAVA',
        subtitle: 'Dünaamiline tegevuskava juhendab samm-sammult läbi projekti oleviku ja tuleviku. Iga verstapost on jälgitav, et tagada läbipaistvus investoritele ja kogukonnale.',
        btnRealtime: 'Reaalajas verstapostid',
        btnHistory: 'Ajalooline versioon',
        notionLabel: 'Laiendatud tegevuskava Notionis',
        filters: {
          all: 'Kõik',
          completed: 'Tehtud',
          inprogress: 'Käimas',
          planned: 'Kavandatud',
        },
        items: [
          { title: 'Ettevõtte asutamine ja vastavus', status: 'completed', statusLabel: 'Tehtud', desc: 'ChartTower Corp. OÜ registreerimine Eestis ja LEI koodi hankimine.', date: 'Q3 2025', category: 'corporate' },
          { title: 'Valge raamatu avaldamine ja tokenoomika', status: 'completed', statusLabel: 'Tehtud', desc: 'Tehnilise dokumentatsiooni ja tokeni majandusstruktuuri avaldamine.', date: 'Q3 2025', category: 'token' },
          { title: 'Eramüük', status: 'completed', statusLabel: 'Tehtud', desc: 'Esialgne tokenite eraldamine strateegilistele investoritele.', date: 'Q4 2025', category: 'token' },
          { title: 'Likviidsusbasseini käivitamine (Raydium)', status: 'completed', statusLabel: 'Tehtud', desc: 'Ametlik noteerimine Solana DEX-is ja kohene LP tokeni põletamine.', date: 'Q4 2025', category: 'token' },
          { title: 'Blue Strike käivitamine', status: 'completed', statusLabel: 'Tehtud', desc: '24/7 ekspertnõustaja XAU/USD-l töökorras 6 sõltumatu strateegia ja libisemise optimeerijaga.', date: 'Q4 2025', category: 'finance' },
          { title: 'Nutilepingu audit', status: 'inprogress', statusLabel: 'Käimas', desc: 'Tokeni lepingu turvalisuse kontroll kolmandate osapoolte poolt.', date: 'Q1 2026', category: 'token' },
          { title: 'Finantsteenuste aktiveerimine', status: 'completed', statusLabel: 'Tehtud', desc: 'CTC Blue Strike, Algo Engine ja Copy Service aktiivsed ja töökorras.', date: 'Q1 2026', category: 'finance' },
          { title: 'Varajase kasutaja Airdrop kampaania', status: 'planned', statusLabel: 'Kavandatud', desc: 'Preemiate jagamine aktiivsele Telegrami kogukonnale.', date: 'Q2 2026', category: 'token' },
          { title: 'Kinnisvaravarade omandamine', status: 'planned', statusLabel: 'Kavandatud', desc: 'Esimene strateegiline kinnisvara osakonna ost Tallinnas.', date: 'Q2 2026', category: 'realEstate' },
          { title: 'CEX noteerimine (Tsentraliseeritud börs)', status: 'planned', statusLabel: 'Kavandatud', desc: 'Noteerimine tsentraliseeritud börsil likviidsuse suurendamiseks.', date: 'Q3 2026', category: 'token' },
          { title: 'Cashback ja utiliidi platvorm', status: 'planned', statusLabel: 'Kavandatud', desc: 'CTC maksete integreerimine teenustele ja automaatsed allahindlused.', date: 'Q4 2026', category: 'token' },
        ]
      },
      transparency: {
        title: 'Maksimaalne läbipaistvus',
        desc: 'ChartTower Corp. kohustub tagama oma tegevuses maksimaalse läbipaistvuse. Kõik ettevõtte rahakotid on Solana plokiahelas avalikult kontrollitavad.',
        stats: {
          verifiable: '100%',
          verifiableLabel: 'KONTROLLITAV',
          wallets: '9',
          walletsLabel: 'AMETLIKKU RAHAKOTTI',
          onchain: '24/7',
          onchainLabel: 'ON-CHAIN'
        }
      },
    },

    aiAutomation: {
      title: 'AI & Automaatika',
      subtitle: 'Tulevik on nüüd.',
      description: 'Arendame täiustatud AI ja automaatika lahendusi eraisikutele ja ettevõtetele. Optimeerige protsesse, vähendage kulusid ja suurendage tootlikkust ChartToweri tehnoloogiaga.',
      notifyBtn: 'Teavita mind käivitamisel',
      features: {
        title1: 'Veebirakendused & Intelligentsed Juhtpaneelid',
        desc1: 'AI-toega veebirakenduste ja interaktiivsete juhtpaneelide arendamine andmete ja ülevaadete reaalajas visualiseerimiseks.',
        title2: 'Chatbot & Vestlusabi',
        desc2: 'Intelligentsed virtuaalsed assistendid 24/7 klienditoeks, suhtluse automatiseerimiseks ja päringute haldamiseks.',
        title3: 'AI Agendid & Automatiseeritud Töövood',
        desc3: 'Intelligentsete agentide loomine ja automatiseeritud töövoogude haldamine äriprotsesside optimeerimiseks.',
      },
      skills: {
        sectionTitle: 'AI & Automaatika oskused',
        sectionSubtitle: 'Intelligentsed lahendused teie ettevõtte iga aspekti optimeerimiseks',
        skill1: 'AI agentide arendamine ja integreerimine',
        skill1Desc: 'Kohandatud intelligentsete agentide projekteerimine ja arendamine, integreeritavad teie ärisüsteemidesse. Otsuste automatiseerimine, loomuliku keele töötlemine ja API integratsioon täiustatud LLM-idega (GPT, Claude, Gemini).',
        skill2: 'Automatiseeritud töövoogude haldamine',
        skill2Desc: 'Keerukate automatiseeritud töövoogude loomine korduvate ülesannete vähendamiseks. Mitmeplatvormiline integratsioon (n8n, Make, Zapier) intelligentsete käivitajate, vigade haldamise ja ettevõtte skaleeritavusega.',
        skill3: 'Arvutinägemine ja andmeanalüüs',
        skill3Desc: 'Visuaalse analüüsi süsteemid objektide äratundmiseks, piltide klassifitseerimiseks, OCR-iks ja video analüüsiks. Rakendatud masinõpe mustrite äratundmiseks, anomaaliate tuvastamiseks ja ennustavaks analüüsiks.',
        skill4: 'Generatiivne AI sisu loomiseks',
        skill4Desc: 'Automatiseerimine tekstilise, visuaalse ja multimeedia sisu genereerimisel. AI-põhine sisu strateegia, automatiseeritud copywriting, piltide genereerimine ja dünaamiline personaliseerimine turunduskapääniate jaoks.',
        skill5: 'Veebirakenduste ja intelligentsete juhtpaneelide arendamine',
        skill5Desc: 'Kaasaegsed veebirakendused integreeritud AI-ga. Reaalajas juhtpaneelid ennustavate analüüsidega, vestlusliideste ja täiustatud andmete visualiseerimistega. Kaasaegne stack: React, Next.js, Node.js.',
        skill6: 'Chatbot ja vestlusabi',
        skill6Desc: 'Intelligentsed virtuaalsed assistendid klienditeeninduseks, tehniliseks toeks ja müügiks. Täiustatud NLP, mitmekeelne, CRM/andmebaasi integratsioon ja kohandatud koolitus ettevõtte teadmistebaasidel.',
        comingSoonLabel: 'Tulekul'
      }
    },
    algoDashboard: {
      backToFinance: 'Tagasi rahandusse',
      title: 'ALGO ENGINE 2.0',
      titleHighlight: 'JUHTPANEEL',
      subtitle: 'Algoritmilise tulemuslikkuse reaalajas jälgimine',
      filterAll: 'Kõik',
      filter3m: '3 kuud',
      filter1m: '1 kuu',
      kpi: {
        totalPips: 'Kokku Pipse',
        totalPipsLabel: 'KOKKU',
        winRate: 'Win Rate',
        winRateLabel: 'TÄPSUS',
        profitFactor: 'Kasumitegur',
        profitFactorLabel: 'SUHE',
        totalTrades: 'Kokku tehinguid',
        totalTradesLabel: 'OPERATSIOONID'
      },
      charts: {
        equityTitle: 'Omakapitali kasv (Pipsid)',
        assetDistTitle: 'Varade jaotus',
        monthlyPerfTitle: 'Igakuine tulemuslikkus',
        pipsLabel: 'Pipsid:',
        tradesLabel: 'Tehingud:',
        winRateLabel: 'Win Rate:'
      },
      table: {
        title: 'Viimased tehingud',
        dateCol: 'Kuupäev',
        assetCol: 'Vara',
        typeCol: 'Tüüp',
      }
    },
    footer: {
      tagline: 'Inspired by the fear of being average.',
      divisions: 'Osakonnad',
      resources: 'Ressursid',
      legal: 'Õiguslik ja kontaktid',
      items: {
        home: 'Avaleht',
        finance: 'Rahandus ja investeeringud',
        realEstate: 'Kinnisvara',
        token: 'CTC Token',
        roadmap: 'Dünaamiline tegevuskava',
        whitepaper: 'Valge raamat',
        community: 'Telegrami kogukond',
        liquidity: 'Likviidsusbassein',
        privacy: 'Privaatsuspoliitika',
        terms: 'Teenuse tingimused',
        cookie: 'Küpsiste poliitika',
        about: 'Meist'
      },
      address: 'ChartTower Corp. OÜ c/o Nomad Consulting OÜ; Ruunaoja 3, 11415 Tallinn, Estonia',
      copyright: '© 2025 ChartTower Corp. Kõik õigused kaitstud.',
      backToTop: 'Tagasi üles'
    },
    consultation: {
      title: 'Tasuta',
      titleHighlight: 'N\u00f5ustamine',
      subtitle: 'Pole kindel, milline teenus sulle sobib? R\u00e4\u00e4gi meile oma vajadustest ja me aitame leida just sulle sobiva lahenduse.',
      cta: 'Taotle tasuta n\u00f5ustamist',
      bullets: ['Ilma kohustuseta', 'Vastus 24 tunni jooksul', '100% isikup\u00e4rastatud'],
      services: {
        blueStrike: 'CTC Blue Strike',
        algoEngine: 'CTC Algo Engine',
        copyService: 'CTC Copy Service',
        realEstate: 'Kinnisvaraosakond',
        ai: 'AI \u0026 Automaatika',
        notSure: 'Pole veel kindel \u2014 aita mul valida'
      },
      modal: {
        title: 'Taotle tasuta n\u00f5ustamist',
        desc: 'T\u00e4ida vorm ja v\u00f5tame sinuga \u00fchendust, et leppida kokku n\u00f5ustamine sulle sobival ajal.',
        fields: {
          name: 'T\u00e4isnimi',
          telegram: 'Telegram',
          optional: 'Valikuline',
          service: 'Huvipakkuv teenus',
          servicePlaceholder: '\u2014 Vali teenus \u2014',
          needs: 'Sinu vajadused',
          needsPlaceholder: 'Kirjelda l\u00fchidalt oma olukorda ja mida otsid...'
        },
        submit: 'Saada taotlus',
        successTitle: 'Taotlus saadetud!',
        successDesc: 'Vastame 24 tunni jooksul. Kontrolli oma e-posti.'
      }
    },
    linktree: {
      subtitle: 'Rahandus, Blockchain, Kinnisvara. Kõik ühes ökosüsteemis.',
      officialChannels: 'Ametlikud kanalid',
      corporateGroup: 'Ettevõtte grupp',
      corporateGroupDesc: 'Reserveeritud juurdepääs kinnitamisel',
      website: 'Ametlik veebisait',
      websiteDesc: 'Uuri täielikku ökosüsteemi',
      tokenChannel: 'CTC Token kanal',
      tokenChannelDesc: 'Tokeni uudised ja uuendused',
      twitter: 'Twitter / X',
      twitterDesc: 'Jälgi meid viimaste uudiste saamiseks',
      instagram: 'Instagram',
      instagramDesc: 'Eksklusiivsed sisu ja ülevaated',
      rightsReserved: 'Kõik õigused kaitstud.'
    },
    privacyPolicy: {
      subtitle: 'Teie privaatsus on meile oluline. Selgitame, kuidas me teie andmeid käsitleme vastavalt GDPR-ile ja Euroopa isikuandmete kaitse eeskirjadele.',
      lastUpdated: 'Viimati uuendatud:',
      lastUpdatedDate: '20. jaanuar 2026',
      s1: {
        title: '1. Vastutav töötleja',
        desc: 'Isikuandmete vastutav töötleja on:',
        company: 'Ärinimi',
        address: 'Registriaadress',
        regNum: 'Registreerimisnumber',
      },
      s2: {
        title: '2. Andmekaitseametnik (DPO)',
        desc: 'Oleme määranud andmekaitseametniku (DPO), kellega saate võtta ühendust kõikides teie isikuandmete töötlemisega seotud küsimustes:',
        dpo: 'DPO',
      },
      s3: {
        title: '3. Kogutavate andmete liigid',
        intro: 'Meie saidil navigeerimise ajal kogume järgmisi andmekategooriaid:',
        navTitle: '3.1 Navigeerimisandmed',
        navDesc: 'Saidi tööd tagavad arvutisüsteemid koguvad normaalse töö käigus automaatselt teatud andmeid, mille edastamine on tingitud Interneti sideprotokollide kasutamisest:',
        navItems: ['IP-aadressid', 'Brauseri tüüp ja operatsioonisüsteem', 'Päringute kuupäev ja kellaaeg', 'Külastatud lehed'],
        chatTitle: '3.2 Vestlusroboti andmed',
        chatDesc: 'Meie virtuaalassistent (ChartTower BOT AI) kogub:',
        chatItems: ['Kasutaja saadetud sõnumid', 'Seansi ID (genereeritud automaatselt ja salvestatud lokaalselt)', 'Vestluste ajatemplid'],
        chatWarning: 'Oluline teade:',
        chatWarningDesc: 'Soovitame teil vestlusrobotiga vesteldes MITTE jagada tundlikke isikuandmeid.',
        cookiesTitle: '3.3 Küpsise-eelistused',
        cookiesDesc: 'Salvestame teie küpsise-eelistused (vt',
      },
      s4: {
        title: '4. Töötlemise eesmärgid ja õiguslik alus',
        intro: 'Teie isikuandmeid töödeldakse järgmistel eesmärkidel:',
        p1Title: 'Veebisaidi toimimine',
        p1Desc: 'Õige navigeerimise ja sisu kättesaadavuse tagamine.',
        p1Legal: 'Õiguslik alus: Õigustatud huvi (GDPR art. 6.1.f)',
        p2Title: 'Vestlusroboti tugi',
        p2Desc: 'Virtuaalassistendi kaudu meie teenuste kohta toe ja teabe pakkumine.',
        p2Legal: 'Õiguslik alus: Kaudne nõusolek kasutamiseks (GDPR art. 6.1.a)',
        p3Title: 'Vestlusroboti teenuse täiustamine',
        p3Desc: 'Vestlusloge kasutatakse ainult roboti enesepuhenduseks ja vastuste kvaliteedi parandamiseks.',
        p3Legal: 'Õiguslik alus: Õigustatud huvi (GDPR art. 6.1.f)',
        p4Title: 'Seaduslike kohustuste täitmine',
        p4Desc: 'Seaduste, määruste või Euroopa normatiivide kohustuste täitmine.',
        p4Legal: 'Õiguslik alus: Juriidiline kohustus (GDPR art. 6.1.c)',
      },
      s5: {
        title: '5. Saajad ja volitatud töötlejad',
        intro: 'Teie andmeid võidakse edastada:',
        h1Title: 'Hostiteenuse pakkuja',
        h1Desc: 'Cloudflare Inc. - Veebisaidi hostimine ja levitamine (Cloudflare Pages)',
        h1Note: 'Asukoht: USA - Andmeedastust reguleerivad standardsed lepingutingimused (SCC) ja andmetöötluslepingud',
        h2Title: 'Vestlusroboti teenus',
        h2Desc: 'Vestlusroboti vestlusandmeid töödeldakse serverites aadressil app.thomastapella.it vastuste haldamiseks ja AI-süsteemi enesepuhenduseks.',
        noteLabel: 'Oluline märkus:',
        note: 'Me EI müü, renti ega jaga teie isikuandmeid kolmandatele osapooltele turunduslikel eesmärkidel. Me ei kasuta jälgimisküpsiseid ega kolmandate osapoolte analüütikat.',
      },
      s6: {
        title: '6. Andmete säilitamisperiood',
        intro: 'Isikuandmeid säilitatakse rangelt vajaliku aja jooksul, et saavutada nende kogumise eesmärgid:',
        i1Label: 'Navigeerimisandmed:',
        i1Desc: 'Kustutatud 7 päeva jooksul pärast kogumist',
        i2Label: 'Vestlusroboti logid:',
        i2Desc: 'Kasutatakse AI-õppeks, seejärel anonümiseeritakse',
        i3Label: 'Küpsise-eelistused:',
        i3Desc: '12 kuud valikust alates',
      },
      s7: {
        title: '7. Teie õigused (GDPR art. 15-22)',
        intro: 'Andmesubjektina on teil õigus:',
        r1Label: 'Juurdepääs',
        r1Desc: 'Saada kinnitust töötlemise olemasolu kohta ja pääseda juurde oma andmetele',
        r2Label: 'Parandamine',
        r2Desc: 'Taotleda ebatäpsete või mittetäielike andmete parandamist',
        r3Label: 'Kustutamine',
        r3Desc: 'Taotleda andmete kustutamist ("Õigus olla unustatud")',
        r4Label: 'Töötlemise piiramine',
        r4Desc: 'Taotleda töötlemise piiramist',
        r5Label: 'Andmete ülekantavus',
        r5Desc: 'Saada andmed struktureeritud, masinloetavas vormingus',
        r6Label: 'Vastuväide',
        r6Desc: 'Esitada töötlemisele vastuväide igal ajal',
        r7Label: 'Nõusoleku tagasivõtmine',
        r7Desc: 'Võtta tagasi varem antud nõusolek',
        exercise: 'Oma õiguste kasutamiseks:',
        complaint: 'Kaebuse esitamise õigus:',
        complaintBody: 'Teil on õigus esitada kaebus pädevale järelevalveasutusele:',
        complaintAuthority: 'Andmekaitse Inspektsioon (Eesti andmekaitseasutus)',
      },
      s8: {
        title: '8. Andmeturve',
        intro: 'Kasutame asjakohaseid tehnilisi ja organisatsioonilisi meetmeid teie isikuandmete kaitsmiseks:',
        items: [
          'HTTPS-krüpteerimine kõigi kommunikatsioonide jaoks',
          'Piiratud juurdepääs isikuandmetele ainult volitatud töötajatele',
          'Hostimine turvalises ja sertifitseeritud infrastruktuuris',
          'Makseteabe ei koguta saidil',
        ],
      },
      s9: {
        title: '9. Privaatsuspoliitika muudatused',
        desc: 'Seda privaatsuspoliitikat võidakse perioodiliselt uuendada. Oluliste muudatuste korral avaldame saidil hästi nähtava teate. Kutsume teid seda lehte regulaarselt kontrollima, et olla kursis, kuidas me teie andmeid kaitseme.',
      },
      contact: {
        title: 'Kontakt',
        desc: 'Kõigi küsimuste korral seoses käesoleva privaatsuspoliitika või teie isikuandmete töötlemisega:',
        email: 'E-post',
        dpo: 'DPO',
        address: 'Aadress',
      },
    },
    termsOfService: {
      title: 'Teenuse tingimused',
      subtitle: 'Juriidilised tingimused, mis reguleerivad ChartTower Corp. OÜ pakutavate teenuste kasutamist.',
      backToHome: 'Tagasi avalehele',
      lastUpdated: 'Viimati uuendatud:',
      lastUpdatedDate: '28. veebruar 2026',
      s1: {
        title: '1. Tingimuste aktsepteerimine',
        p: 'Veebisaidile sisenedes nõustub Kasutaja tingimusteta käesolevate Teenuse tingimustega. Kui Kasutaja ei nõustu nende tingimustega, palutakse tal viivitamatult lõpetada veebisaidi ja ChartTower Corp. OÜ pakutavate Teenuste kasutamine.',
      },
      s2: {
        title: '2. Rahandus- ja investeerimisosakond: ajalooliste andmete ja tarkvara pakkuja',
        p: 'Kasutaja tunnistab ja nõustub, et ChartTower Corp. OÜ ei ole sertifitseeritud finantsteenuste pakkuja vastavalt kohaldatavatele valdkonnaeeskirjadele ning tegutseb eranditult tehnoloogia ja andmeanalüüsi pakkujana. Allpool kirjeldatud erinevad Teenused koosnevad turuanalüüsist, algoritmsetest signaalidest ja ajaloolistest andmetest. Ühtegi ChartTower Corp. pakutavat sisu ei tohiks tõlgendada personaalse "investeerimisnõustamisena" (MiFID II direktiivi või samaväärsete eeskirjade tähenduses).',
        warningTitle: 'CFD-DE, FOREXI JA KRÜPTOVALUUTADEGA KAUPLEMINE SISALDAB KÕRGET RISKI JA VÕIB PÕHJUSTADA KOGU INVESTEERITUD KAPITALI KAOTAMISE. Kasutaja kinnitab, et on teadlik järgmisest:',
        w1: 'Ajaloolised tulemused (Backtestid), mis on näidatud erinevates juhtpaneelides ja teenusearuannetes, on hüpoteetilised ega garanteeri tulevasi tulemusi.',
        w2: 'Finantsvõimenduse kasutamine suurendab nii kasumit kui kahjumit.',
        w3: 'Kasutaja peaks investeerima ainult kapitali, mida ta saab endale lubada kaotada ("riskikapital").',
      },
      s3: {
        title: '3. CTC Blue Strike',
        h1: 'Tarkvara, mitte varahaldus',
        h1p: 'ChartTower Corp. pakub tarkvara, mis töötleb turuandmeid ja töötab kohandatavate parameetritega, lähtudes mitme aasta ajaloolistel perioodidel teostatud backtestidest. Kasutaja säilitab täieliku kontrolli konfiguratsiooni üle ja seega lõpliku vastutuse oma investeerimisotsuste eest. ChartTower Corp. ei tegutse varahaldurina ega oma otsest juurdepääsu Kasutaja vahenditele.',
        h2: 'VPS',
        h2p: 'CTC Blue Strike vajab installimist ja konfigureerimist VPS-il sobivate spetsifikatsioonidega kliendi kulul, kui pole teisiti kokku lepitud.',
        h3: 'Backtestid ja vastutuse välistamine',
        h3p1: 'Kasutajatele tehakse kättesaadavaks ajaloolistel mitme aasta perioodidel teostatud backtestide tulemused, et näidata potentsiaalset tulemuslikkust, kuid see ei kujuta mingil viisil garantiid tulevaste tootluste kohta.',
        h3p2: 'ChartTower Corp. ei vastuta Kliendi ega kolmandate isikute ees rahaliste kahjude, saamata jäänud kasumi, kaotatud võimaluste ega muude kaudsete, põhjuslike või eriliste kahjude eest, mis tulenevad CTC Blue Strike tarkvara kasutamisest (või mittekasutamisest, või kasutamisest, mis ei vasta antud juhistele ja seadistustele/parameetritele).',
        h3p3: '"Mittevastava kasutuse" näited, mis võivad põhjustada vahendite kaotamise: VPS-i ühenduse käsitsi ja äkiline katkestamine; eelseadistatud seadistuste käsitsi muutmine; orderite käsitsi avamine või sulgemine; tarkvara mis tahes eesmärgil rikkumiskatsed.',
        h4: 'Autoriõigus',
        h4p: 'CTC Blue Strike on autoriõigusega kaitstud tarkvara. Iga volitamata koopia-, muutmis-, rikkumis- või edasimüügikatse kohta esitatakse kõik asjakohased tsiviil- ja/või kriminaalõiguslikud hagid.',
      },
      s4: {
        title: '4. CTC Algo Engine 2.0',
        h1: 'Signaalikanal ja informatiivne olemus',
        h1p: 'Teenus seisneb teabevoogude pakkumises, mille genereerib patenteeritud algoritm, mis põhineb täiustatud tehnilise analüüsi loogikatel. Seda teavet levitatakse struktureeritud "hariduslike signaalide" kujul, mis sisaldavad selliseid parameetreid nagu sisestuspunkt, stopp-kahjum ja mitu kasumivõtmise taset.',
        h2: 'Käsitsi täitmine ja ootel orderid',
        h2p: "Teenuse soovitatud operatiivne lähenemisviis põhineb peamiselt ootel orderite kasutamisel. Kasutaja tunnistab, et see operatiivne režiim eeldab tingimata käsitsi parameetrite sisestamist oma kauplemisplatvormil. Teenus piirdub hinnatasemete pakkumisega; kasutajal on täielik ja ainuõiguslik otsustusõigus otsustada, kas, millal ja kuidas neid ordereeid täita, säilitades täieliku kontrolli oma kapitali üle. ChartTower Corp. algoritmi ja Kasutaja kauplemiskonto vahel puudub automaatne ühendus.",
        h3: 'Kolmandad osapooled (tarneplatvorm)',
        h3p: 'Signaale levitatakse kolmandate osapoolte sõnumsidede platvormide (Telegram) kaudu. ChartTower Corp. ei vastuta teavituste vastuvõtmise viivituste, sõnumsideserverite tõrgete ega orderite täitmata jätmise eest, mis on tingitud Kasutaja platvormi või kasutatava Maakleri tehnilistest probleemidest.',
        h4: 'Backtestid ja vastutuse välistamine',
        h4p1: 'Kasutajatele esitatakse ajaloolistel mitme aasta perioodidel teostatud simulatsioonide tulemused, et näidata potentsiaalset tulemuslikkust, kuid see ei kujuta mingil viisil garantiid tulevaste tootluste kohta.',
        h4p2: 'ChartTower Corp. ei vastuta Kliendi ega kolmandate isikute ees rahaliste kahjude, saamata jäänud kasumi, kaotatud võimaluste ega muude kaudsete, põhjuslike või eriliste kahjude eest, mis tulenevad CTC Algo Engine 2.0 Teenuse genereeritud signaalide kasutamisest.',
      },
      s5: {
        title: '5. CTC Copy Service',
        h1: 'Teenuse olemus, tehnoloogiline infrastruktuur ja platvorminõue',
        h1p1: 'Kasutaja tunnistab, et Teenuse olemus on piiratud andmete ja telemaatiliste impulsside (signaalid, mis on ekstraheeritud ChartTower Corp. patenteeritud Masteri kontolt) pakkumisega. Kogu tehnoloogiline täitmisinfrastruktuur, orderite sobitamine ja vahendite hoidmine on eranditult kolmandate osapoolte (Maakler) omandis ja nende vastutuse all.',
        h1p2: 'Kuna Mastri strateegia toimib FPG maakleri serverites, on ühenduse lubamiseks hädavajalik, et kasutajal oleks aktiivne konto sama vahendajaga. Teenus ei ole tehniliselt toetatud ega aktiveeritav kolmandate osapoolte platvormidel ega maakleritel.',
        h2: 'Vastutuse välistamine',
        h2p: 'ChartTower Corp. ei vastuta Kliendi ega kolmandate isikute ees rahaliste kahjude, saamata jäänud kasumi, kaotatud võimaluste ega muude kaudsete, põhjuslike või eriliste kahjude eest, mis tulenevad CTC Copy Service Mastri kontode tehingute automaatse replikatsiooni kasutamisest.',
      },
      s6: {
        title: '6. AI & Automaatika osakond: kohandamine ja kohandatud teenused',
        p: 'AI & Automaatika osakond pakub kohandatud elektroonilisi teenuseid veebisaitide arendamiseks, veebirakenduste loomiseks, töövoogude automatiseerimiseks ja küberturvalisuseks. Arvestades teenuse kõrgelt kohandatud olemust, määratletakse iga projekti tehnilised spetsifikatsioonid, tarneajad, kulud ja täpsed funktsioonid igal juhul eraldi poolte vahel allkirjastatud Äriettepanekus. Üldiste Tingimuste ja konkreetse lepingu vahelise konflikti korral prevaleerib viimane.',
        h1: 'Kolmandate osapoolte sõltuvused (API-d) ja hooldus',
        h1p: 'Kasutaja tunnistab, et automatiseerimine võib sõltuda kolmandate osapoolte teenustest, API-dest või platvormidest (nt OpenAI, Telegram, Google, n8n). ChartTower Corp. ei vastuta katkestuste, tõrgete ega selliste kolmandate osapoolte ühepoolsete muudatuste eest, mis võivad ohustada tarnitud toote funktsionaalsust. Kui kirjalikult pole teisiti kokku lepitud (nt hoolduslepingutasu), loetakse teenus lõppenuks tarnimise ja testimise hetkel. Hilisemad uuendused, mis on nõutavad väliste muudatuste tõttu, võivad olla uue hinnapakkumise teema.',
        h2: 'Intellektuaalomand (kasutuslitsents)',
        h2p: 'Kui kirjalikult pole teisiti kokku lepitud, säilitab ChartTower Corp. täieliku intellektuaalomandi (autoriõiguse) arendatud lähtekoodi, teekide ja meetodite üle. Kliendile antakse alaline, mitte-erandilik, mitteülekantav Kasutuslitsents tarkvara kasutamiseks oma organisatsiooni piires. Kliendil on keelatud tarkvara lähtekoodi kolmandatele isikutele kasumlikul eesmärgil edasi müüa, allitsentsida ega levitada, välja arvatud juhul, kui poolte vahel on kirjalikult teisiti kokku lepitud.',
      },
      s7: {
        title: '7. Kinnisvaraosakond: arendusjärgus osakond',
        p: 'Kasutaja märgib, et Kinnisvaraosakond ja saidil kirjeldatud seotud sisu on praegu arendus- ja esialgses struktureerimisfaasis. Mis tahes teabematerjal, graafilised renderdused, tegevuskavad või majandusprojektsioonid selles jaotises on illustratiivse iseloomuga ega kujuta mingil viisil endast avalikku säästude või finantsinstrumentide pakkumist ega kinnisvara investeeringute kutset.',
        h1: 'Tulevased tingimused',
        h1p: 'Kinnisvaraosakonna juriidilised tingimused, juurdepääsunõuded ja konkreetsed tegevuskord reguleeritakse hiljem avaldatavate Teenuse tingimustega. ChartTower Corp. jätab endale õiguse reorganiseerida selle osakonna arengut ilma eelneva teateta ja ilma et see tooks kaasa mingit vastutust Kasutaja ees.',
        h2: 'Huvi avaldused ja pilootprogrammid',
        h2p: 'Vaatamata osakonna arengufaasile on ChartTower Corp. valmis hindama Kasutaja konkreetse ja spontaanse taotluse korral (pöördsoovitus) võimalust osutada esialgset nõustamisteenust või varajast juurdepääsu pilootprojektidele. Huvilised kasutajad saavad ettevõttega uuriva hinnangu jaoks ühendust võtta. Sellised arutelud on puhtalt informatiivsed, ilma poolte jaoks siduva kohustuseta, ega kujuta teenuse osutamise garantiid. Selliste kontaktidest tulenevad kokkulepped vormistatakse eraldi, konkreetse juhtumi vajadustele kohandatud era-eralepingutena.',
      },
    },
    cookiePolicy: {
      title: 'Küpsiste poliitika',
      subtitle: 'Täielik läbipaistvus selle kohta, kuidas me küpsiseid kasutame. Teie privaatsus on meie prioriteet.',
      lastUpdated: 'Viimati uuendatud:',
      lastUpdatedDate: '20. jaanuar 2026',
      importantTitle: 'Teie privaatsus on oluline',
      importantP: 'ChartTower Corp. EI kasuta jälgimisküpsiseid, kolmandate osapoolte analüütikat ega turundusküpsiseid. Kasutame eranditult rangelt vajalikke tehnilisi küpsiseid saidi toimimiseks.',
      whatTitle: 'Mis on küpsised?',
      whatP1: 'Küpsised on väikesed tekstifailid, mida veebisaidid salvestavad kasutaja seadmesse (arvuti, nutitelefon, tahvelarvuti) sirvimisel. Neid kasutatakse teabe ja eelistuste salvestamiseks, parandades sirvimiskogemust.',
      whatP2: 'See küpsiste poliitika on koostatud vastavalt määrusele (EL) 2016/679 (GDPR) ja direktiivile 2002/58/EÜ (ePrivacy), nagu seda on üle võetud kohaldatavate riiklike eeskirjadega.',
      techTitle: 'Tehnilised küpsised (vajalikud)',
      techAlways: 'Alati aktiivne',
      techDesc: 'Need küpsised on veebisaidi toimimiseks hädavajalikud ja neid ei saa keelata. Need määratakse vastuseks teie toimingutele, näiteks privaatsuse-eelistuste haldamisel. Need ei nõua kasutaja nõusolekut privaatsusseaduse art. 122 kohaselt.',
      tableCol1: 'Küpsis',
      tableCol2: 'Domeen',
      tableCol3: 'Kestus',
      tableCol4: 'Eesmärk',
      row1Duration: '12 kuud',
      row1Purpose: 'Salvestab kasutaja küpsiste eelistused',
      row2Duration: 'Püsiv',
      row2Purpose: 'Vestlusroboti seansi identifikaator vestluse järjepidevuse tagamiseks',
      analyticsTitle: 'Analüütika küpsised',
      notUsed: 'Ei kasutata',
      analyticsDesc: 'ChartTower Corp. ei kasuta Google Analyticsi, Facebook Pixelit ega muid jälgimisvahendeid. Austame teie privaatsust ja ei jälgi teie sirvimiskäitumist.',
      marketingTitle: 'Turundus- ja profiilimisküpsised',
      marketingDesc: 'Me ei kasuta reklaamimis-, remarketing- ega kasutajate profiilimisküpsiseid. Me ei müü ega jaga teie andmeid reklaamivõrkudega.',
      thirdPartyTitle: 'Kolmandate osapoolte küpsised',
      thirdPartyP: 'Meie sait võib sisaldada manustatud sisu (nt videod, kaardid) välistest teenustest. Need teenused võivad seada oma küpsiseid.',
      prefsTitle: 'Eelistuste haldamine',
      prefsP: 'Saate oma küpsiste eelistusi igal ajal muuta:',
      resetTitle: 'Lähtesta küpsiste eelistused',
      resetDesc: 'Klõpsake alloleval nupul, et kustutada oma salvestatud eelistused. Nõusoleku bänner ilmub teie järgmisel visiidil uuesti.',
      resetBtn: 'Lähtesta küpsiste eelistused',
      browserTitle: 'Brauseri seaded',
      browserDesc: 'Saate küpsiseid hallata ka otse brauseri seadetes:',
      controllerTitle: 'Vastutav töötleja',
      controllerCompany: 'Ärinimi',
      controllerAddress: 'Registriaadress',
      controllerDPO: 'DPO',
      moreInfoTitle: 'Täiendav teave',
      moreInfoP: 'Täieliku teabe saamiseks oma isikuandmete töötlemise kohta vaadake meie privaatsuspoliitikat.',
      moreInfoBtn: 'Mine privaatsuspoliitikale',
    },
  }
};

